var filterLastFocus = null;
/* Sign Portal theme behaviour — ported from the React mockup's interactive bits.
   Plain, dependency-free JS. Covers:
   - desktop mega-menu hover/focus open
   - mobile drawer open/close + accordion
   - rotating search placeholder + live suggestion dropdown (Sign Portal search API
     with a silent fallback to Shopify predictive search)
   - click-to-play video embeds
   - live cart count (refreshes from /cart.js on load + after AJAX add events) */
(function () {
  "use strict";

  /* ---------- Image right-click / drag-to-save deterrent ----------
     Soft deterrent only (determined users can bypass via DevTools). Delegated
     listeners so AJAX-injected and lazy-loaded images are covered without
     per-element handlers. Only suppresses the default when the event target is
     an image (IMG/SVG, inside <picture>, or an element with a CSS background
     image) — right-click on text, links and form fields keeps working. */
  function spIsImageTarget(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag === "IMG" || tag === "PICTURE" || tag === "SVG" || el.closest && el.closest("img, picture, svg")) return true;
    // Elements styled with a background image (hero banners etc.) — but only
    // when the element itself is essentially just the image (no interactive
    // content under the pointer), so links/buttons over banners stay normal.
    if (tag === "A" || tag === "BUTTON" || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || tag === "LABEL") return false;
    try {
      var bg = window.getComputedStyle(el).backgroundImage;
      return !!bg && bg !== "none" && bg.indexOf("url(") !== -1;
    } catch (e) { return false; }
  }
  document.addEventListener("contextmenu", function (e) {
    if (spIsImageTarget(e.target)) e.preventDefault();
  });
  document.addEventListener("dragstart", function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && (t.tagName === "IMG" || (t.closest && t.closest("picture, svg")))) e.preventDefault();
  });

  /* ---------- "Help me choose" smooth-scroll to the material comparison table ---------- */
  document.addEventListener("click", function (e) {
    var link = e.target.closest ? e.target.closest("[data-sp-scroll]") : null;
    if (!link) return;
    var hash = (link.getAttribute("href") || "").replace(/^.*#/, "");
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  });

  /* ---------- Shared add-to-cart button state (icon: cart → spinner → check) ---------- */
  var SP_SPINNER_SVG = '<svg width="100%" height="100%" class="animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" stroke-opacity="0.25"></circle><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path></svg>';
  var SP_CHECK_SVG = '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';
  function spCartBtn(btn, state) {
    if (!btn) return;
    var icon = btn.querySelector("[data-sp-cart-icon]");
    var label = btn.querySelector("[data-sp-cart-label]");
    if (state === "loading") {
      if (icon) { if (icon.getAttribute("data-sp-orig") === null) icon.setAttribute("data-sp-orig", icon.innerHTML); icon.innerHTML = SP_SPINNER_SVG; }
      if (label) label.textContent = "Adding";
      btn.disabled = true;
    } else if (state === "done") {
      if (icon) icon.innerHTML = SP_CHECK_SVG;
      if (label) label.textContent = "Added";
    } else {
      if (icon && icon.getAttribute("data-sp-orig") !== null) icon.innerHTML = icon.getAttribute("data-sp-orig");
      if (label) label.textContent = "Add to cart";
      btn.disabled = false;
    }
  }

  /* ---------- Shared calculator price panel (big per-piece, SAVE pill, qty-discount table) ----------
     Populates the generic markup rendered by snippets/calc-discount-panel.liquid.
     All prices are GST-INCLUSIVE dollars. For matrix calculators the tier rows
     come from the backend (final marked-up figures only); for the self-hosted
     calculators they are built locally from each formula's own per-piece function. */
  function spMoney(n) {
    return "$" + Number(n).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function spMoney0(n) {
    return "$" + Math.round(Number(n)).toLocaleString("en-AU");
  }
  // Headline price: whole-dollar amounts drop the ".00" (per the approved design), otherwise show cents.
  function spMoneyLead(n) {
    n = Number(n);
    return Math.abs(n - Math.round(n)) < 0.005 ? spMoney0(n) : spMoney(n);
  }
  // Panel prices are DISPLAYED ex GST (per unit, tiers, savings); only each
  // calculator's Total row is GST-inclusive. Callers keep passing GST-incl
  // values (AU GST is a flat 10%), and the panel divides for display only.
  function spExGst(n, root) {
    // Only native-variant panels follow the shop tax basis. Formula calculators
    // continue passing inclusive prices under their existing backend contract.
    if (root && root.hasAttribute("data-sp-vtiers")) {
      var included = root.getAttribute("data-sp-taxes-included") === "true";
      var taxable = root.getAttribute("data-sp-native-taxable") !== "false";
      return window.SignPortalNativeTax.breakdown(Number(n) * 100, included, taxable).subtotal / 100;
    }
    return Number(n) / 1.1;
  }

  // Big per-piece price + struck qty-1 base + green SAVE pill (pill only when qty>1 and cheaper).
  // Move the existing live price beside Quantity on phones. Keep one price
  // node (and its existing pricing hooks), restoring its exact desktop slot.
  function spPositionMobileUnitPrice(root) {
    if (root.__spMobileUnitPrice) return;
    var panel = root.querySelector("[data-sp-panel]");
    var price = panel && panel.querySelector("[data-sp-pp]");
    var plus = root.querySelector('button[aria-label="Increase quantity"]');
    if (!price || !plus || !window.matchMedia) return;
    var lead = panel.firstElementChild;
    if (!lead || !lead.contains(price)) return;
    var stepper = plus.parentElement;
    var field = stepper.parentElement;
    var slot = document.createComment("unit-price-desktop-slot");
    panel.insertBefore(slot, lead);
    var row = document.createElement("div");
    row.className = "sp-mobile-quantity-row";
    field.classList.add("sp-mobile-quantity-field");
    lead.classList.add("sp-mobile-unit-price");
    var media = window.matchMedia("(max-width: 767px)");
    function place() {
      if (media.matches) {
        if (!row.parentElement) {
          field.insertBefore(row, stepper);
          row.appendChild(stepper);
        }
        row.appendChild(lead);
      } else {
        slot.parentNode.insertBefore(lead, slot.nextSibling);
        if (row.parentElement) {
          field.insertBefore(stepper, row);
          row.remove();
        }
      }
    }
    root.__spMobileUnitPrice = true;
    if (media.addEventListener) media.addEventListener("change", place);
    else media.addListener(place);
    place();
  }

  function spRenderLead(root, perPiece, basePerPiece, qty) {
    spPositionMobileUnitPrice(root);
    var ppEl = root.querySelector("[data-sp-pp]");
    var baseEl = root.querySelector("[data-sp-pp-base]");
    var saveEl = root.querySelector("[data-sp-save]");
    if (ppEl) ppEl.textContent = spMoneyLead(spExGst(perPiece, root));
    var saving = (Number(basePerPiece) - Number(perPiece)) * qty;
    var show = qty > 1 && Number(basePerPiece) > Number(perPiece) + 0.005 && saving >= 1;
    if (baseEl) {
      if (show) { baseEl.textContent = spMoney(spExGst(basePerPiece, root)); baseEl.classList.remove("hidden"); }
      else { baseEl.textContent = ""; baseEl.classList.add("hidden"); }
    }
    if (saveEl) {
      if (show) { saveEl.textContent = "SAVE " + spMoney(spExGst(saving, root)); saveEl.classList.remove("hidden"); }
      else { saveEl.textContent = ""; saveEl.classList.add("hidden"); }
    }
  }

  // Reset the lead + hide the table (error / invalid state).
  function spClearLead(root) {
    spPositionMobileUnitPrice(root);
    var ppEl = root.querySelector("[data-sp-pp]");
    if (ppEl) ppEl.textContent = "—";
    var baseEl = root.querySelector("[data-sp-pp-base]");
    if (baseEl) { baseEl.textContent = ""; baseEl.classList.add("hidden"); }
    var saveEl = root.querySelector("[data-sp-save]");
    if (saveEl) { saveEl.textContent = ""; saveEl.classList.add("hidden"); }
    spRenderTiers(root, [], 0, 0);
  }

  // Wire a reusable "Unique Designs" stepper (see snippet calc-designs-stepper).
  // attr is the data-attribute base (e.g. "sp-stickers-designs"); onChange runs
  // after every clamp. Clamps to an integer 1..100. Returns the input element
  // (or null if the stepper isn't present).
  function spWireDesignsStepper(root, attr, onChange) {
    var input = root.querySelector("[data-" + attr + "]");
    if (!input) return null;
    var minus = root.querySelector("[data-" + attr + "-minus]");
    var plus = root.querySelector("[data-" + attr + "-plus]");
    function val() { var n = parseInt(input.value, 10); return isNaN(n) ? 1 : n; }
    function clamp() {
      var n = val();
      if (n < 1) n = 1;
      if (n > 100) n = 100;
      if (String(n) !== input.value) input.value = n;
      return n;
    }
    if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, val() - 1); clamp(); if (onChange) onChange(); });
    if (plus) plus.addEventListener("click", function () { input.value = Math.min(100, val() + 1); clamp(); if (onChange) onChange(); });
    input.addEventListener("input", function () { if (onChange) onChange(); });
    input.addEventListener("blur", function () { clamp(); if (onChange) onChange(); });
    return input;
  }

  // rows: [{ qtyMin, qtyMax(nullable), qtyLabel, perPiece }]. Highlights the row
  // containing currentQty. Hides the table when there are fewer than 2 tiers.
  // Saving % label: whole number normally; above 99% show up to 2 decimals and
  // cap at 99.99 so a near-total discount can never display as "100%".
  function spSavePctLabel(p) {
    var pct = p * 100;
    if (pct <= 99) return String(Math.round(pct));
    var s = Math.min(pct, 99.99).toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
    return parseFloat(s) >= 100 ? "99.99" : s;
  }

  // discountOffsetPp (optional): subtract this many percentage points from the
  // displayed "% saved" label (does not change the per-piece prices shown).
  function spRenderTiers(root, rows, currentQty, basePerPiece, discountOffsetPp) {
    var wrap = root.querySelector("[data-sp-tiers-wrap]");
    var tbody = root.querySelector("[data-sp-tiers]");
    if (!tbody) return;
    tbody.innerHTML = "";
    if (!rows || rows.length < 2) {
      if (wrap) wrap.classList.add("hidden");
      return;
    }
    if (wrap) wrap.classList.remove("hidden");
    var activeRow = null;
    rows.forEach(function (r, i) {
      var active = currentQty >= r.qtyMin && (r.qtyMax == null || currentQty <= r.qtyMax);
      var rawSavePct = basePerPiece > r.perPiece + 0.005 ? (basePerPiece - r.perPiece) / basePerPiece : 0;
      var savePct = discountOffsetPp ? Math.max(0, rawSavePct - discountOffsetPp / 100) : rawSavePct;
      var tr = document.createElement("tr");
      // First row has no top border — the header row's bottom border is the divider.
      tr.className = (i === 0 ? "" : "border-t border-gray-100 ") + (active ? "bg-[var(--sp-light)] font-bold text-[var(--sp-blue)]" : "text-gray-700");
      var qtyCell = r.qtyLabel + (active ? ' <span class="ml-1 align-middle rounded bg-[var(--sp-blue)] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white">Selected</span>' : "");
      var saveCell = savePct > 0.005
        ? '<td class="px-3 py-1.5 text-right font-semibold text-[#17a349] tabular-nums">' + spSavePctLabel(savePct) + "%</td>"
        : '<td class="px-3 py-1.5 text-right text-gray-500 tabular-nums">0%</td>';
      tr.innerHTML =
        '<td class="px-3 py-1.5 text-left whitespace-nowrap">' + qtyCell + "</td>" +
        '<td class="px-3 py-1.5 text-right tabular-nums">' + spMoney(spExGst(r.perPiece, root)) + "</td>" +
        saveCell;
      tbody.appendChild(tr);
      if (active) activeRow = tr;
    });
    spScrollToTier(root, activeRow);
  }

  // Keep the highlighted "Selected" tier row visible inside the scrollable
  // table whenever the quantity changes (accounts for the sticky header).
  function spScrollToTier(root, row) {
    if (!row) return;
    var scroll = root.querySelector("[data-sp-tiers-scroll]");
    if (!scroll || scroll.scrollHeight <= scroll.clientHeight + 2) return;
    var head = scroll.querySelector("thead");
    var headH = head ? head.offsetHeight : 0;
    var rowTop = row.offsetTop;
    var rowBottom = rowTop + row.offsetHeight;
    var viewTop = scroll.scrollTop + headH;
    var viewBottom = scroll.scrollTop + scroll.clientHeight;
    if (rowTop >= viewTop && rowBottom <= viewBottom) return; // already in view
    var target = Math.max(0, rowTop - headH - (scroll.clientHeight - headH - row.offsetHeight) / 2);
    if (typeof scroll.scrollTo === "function") scroll.scrollTo({ top: target, behavior: "smooth" });
    else scroll.scrollTop = target;
  }

  // Ladder of quantities probed to discover where the per-piece price steps down.
  var SP_TIER_LADDER = [1, 2, 3, 5, 10, 15, 25, 50, 100, 250, 500, 1000];

  // Build ranged discount rows from a per-piece pricing function.
  // unitAt(q) returns GST-incl dollars per piece at quantity q (or null if invalid).
  // A new row is emitted only where the per-piece price drops below the previous
  // row, so a calculator with no volume discount yields a single row (table hidden).
  function spBuildTiers(unitAt, minQty, maxQty) {
    minQty = Math.max(1, minQty || 1);
    var pts = [];
    var pp0 = unitAt(minQty);
    if (pp0 != null && isFinite(pp0) && pp0 > 0) pts.push({ q: minQty, pp: pp0 });
    for (var i = 0; i < SP_TIER_LADDER.length; i++) {
      var q = SP_TIER_LADDER[i];
      if (q <= minQty) continue;
      if (maxQty && q > maxQty) break;
      var pp = unitAt(q);
      if (pp == null || !isFinite(pp) || pp <= 0) continue;
      pts.push({ q: q, pp: pp });
    }
    // When maxQty is set, always probe exactly at that boundary so it appears
    // as the final "N+" tier (e.g. 49+) even if maxQty isn't in the ladder.
    if (maxQty) {
      var last = pts.length ? pts[pts.length - 1] : null;
      if (!last || last.q < maxQty) {
        var ppBoundary = unitAt(maxQty);
        if (ppBoundary != null && isFinite(ppBoundary) && ppBoundary > 0) pts.push({ q: maxQty, pp: ppBoundary });
      }
    }
    var rows = [];
    for (var j = 0; j < pts.length; j++) {
      var prev = rows.length ? rows[rows.length - 1] : null;
      if (prev && pts[j].pp >= prev.perPiece - 0.005) continue; // no drop → same band
      rows.push({ qtyMin: pts[j].q, perPiece: pts[j].pp });
    }
    for (var k = 0; k < rows.length; k++) {
      var next = rows[k + 1];
      rows[k].qtyMax = next ? next.qtyMin - 1 : null;
      rows[k].qtyLabel = next ? (rows[k].qtyMin === rows[k].qtyMax ? String(rows[k].qtyMin) : rows[k].qtyMin + "–" + rows[k].qtyMax) : rows[k].qtyMin + "+";
    }
    return rows;
  }

  // Wire the shared lead + tier table for a self-hosted (formula) calculator.
  // unitAt(q) must mirror the handler's quantized per-piece for quantity q.
  // discountOffsetPp (optional): passed through to spRenderTiers to reduce displayed save%.
  function spLivePanel(root, unitAt, qty, minQty, maxQty, discountOffsetPp) {
    var base = unitAt(minQty);
    var per = unitAt(qty);
    if (per == null || !isFinite(per) || per <= 0) { spClearLead(root); return; }
    spRenderLead(root, per, base, qty);
    spRenderTiers(root, spBuildTiers(unitAt, minQty, maxQty), qty, base, discountOffsetPp);
  }

  /* ---------- AJAX add-to-cart for product cards (collections / carousels / search) ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.nodeName !== "FORM") return;
    if (form.id === "sp-product-form") return; // main product / acrylic form handled separately
    if (!/\/cart\/add\b/.test(form.getAttribute("action") || "")) return;
    var btn = form.querySelector("[data-sp-cart-btn]");
    var idField = form.querySelector('[name="id"]');
    if (!btn || !idField) return;
    e.preventDefault();
    if (btn.disabled) return;
    spCartBtn(btn, "loading");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: idField.value, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        // "Added" persists until the page is refreshed (no reset) — the
        // customer stays on the collection page and can keep browsing.
        spCartBtn(btn, "done");
        document.dispatchEvent(new Event("cart:refresh"));
      })
      .catch(function () { spCartBtn(btn, "idle"); });
  });

  /* ---------- Quick-add popup for product cards with options ----------
     Cards for multi-variant products carry [data-sp-qa] + an embedded JSON
     blob (options, variants). Clicking opens a popup (bottom sheet on mobile,
     centred dialog on desktop) with option dropdowns, a qty stepper and the
     same tier pricing table as the product page (1–4 / 5–9 / 10–19 / 20+).
     Qty 1–4 adds the NATIVE variant; qty 5+ MUST go through the pricing
     backend (/api/variant/configure) so the tier discount is real at checkout
     — never add 5+ natively, and never fall back to full price on failure. */
  (function () {
    // Escape ALL catalog-sourced text interpolated into the modal's innerHTML
    // (titles, option names/values, URLs) — merchant content must never become markup.
    function qaEsc(s) {
      return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function qaTierDiscount(q) { return q >= 20 ? 0.15 : q >= 10 ? 0.1 : q >= 5 ? 0.05 : 0; }
    // Mirrors the backend's /api/variant/configure math exactly.
    function qaUnitCents(baseCents, q) { return Math.max(1, Math.round(baseCents * (1 - qaTierDiscount(q)))); }

    var overlay = null, panel = null, state = null;

    function qaClose() {
      if (overlay) overlay.remove();
      overlay = null; panel = null; state = null;
      if (typeof spSetScrollLock === "function") spSetScrollLock(false);
      else document.documentElement.classList.remove("overflow-hidden");
    }
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && overlay) qaClose(); });

    function qaVariant() {
      if (!state) return null;
      var sel = state.selects.map(function (s) { return s.value; });
      return state.data.variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === sel[i]; });
      }) || null;
    }
    function qaQty() { return Math.max(1, parseInt(state.qtyIn.value, 10) || 1); }

    function qaRepaint() {
      var v = qaVariant();
      var q = qaQty();
      var addBtn = panel.querySelector("[data-sp-qa-add]");
      var totalEl = panel.querySelector("[data-sp-qa-total]");
      var rows = panel.querySelectorAll("[data-sp-qa-tier]");
      if (!v || !v.available) {
        totalEl.textContent = v ? "Sold out" : "Unavailable";
        addBtn.disabled = true;
        rows.forEach(function (r) { r.classList.remove("bg-[var(--sp-light)]"); r.querySelector("[data-sp-qa-tier-price]").textContent = "\u2014"; });
        return;
      }
      addBtn.disabled = false;
      totalEl.textContent = spMoney((qaUnitCents(v.price, q) * q) / 100);
      var mins = [1, 5, 10, 20];
      rows.forEach(function (r, i) {
        r.querySelector("[data-sp-qa-tier-price]").textContent = spMoney(qaUnitCents(v.price, mins[i]) / 100);
        var maxs = [4, 9, 19, Infinity];
        var active = q >= mins[i] && q <= maxs[i];
        r.classList.toggle("bg-[var(--sp-light)]", active);
        r.classList.toggle("font-bold", active);
      });
    }

    function qaShowErr(msg) {
      var el = panel.querySelector("[data-sp-qa-error]");
      el.textContent = msg;
      el.classList.remove("hidden");
    }

    function qaOpen(cardBtn) {
      var holder = cardBtn.parentElement.querySelector("[data-sp-qa-data]");
      var data;
      try { data = JSON.parse(holder.textContent); } catch (e) {
        // Data blob unusable — send the customer to the product page instead.
        var fallbackUrl = cardBtn.getAttribute("data-sp-qa-url");
        if (fallbackUrl) window.location.href = fallbackUrl;
        return;
      }
      qaClose();

      overlay = document.createElement("div");
      overlay.className = "fixed inset-0 z-[110] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4";
      overlay.addEventListener("click", function (e) { if (e.target === overlay) qaClose(); });

      var optHtml = data.options.map(function (opt, i) {
        return '<label class="block"><span class="text-xs font-bold uppercase tracking-wide text-black">' + qaEsc(opt.name) +
          '</span><select data-sp-qa-opt="' + i + '" class="mt-1 w-full rounded-xl border-2 border-gray-200 bg-white px-3 py-2.5 text-sm font-semibold text-black focus:border-[var(--sp-blue)] focus:outline-none">' +
          opt.values.map(function (val) { return '<option>' + qaEsc(val) + '</option>'; }).join("") +
          '</select></label>';
      }).join("");

      var tierHtml = ['1\u20134|0%', '5\u20139|5% off', '10\u201319|10% off', '20+|15% off'].map(function (t) {
        var p = t.split("|");
        return '<div data-sp-qa-tier class="grid grid-cols-3 items-center rounded-lg px-2.5 py-1.5 text-[13px] text-black">' +
          '<span class="font-semibold">' + p[0] + '</span>' +
          '<span class="text-center text-xs font-semibold text-[#16a34a]">' + (p[1] === '0%' ? '\u2014' : p[1]) + '</span>' +
          '<span data-sp-qa-tier-price class="text-right"></span></div>';
      }).join("");

      panel = document.createElement("div");
      panel.className = "max-h-[88vh] w-full overflow-y-auto rounded-t-2xl bg-white p-5 shadow-2xl sm:max-w-md sm:rounded-2xl";
      panel.innerHTML =
        '<div class="flex items-start gap-3">' +
          (data.image ? '<img src="' + qaEsc(data.image) + '" alt="" width="64" height="64" class="h-16 w-16 shrink-0 rounded-xl border border-gray-100 object-contain">' : '') +
          '<div class="min-w-0 flex-1"><p class="font-display text-[15px] font-bold leading-tight text-black">' + qaEsc(data.title) + '</p>' +
          '<p class="mt-0.5 text-xs text-black"><a href="' + qaEsc(data.url) + '" class="font-semibold text-[var(--sp-blue)] underline">View full details</a></p></div>' +
          '<button type="button" data-sp-qa-close aria-label="Close" class="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-gray-100 text-black transition-colors hover:bg-gray-200"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '</div>' +
        '<div class="mt-4 space-y-3">' + optHtml + '</div>' +
        '<div class="mt-4 flex items-center justify-between gap-3">' +
          '<span class="text-xs font-bold uppercase tracking-wide text-black">Quantity</span>' +
          '<div class="inline-flex items-center rounded-full border-2 border-gray-200">' +
            '<button type="button" data-sp-qa-minus class="grid h-9 w-9 place-items-center text-lg font-bold text-black" aria-label="Decrease quantity">\u2212</button>' +
            '<input data-sp-qa-qty type="number" min="1" value="1" inputmode="numeric" class="w-12 border-0 bg-transparent text-center text-sm font-bold text-black focus:outline-none">' +
            '<button type="button" data-sp-qa-plus class="grid h-9 w-9 place-items-center text-lg font-bold text-black" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="mt-4 rounded-xl border border-gray-200 p-2">' +
          '<div class="grid grid-cols-3 px-2.5 pb-1 text-[11px] font-bold uppercase tracking-wide text-black"><span>Qty</span><span class="text-center">Discount</span><span class="text-right">Per item</span></div>' +
          tierHtml +
        '</div>' +
        '<div class="mt-4 text-center">' +
          '<p class="text-[11px] font-bold uppercase tracking-wide text-black">Total (incl. GST)</p><p data-sp-qa-total class="font-display text-lg font-extrabold text-black"></p>' +
        '</div>' +
        '<p data-sp-qa-error class="mt-3 hidden rounded-lg bg-red-50 px-3 py-2 text-xs font-semibold text-red-700"></p>' +
        '<button type="button" data-sp-qa-add class="mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-[#16a34a] px-4 py-3 text-sm font-bold text-white disabled:opacity-60">' +
          '<span data-sp-cart-icon class="inline-flex h-4 w-4 items-center justify-center"><svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg></span> <span data-sp-cart-label>Add to cart</span>' +
        '</button>';
      overlay.appendChild(panel);
      document.body.appendChild(overlay);
      if (typeof spSetScrollLock === "function") spSetScrollLock(true);
      else document.documentElement.classList.add("overflow-hidden");

      state = {
        data: data,
        cardBtn: cardBtn,
        apiBase: (cardBtn.getAttribute("data-sp-qa-api") || "").trim().replace(/\/+$/, ""),
        selects: Array.prototype.slice.call(panel.querySelectorAll("[data-sp-qa-opt]")),
        qtyIn: panel.querySelector("[data-sp-qa-qty]")
      };
      panel.querySelector("[data-sp-qa-close]").addEventListener("click", qaClose);
      state.selects.forEach(function (s) { s.addEventListener("change", qaRepaint); });
      state.qtyIn.addEventListener("input", qaRepaint);
      panel.querySelector("[data-sp-qa-minus]").addEventListener("click", function () { state.qtyIn.value = Math.max(1, qaQty() - 1); qaRepaint(); });
      panel.querySelector("[data-sp-qa-plus]").addEventListener("click", function () { state.qtyIn.value = qaQty() + 1; qaRepaint(); });
      panel.querySelector("[data-sp-qa-add]").addEventListener("click", qaAdd);
      qaRepaint();
    }

    function qaAdd() {
      var v = qaVariant();
      var q = qaQty();
      var addBtn = panel.querySelector("[data-sp-qa-add]");
      var cardBtn = state.cardBtn;
      if (!v || !v.available) return;
      panel.querySelector("[data-sp-qa-error]").classList.add("hidden");
      spCartBtn(addBtn, "loading");

      function done() {
        document.dispatchEvent(new Event("cart:refresh"));
        qaClose();
        // Card button shows a persistent "Added" (until page refresh).
        spCartBtn(cardBtn, "done");
        cardBtn.disabled = false;
      }
      function fail(msg) {
        spCartBtn(addBtn, "idle");
        qaShowErr(msg || "Something went wrong. Please try again.");
      }

      if (q >= 5) {
        // Discounted quantities must be priced by the backend — no silent
        // full-price fallback (see PDP vtiers flow).
        if (!state.apiBase) { fail("Online quantity pricing is temporarily unavailable. Please order from the product page or contact us."); return; }
        fetch(state.apiBase + "/api/variant/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ variantId: String(v.id), qty: q })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't apply the quantity discount. Please try again.");
            }
            var props = {};
            state.data.options.forEach(function (opt, i) { props[opt.name] = state.selects[i].value; });
             return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
               body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || q, properties: (props._sp_original_url = cardBtn.getAttribute("data-sp-qa-url") || "", props) })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(done)
          .catch(function (err) { fail(err && err.message); });
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: v.id, quantity: q })
      })
        .then(function (r) { if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again."); return r.json(); })
        .then(done)
        .catch(function (err) { fail(err && err.message); });
    }

    document.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest("[data-sp-qa]") : null;
      if (!btn) return;
      if (btn.disabled) return;
      e.preventDefault();
      qaOpen(btn);
    });
  })();

  /* ---------- Buy-now buttons on calculator products ----------
     Native dynamic checkout is FORBIDDEN on calculator products (it would buy the
     $0 base variant — undercharge). These buttons instead run the SAME exact-price
     configure + add-to-cart flow as the submit button, then continue to checkout
     once THAT form's add succeeds. The intent is scoped to the originating form:
     on cart:refresh we only redirect if the pending form's own add-to-cart button
     is in its success state ("Added" — set exclusively by spCartBtn on that
     form's success path), so a failed buy-now can never cause an unrelated,
     later add to redirect. The intent is also time-boxed and cleared by any
     direct add-to-cart click. */
  var spBuyNowForm = null;
  var spBuyNowAt = 0;
  function spBuyNowClear() { spBuyNowForm = null; spBuyNowAt = 0; }
  document.addEventListener("click", function (e) {
    var buyBtn = e.target.closest("[data-sp-buy-now]");
    if (!buyBtn) {
      // Any direct add-to-cart click cancels a pending buy-now intent so a
      // regular add after a failed buy-now never redirects to checkout.
      if (e.target.closest("[data-sp-add], [data-sp-cart-btn]")) spBuyNowClear();
      return;
    }
    var form = buyBtn.closest("form");
    if (!form) return;
    var addBtn = form.querySelector("[data-sp-add]");
    if (addBtn && addBtn.disabled) return;
    spBuyNowForm = form;
    spBuyNowAt = Date.now();
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
  });
  document.addEventListener("cart:refresh", function () {
    if (!spBuyNowForm) return;
    if (Date.now() - spBuyNowAt >= 30000) { spBuyNowClear(); return; }
    var label = spBuyNowForm.querySelector("[data-sp-add] [data-sp-cart-label]");
    if (!label || label.textContent !== "Added") return; // refresh came from elsewhere (or this form's add failed)
    spBuyNowClear();
    window.location.href = "/checkout";
  });

  /* ---------- Desktop mega menu ---------- */
  var nav = document.querySelector("[data-sp-nav]");
  if (nav) {
    var panels = {};
    nav.querySelectorAll("[data-sp-mega]").forEach(function (p) {
      panels[p.getAttribute("data-sp-mega")] = p;
    });
    var closeAll = function () {
      Object.keys(panels).forEach(function (k) { panels[k].removeAttribute("data-open"); });
      nav.querySelectorAll("[data-sp-nav-item]").forEach(function (li) {
        var caret = li.querySelector(".sp-nav-caret");
        if (caret) caret.classList.remove("rotate-180");
        var link = li.querySelector(".sp-nav-link");
        if (link) link.classList.remove("text-[var(--sp-blue)]");
      });
    };
    var openItem = function (li) {
      var idx = li.getAttribute("data-sp-nav-item");
      closeAll();
      if (idx && panels[idx]) {
        panels[idx].setAttribute("data-open", "true");
        var caret = li.querySelector(".sp-nav-caret");
        if (caret) caret.classList.add("rotate-180");
        var link = li.querySelector(".sp-nav-link");
        if (link) link.classList.add("text-[var(--sp-blue)]");
      }
    };
    nav.querySelectorAll("[data-sp-nav-item]").forEach(function (li) {
      li.addEventListener("mouseenter", function () { openItem(li); });
      li.addEventListener("focusin", function () { openItem(li); });
    });
    // Plain top-level items (no dropdown) must close any open panel on hover,
    // otherwise e.g. the Info panel stays open while hovering "Design Packages".
    var firstDropLi = nav.querySelector("[data-sp-nav-item]");
    if (firstDropLi && firstDropLi.parentElement) {
      Array.prototype.forEach.call(firstDropLi.parentElement.children, function (li) {
        if (li.tagName === "LI" && !li.hasAttribute("data-sp-nav-item")) {
          li.addEventListener("mouseenter", closeAll);
          li.addEventListener("focusin", closeAll);
        }
      });
    }
    nav.addEventListener("mouseleave", closeAll);
    // keep panel open while hovering it
    Object.keys(panels).forEach(function (k) {
      panels[k].addEventListener("mouseenter", function () {
        panels[k].setAttribute("data-open", "true");
      });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  /* ---------- Sticky header: scroll-direction nav reveal ----------
     The nav row (row 3) collapses while scrolling DOWN and reveals on scroll
     UP. Flicker guard: toggling changes the header height, which shifts the
     scroll position and flips the apparent direction — a feedback loop. After
     each toggle we ignore direction for 400ms (CSS transition is 280ms) while
     resyncing lastY so post-cooldown deltas are genuine. */
  var spHdr = document.querySelector("[data-sp-header]");
  if (spHdr) {
    var spHdrLastY = window.pageYOffset || 0;
    var spHdrTicking = false;
    var spHdrDown = false;
    var spHdrLockUntil = 0;
    var spHdrOnScroll = function () {
      spHdrTicking = false;
      var y = window.pageYOffset || 0;
      if (Date.now() < spHdrLockUntil) { spHdrLastY = y; return; }
      var delta = y - spHdrLastY;
      // Hysteresis: ignore small movements so quick wiggles don't flicker.
      if (y > 160 && Math.abs(delta) < 24) return;
      if (Math.abs(delta) < 8) return; // jitter threshold (iOS rubber-banding)
      var wantDown = delta > 0 && y > 160;
      if (wantDown !== spHdrDown) {
        spHdrDown = wantDown;
        spHdr.classList.toggle("sp-hdr-down", wantDown);
        spHdrLockUntil = Date.now() + 400;
      }
      spHdrLastY = y;
    };
    window.addEventListener("scroll", function () {
      if (!spHdrTicking) { spHdrTicking = true; requestAnimationFrame(spHdrOnScroll); }
    }, { passive: true });
  }

  /* ---------- Mobile search sheet ---------- */
  var spSearchSheet = document.querySelector("[data-sp-search-sheet]");
  var spSearchToggleBtn = null; // Remember what opened it
  var spSearchInerted = [];

  function spSetScrollLock(lock) {
    if (lock) {
      document.body.setAttribute("data-sp-scroll-lock", parseInt(document.body.getAttribute("data-sp-scroll-lock") || "0") + 1);
      document.body.style.overflow = "hidden";
    } else {
      var current = parseInt(document.body.getAttribute("data-sp-scroll-lock") || "0");
      if (current <= 1) {
        document.body.removeAttribute("data-sp-scroll-lock");
        document.body.style.overflow = "";
      } else {
        document.body.setAttribute("data-sp-scroll-lock", current - 1);
      }
    }
  }

  if (spSearchSheet) {
    if (spSearchSheet.parentElement !== document.body) document.body.appendChild(spSearchSheet);

    spSearchSheet.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        var focusableEls = Array.prototype.slice.call(spSearchSheet.querySelectorAll('a[href], button, textarea, input, select')).filter(function(el) {
          return !el.disabled && !el.hasAttribute('hidden') && el.offsetParent !== null;
        });
        if (!focusableEls.length) return;
        var firstFocusable = focusableEls[0];
        var lastFocusable = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            lastFocusable.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            firstFocusable.focus();
            e.preventDefault();
          }
        }
      }
    });

    function closeSearchSheet() {
      spSearchSheet.classList.add("hidden");
      spSearchInerted.forEach(function (el) { el.removeAttribute("inert"); });
      spSearchInerted = [];
      spSetScrollLock(false);
      if (spSearchToggleBtn) {
        spSearchToggleBtn.setAttribute("aria-expanded", "false");
        spSearchToggleBtn.focus();
      }
    }
    document.addEventListener("click", function(e) {
      if (!e.target || !e.target.closest) return;
      var toggle = e.target.closest("[data-sp-msearch-toggle]");
      if (toggle) {
        spSearchToggleBtn = toggle;
        spSearchToggleBtn.setAttribute("aria-expanded", "true");
        spSearchSheet.classList.remove("hidden");

        spSearchInerted = Array.prototype.slice.call(document.body.children).filter(function (el) {
          return el !== spSearchSheet && !el.hasAttribute("inert");
        });
        spSearchInerted.forEach(function (el) { el.setAttribute("inert", ""); });

        spSetScrollLock(true);
        // Let display update, then focus input
        setTimeout(function() {
          var inp = spSearchSheet.querySelector("[data-sp-search-input]");
          if (inp) {
            inp.focus();
            if (inp.value) {
               inp.value = "";
               inp.dispatchEvent(new Event("input", { bubbles: true }));
            }
          }
        }, 50);
        return;
      }
      if (e.target.closest("[data-sp-search-sheet-close]")) {
        closeSearchSheet();
        return;
      }
      var pop = e.target.closest("[data-sp-search-pop]");
      if (pop) {
         var inp = spSearchSheet.querySelector("[data-sp-search-input]");
         if (inp) {
            inp.value = pop.getAttribute("data-sp-search-pop") || pop.textContent.trim();
            inp.focus();
            inp.dispatchEvent(new Event("input", { bubbles: true }));
         }
      }
    });
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && !spSearchSheet.classList.contains("hidden")) {
        closeSearchSheet();
      }
    });
  }

  /* ---------- Mobile drawer ----------
     The drawer is re-parented to <body> so its position:fixed overlay/panel
     are sized against the viewport no matter what containing block an
     ancestor of the header creates (backdrop-filter, transform, filter...).
     All clicks are handled by ONE delegated document listener, so wiring
     survives both the re-parenting and Shopify theme-editor section
     re-renders (shopify:section:load re-runs the setup, which also removes
     any stale body-level copy so only one drawer ever exists). */
  var spDrawerSetup = function () {
    var drawers = document.querySelectorAll("[data-sp-drawer]");
    if (!drawers.length) return;
    var drawer = drawers[drawers.length - 1]; // freshest render wins
    drawers.forEach(function (d) { if (d !== drawer) d.remove(); });
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    drawer.classList.add("hidden"); // always start closed after (re)setup
    drawer.classList.remove("sp-drawer-open");
    // Ensure we don't clear lock if sheet is open, handled by setup
  };
  spDrawerSetup();
  document.addEventListener("shopify:section:load", spDrawerSetup);
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest("[data-sp-drawer-open]")) {
      var dOpen = document.querySelector("[data-sp-drawer]");
      if (dOpen) {
        dOpen.classList.remove("hidden");
        spSetScrollLock(true);
        // Two frames so the browser paints the off-screen state first,
        // then .sp-drawer-open transitions the panel in from the left.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { dOpen.classList.add("sp-drawer-open"); });
        });
      }
      return;
    }
    var closeBtn = e.target.closest("[data-sp-drawer-close]");
    if (closeBtn) {
      var dClose = closeBtn.closest("[data-sp-drawer]");
      if (dClose) {
        dClose.classList.remove("sp-drawer-open");
        spSetScrollLock(false);
        // Hide only after the slide-out finishes (CSS transition 200ms).
        setTimeout(function () {
          if (!dClose.classList.contains("sp-drawer-open")) dClose.classList.add("hidden");
        }, 220);
      }
      return;
    }
    var acc = e.target.closest("[data-sp-acc]");
    if (acc && acc.closest("[data-sp-drawer]")) {
      var accBody = acc.closest("li").querySelector("[data-sp-acc-body]");
      var accCaret = acc.querySelector(".sp-acc-caret");
      if (!accBody) return;
      var accOpen = !accBody.classList.contains("hidden");
      accBody.classList.toggle("hidden", accOpen);
      if (accCaret) accCaret.classList.toggle("rotate-180", !accOpen);
    }
  });

  /* ---------- Search: shared helpers (API base + analytics beacons) ----------
     The Sign Portal search API (same backend as the pricing calculators) powers
     the suggestion dropdown, typo correction and the "similar products" fallback
     on /search. Every call is fail-safe: on error/timeout the storefront quietly
     drops back to Shopify's own predictive search. */
  var SP_SEARCH_API = (function () {
    var el = document.querySelector("[data-sp-search-api]");
    var v = el ? (el.getAttribute("data-sp-search-api") || "").trim() : "";
    return v.replace(/\/+$/, "");
  })();

  // Fire-and-forget search analytics. Never blocks navigation, never throws.
  function spSearchEvent(payload) {
    try {
      if (!SP_SEARCH_API || !payload || !payload.type) return;
      var url = SP_SEARCH_API + "/api/search/event";
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        // text/plain keeps sendBeacon a "simple" CORS request (no preflight).
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        if (navigator.sendBeacon(url, blob)) return;
      }
      if (window.fetch) {
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: body,
          keepalive: true
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function spHandleFromUrl(url) {
    var m = /\/products\/([^/?#]+)/.exec(String(url || ""));
    return m ? m[1] : "";
  }

  /* ---------- Rotating search placeholder ----------
     The real placeholder attribute is left empty; a fake, absolutely-positioned
     span carries the text so it can cross-fade (placeholder attributes can't be
     animated). Shown only while the input is empty. Rotation pauses the moment
     the box is focused or typed in and resumes only once it is empty AND blurred. */
  var SP_SEARCH_PLACEHOLDERS = [
    "Search by product, SKU, keyword or category...",
    'Try "Danger No Entry"',
    'Try "Brag Mat"',
    'Try "Traffolyte Labels"',
    'Try "Corflute Signs"',
    'Try "Electrical Labels"',
    'Try "Pull Up Banner"',
    'Try "Acrylic Cut to Size"',
    'Try "Custom Stickers"',
    'Try "Floor Decals"',
    'Try "Fire Extinguisher Sign"'
  ];

  document.querySelectorAll("[data-sp-search]").forEach(function (wrap) {
    var input = wrap.querySelector("[data-sp-search-input]");
    var ph = wrap.querySelector("[data-sp-search-ph]");
    if (!input || !ph) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var idx = 0;
    var rotateTimer = null;
    var fadeTimer = null;
    var focused = false;

    function setText(text) {
      if (fadeTimer) { clearTimeout(fadeTimer); fadeTimer = null; }
      if (reduce) { ph.textContent = text; ph.style.opacity = "1"; return; }
      ph.style.opacity = "0";
      fadeTimer = setTimeout(function () {
        ph.textContent = text;
        ph.style.opacity = "1";
        fadeTimer = null;
      }, 200);
    }
    function tick() {
      idx = (idx + 1) % SP_SEARCH_PLACEHOLDERS.length;
      setText(SP_SEARCH_PLACEHOLDERS[idx]);
    }
    function start() {
      if (rotateTimer) return;
      rotateTimer = setInterval(tick, 5000);
    }
    function stop() {
      if (rotateTimer) { clearInterval(rotateTimer); rotateTimer = null; }
      if (fadeTimer) { clearTimeout(fadeTimer); fadeTimer = null; }
      ph.style.opacity = "1";
    }
    function refresh() {
      var empty = !input.value;
      // Inline display (never .hidden) so it can't fight layout utilities.
      ph.style.display = empty ? "" : "none";
      if (empty && !focused) start();
      else stop();
    }

    ph.style.opacity = "1";
    input.addEventListener("focus", function () { focused = true; refresh(); });
    input.addEventListener("blur", function () { focused = false; refresh(); });
    input.addEventListener("input", refresh);
    refresh();
  });

  /* ---------- Live suggestion dropdown ----------
     Primary source: {api}/api/search/suggest (ranked across name/SKU/keywords/
     tags/categories/attributes/descriptions, with typo correction).
     Fallback: Shopify /search/suggest.json — used whenever the API is not
     configured, errors, times out (>800ms) or answers !ok. */
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    // Allow for a cold search-index response without racing a valid ~800 ms reply.
    // This is a failover ceiling, not the perceived-speed target for normal queries.
    var SUGGEST_TIMEOUT = 5000;
    var cache = Object.create(null);
    var order = [];
    var MAX_CACHE = 60;

    function remember(key, val) {
      if (!(key in cache)) {
        order.push(key);
        if (order.length > MAX_CACHE) delete cache[order.shift()];
      }
      cache[key] = val;
    }
    function money(v) {
      var n = parseFloat(v);
      return isNaN(n) ? "" : "$" + n.toFixed(2);
    }
    function esc(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function thumb(url) {
      if (!url) return "";
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=96";
    }
    function allUrl(term) {
      return root + "search?q=" + encodeURIComponent(term) + "&type=product";
    }
    function reEsc(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    // Bold every occurrence of the query (whole phrase first, then each word) in
    // a plain-text string. Splitting on the RAW text and escaping each fragment
    // keeps the output safe without ever matching inside an HTML entity.
    function highlight(text, term) {
      var s = String(text == null ? "" : text);
      var toks = [];
      var seen = Object.create(null);
      String(term || "").trim().split(/\s+/).forEach(function (w) {
        if (w.length < 2) return;
        var k = w.toLowerCase();
        if (seen[k]) return;
        seen[k] = 1;
        toks.push(w);
      });
      var whole = String(term || "").trim();
      if (whole.length >= 2 && !seen[whole.toLowerCase()]) toks.unshift(whole);
      if (!toks.length || !s) return esc(s);
      toks.sort(function (a, b) { return b.length - a.length; });
      var re;
      try {
        re = new RegExp("(" + toks.map(reEsc).join("|") + ")", "ig");
      } catch (e) {
        return esc(s);
      }
      var out = "", last = 0, m;
      while ((m = re.exec(s)) !== null) {
        if (m[0] === "") { re.lastIndex++; continue; }
        out += esc(s.slice(last, m.index)) + '<mark class="bg-transparent font-extrabold text-[var(--sp-blue)]">' + esc(m[0]) + "</mark>";
        last = m.index + m[0].length;
      }
      out += esc(s.slice(last));
      return out;
    }

    // Transient single-use products (quantity-discount / custom-cut orders)
    // must never appear as suggestions. New ones are hidden via the seo.hidden
    // metafield server-side; this guards against ones minted before that fix.
    function isTransient(p) {
      var u = String((p && (p.url || p.handle)) || "");
      return u.indexOf("custom-cut-") > -1 || u.indexOf("b2b-order-") > -1;
    }

    function imgCell(src) {
      return '<span class="grid h-12 w-12 shrink-0 place-items-center overflow-hidden rounded-lg bg-white ring-1 ring-black/5">' +
        (src ? '<img src="' + esc(thumb(src)) + '" alt="" loading="lazy" decoding="async" width="48" height="48" class="h-full w-full object-contain">' : "") +
        "</span>";
    }
    function seeAll(term) {
      return '<a href="' + esc(allUrl(term)) + '" data-sp-result data-sp-seeall class="flex items-center justify-between gap-2 border-t border-gray-100 px-4 py-3 text-[13px] font-bold text-[var(--sp-blue)] transition-colors hover:bg-[var(--sp-light)]">' +
               '<span>See all results for &ldquo;' + esc(term) + '&rdquo;</span>' +
               '<span aria-hidden="true">&rarr;</span>' +
             "</a>";
    }
    function groupHead(label) {
      return '<p class="px-3 pb-1.5 pt-1 text-[11px] font-bold uppercase tracking-[0.14em] text-[var(--sp-purple)]">' + label + "</p>";
    }

    /* ---- API rendering ---- */
    function apiPrice(p) {
      if (p.poa) return '<span class="text-[13px] font-extrabold text-black">POA</span>';
      var n = parseFloat(p.priceMin);
      if (isNaN(n) || n <= 0) return "";
      return '<span class="text-[13px] font-extrabold text-black">From ' + esc(money(n)) + "</span>";
    }
    function apiRows(products, term) {
      var html = "";
      for (var i = 0; i < products.length; i++) {
        var p = products[i] || {};
        var meta = [];
        if (p.sku) meta.push(highlight(p.sku, term));
        if (p.category) meta.push(highlight(p.category, term));
        var match = p.match || {};
        var snippet = "";
        if (match.text && match.field && match.field !== "title") {
          snippet = '<span class="mt-0.5 block truncate text-[12px] text-gray-500">' + highlight(match.text, term) + "</span>";
        }
        var price = apiPrice(p);
        html +=
          '<a href="' + esc(p.url || (root + "products/" + p.handle)) + '" data-sp-result data-sp-handle="' + esc(p.handle || "") + '" role="option" class="flex items-center gap-3 rounded-xl px-3 py-2 outline-none transition-colors hover:bg-[var(--sp-light)]">' +
            imgCell(p.image) +
            '<span class="min-w-0 flex-1">' +
              '<span class="block truncate text-[14px] font-semibold leading-tight text-black">' + highlight(p.title, term) + "</span>" +
              (meta.length ? '<span class="mt-0.5 block truncate text-[12px] text-gray-500">' + meta.join(" &middot; ") + "</span>" : "") +
              snippet +
              (price ? '<span class="mt-1 block">' + price + "</span>" : "") +
            "</span>" +
          "</a>";
      }
      return html;
    }
    function apiCategoryRows(categories, term) {
      var html = "";
      for (var i = 0; i < categories.length; i++) {
        var c = categories[i] || {};
        html +=
          '<a href="' + esc(c.url || (root + "collections/" + c.handle)) + '" data-sp-result data-sp-category="' + esc(c.handle || "") + '" role="option" class="flex items-center gap-3 rounded-xl px-3 py-2 outline-none transition-colors hover:bg-[var(--sp-light)]">' +
            '<span class="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-[var(--sp-light)] text-[var(--sp-blue)] text-[13px] font-bold" aria-hidden="true">&#9906;</span>' +
            '<span class="min-w-0 flex-1 truncate text-[14px] font-semibold leading-tight text-black">' + highlight(c.title, term) + "</span>" +
          "</a>";
      }
      return html;
    }
    function apiView(data, term) {
      var products = (data && data.products) || [];
      var cats = (data && data.categories) || [];
      var pages = (data && data.pages) || [];
      var html = "";
      if (data && data.correctedQuery) {
        html += '<p class="border-b border-gray-100 px-4 py-2 text-[12px] text-gray-500">Showing results for &ldquo;<span class="font-bold text-black">' + esc(data.correctedQuery) + "</span>&rdquo;</p>";
      }
      if (products.length) {
        html += '<div class="p-2">' + groupHead("Products") + apiRows(products, term) + "</div>";
      }
      if (cats.length) {
        html += '<div class="' + (products.length ? "border-t border-gray-100 " : "") + 'p-2">' + groupHead("Categories") + apiCategoryRows(cats, term) + "</div>";
      }
      if (pages.length) {
        html += '<div class="' + (products.length || cats.length ? "border-t border-gray-100 " : "") + 'p-2">' + groupHead("Helpful Pages") + pageRows(pages, term) + "</div>";
      }
      return html + seeAll(term);
    }

    /* ---- Shopify predictive-search (fallback) rendering ---- */
    function pageRows(pages, term) {
      var html = "";
      for (var i = 0; i < pages.length; i++) {
        var p = pages[i];
        html +=
          '<a href="' + esc(p.url) + '" data-sp-result role="option" class="flex items-center gap-3 rounded-xl px-3 py-2 outline-none transition-colors hover:bg-[var(--sp-light)]">' +
            '<span class="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-[var(--sp-light)] text-[var(--sp-blue)] text-[13px] font-bold" aria-hidden="true">&#128196;</span>' +
            '<span class="min-w-0 flex-1 truncate text-[14px] font-semibold leading-tight text-black">' + highlight(p.title, term) + "</span>" +
          "</a>";
      }
      return html;
    }

    function rows(products) {
      var html = "";
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var img = (p.featured_image && p.featured_image.url) || p.image || "";
        var sale = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price);
        html +=
          '<a href="' + esc(p.url) + '" data-sp-result data-sp-handle="' + esc(p.handle || spHandleFromUrl(p.url)) + '" role="option" class="flex items-center gap-3 rounded-xl px-3 py-2 outline-none transition-colors hover:bg-[var(--sp-light)]">' +
            imgCell(img) +
            '<span class="min-w-0 flex-1">' +
              '<span class="block truncate text-[14px] font-semibold leading-tight text-black">' + esc(p.title) + "</span>" +
              '<span class="mt-1 flex items-center gap-2">' +
                '<span class="text-[13px] font-extrabold text-black">' + money(p.price) + "</span>" +
                (sale ? '<span class="text-[12px] text-gray-400 line-through">' + money(p.compare_at_price_max) + "</span>" : "") +
                (p.available ? "" : '<span class="text-[11px] font-semibold text-gray-400">Sold out</span>') +
              "</span>" +
            "</span>" +
          "</a>";
      }
      return html;
    }

    function view(state, payload, term) {
      if (state === "loading") {
        return '<div class="px-4 py-6 text-center text-sm font-semibold text-gray-500"><svg class="inline-block h-5 w-5 animate-spin mr-2" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" stroke-opacity="0.25"></circle><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path></svg>Searching&hellip;</div>';
      }
      if (state === "error") {
        return '<div class="px-4 py-7 text-center">' +
                 '<p class="text-sm font-semibold text-black">Couldn&rsquo;t load suggestions.</p>' +
                 '<div class="mt-4 flex flex-col items-center gap-3">' +
                   '<button type="button" data-sp-search-retry class="inline-flex min-h-[44px] items-center gap-1.5 rounded-full px-5 py-2.5 text-[14px] font-bold text-white" style="background-image: var(--sp-grad-btn)">Retry search</button>' +
                   '<a href="' + esc(allUrl(term)) + '" class="text-[13px] font-semibold text-[var(--sp-blue)] hover:underline">Search all signs</a>' +
                 '</div>' +
               "</div>";
      }
      if (state === "empty") {
        return '<div class="px-4 py-7 text-center">' +
                 '<p class="text-[15px] font-bold text-black">We couldn&rsquo;t find an exact match.</p>' +
                 '<div class="mt-5 flex flex-col items-center gap-3">' +
                   '<button type="button" data-sp-search-focus class="text-[14px] font-semibold text-[var(--sp-blue)] hover:underline">Search again</button>' +
                   '<a href="' + root + 'pages/safety-signs" class="text-[14px] font-semibold text-[var(--sp-blue)] hover:underline">Browse all safety signs</a>' +
                   '<a href="' + root + 'collections/custom-signage" data-sp-custom-sign class="text-[14px] font-semibold text-[var(--sp-blue)] hover:underline">Create a custom safety sign</a>' +
                   '<a href="' + root + 'pages/contact-us" class="text-[14px] font-semibold text-[var(--sp-blue)] hover:underline">Contact Sign Portal</a>' +
                 '</div>' +
               "</div>";
      }
      if (state === "api") return apiView(payload, term);

      // Fallback
      var html = "";
      if (payload && payload.products && payload.products.length) {
         html += '<div class="p-2">' + groupHead("Products") + rows(payload.products) + "</div>";
      }
      if (payload && payload.pages && payload.pages.length) {
         html += '<div class="' + (html ? "border-t border-gray-100 " : "") + 'p-2">' + groupHead("Pages & Articles") + pageRows(payload.pages, term) + "</div>";
      }
      return html + seeAll(term);
    }

    function resultCount(entry) {
      if (!entry) return 0;
      if (entry.mode === "api") {
        var d = entry.data || {};
        return ((d.products && d.products.length) || 0) + ((d.categories && d.categories.length) || 0) + ((d.pages && d.pages.length) || 0);
      }
      if (entry.mode === "shopify") {
        var s = entry.data || {};
        return ((s.products && s.products.length) || 0) + ((s.pages && s.pages.length) || 0);
      }
      return 0;
    }
    function isEmptyEntry(entry) { return resultCount(entry) === 0; }

    document.querySelectorAll("[data-sp-search]").forEach(function (wrap) {
      var input = wrap.querySelector("[data-sp-search-input]");
      var panel = wrap.querySelector("[data-sp-results]");
      if (!input || !panel) return;
      var form = wrap.querySelector("form");
      var timer = null, controller = null, active = -1;
      var lastEntry = null, lastTerm = "";

      function getSheetEmpty() {
        var sheet = wrap.closest("[data-sp-search-sheet]");
        return sheet ? sheet.querySelector("[data-sp-search-sheet-empty]") : null;
      }
      var clearBtn = wrap.querySelector("[data-sp-search-clear]");

      function show() {
        panel.classList.remove("hidden");
        input.setAttribute("aria-expanded", "true");
        var empty = getSheetEmpty();
        if (empty) empty.classList.add("hidden");
      }
      function hide() {
        panel.classList.add("hidden");
        input.setAttribute("aria-expanded", "false");
        input.removeAttribute("aria-activedescendant");
        var liveRegion = wrap.querySelector("[data-sp-search-live-region]");
        if (liveRegion) liveRegion.textContent = "";
        active = -1;
        var empty = getSheetEmpty();
        if (empty) empty.classList.remove("hidden");
      }
      function updateClearBtn() {
        if (!clearBtn) return;
        if (input.value.length > 0) clearBtn.style.display = "grid";
        else clearBtn.style.display = "none";
      }
      if (clearBtn) {
        clearBtn.addEventListener("click", function() {
          if (timer) { clearTimeout(timer); timer = null; }
          if (controller) { controller.abort(); controller = null; }
          input.value = "";
          updateClearBtn();
          hide();
          input.focus();
        });
      }

      function opts() { return panel.querySelectorAll("[data-sp-result]"); }
      function paint(state, payload, term) {
        panel.innerHTML = view(state, payload, term);
        input.removeAttribute("aria-activedescendant");
        active = -1;
        show();
      }
      var liveRegion = wrap.querySelector("[data-sp-search-live-region]");
      function announce(msg) {
        if (liveRegion) liveRegion.textContent = msg;
      }
      function paintEntry(entry, term) {
        lastEntry = entry;
        lastTerm = term;
        var count = resultCount(entry);
        if (count === 0) {
          paint("empty", null, term);
          announce("No results found for " + term);
          return;
        }
        paint(entry.mode === "api" ? "api" : "results", entry.data, term);
        announce(count + " results found.");
      }
      function move(dir) {
        var list = opts();
        if (!list.length) return;
        active += dir;
        if (active < 0) active = list.length - 1;
        if (active >= list.length) active = 0;
        for (var i = 0; i < list.length; i++) {
          var on = i === active;
          list[i].classList.toggle("bg-[var(--sp-light)]", on);
          list[i].setAttribute("aria-selected", on ? "true" : "false");

          if (!list[i].id) {
             list[i].id = "sp-res-" + i + "-" + Date.now();
          }

          if (on) {
            list[i].scrollIntoView({ block: "nearest" });
            input.setAttribute("aria-activedescendant", list[i].id);
          }
        }
        if (active === -1) {
           input.removeAttribute("aria-activedescendant");
        }
      }

      // "search" analytics event — only once the customer stops typing for 1s.
      function fallbackSearch(term, signal, excludeProducts) {
        var types = excludeProducts ? "page,article" : "product,page,article";
        var url = root + "search/suggest.json?q=" + encodeURIComponent(term) +
          "&resources[type]=" + types + "&resources[limit]=8&resources[options][unavailable_products]=last";

        var opts = { headers: { Accept: "application/json" } };
        if (signal) opts.signal = signal;

        return fetch(url, opts)
          .then(function (r) {
            if (!r.ok) throw new Error("HTTP " + r.status);
            return r.json();
          })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            var pages = (data && data.resources && data.resources.results && data.resources.results.pages) || [];
            var articles = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
            products = products.filter(function (p) { return !isTransient(p); });
            return { mode: "shopify", data: { products: products, pages: pages.concat(articles) } };
          });
      }

      function apiSearch(term, signal) {
        if (!SP_SEARCH_API || !("AbortController" in window)) return Promise.reject(new Error("no-api"));

        // Inner helper so we can reuse the same AbortController for a retry.
        function doFetch(q) {
          var shopifyReq = fallbackSearch(q, signal, true).catch(function() { return { data: { pages: [] } }; });
          var apiReq = fetch(SP_SEARCH_API + "/api/search/suggest?q=" + encodeURIComponent(q) + "&limit=8", {
            signal: signal,
            mode: "cors",
            credentials: "omit",
            headers: { Accept: "application/json" }
          })
            .then(function (r) {
              if (!r.ok) throw new Error("HTTP " + r.status);
              return r.json();
            });

          return Promise.all([apiReq, shopifyReq])
            .then(function (results) {
              var data = results[0];
              var shopifyRes = results[1];
              if (!data || data.ok !== true) throw new Error("not-ok");
              var products = (data.products || []).filter(function (p) { return !isTransient(p); });
              return {
                mode: "api",
                data: {
                  correctedQuery: data.correctedQuery || null,
                  products: products,
                  categories: data.categories || [],
                  pages: shopifyRes.data.pages || []
                }
              };
            });
        }

        return doFetch(term).then(function (entry) {
          var d = entry.data || {};
          var noResults = !(d.products && d.products.length) && !(d.categories && d.categories.length) && !(d.pages && d.pages.length);
          if (noResults && !d.correctedQuery) {
            var words = term.trim().split(/\s+/);
            if (words.length >= 2) {
              var shorter = words.slice(0, -1).join(" ");
              // Hit the local cache first to avoid an unnecessary round-trip.
              var cached = cache[shorter];
              if (cached && cached.mode === "api") {
                var cp = (cached.data && cached.data.products) || [];
                var cc = (cached.data && cached.data.categories) || [];
                var cpg = (cached.data && cached.data.pages) || [];
                if (cp.length || cc.length || cpg.length) {
                  return { mode: "api", data: { correctedQuery: shorter, products: cp, categories: cc, pages: cpg } };
                }
              }
              return doFetch(shorter)
                .then(function (entry2) {
                  var d2 = entry2.data || {};
                  if ((d2.products && d2.products.length) || (d2.categories && d2.categories.length) || (d2.pages && d2.pages.length)) {
                    return { mode: "api", data: { correctedQuery: shorter, products: d2.products || [], categories: d2.categories || [], pages: d2.pages || [] } };
                  }
                  return entry; // retry also empty — propagate original 0-result entry
                })
                .catch(function () { return entry; }); // retry errored — propagate original
            }
          }
          return entry;
        });
      }

      function search(term) {
        if (term in cache) {
          paintEntry(cache[term], term);
          return;
        }
        paint("loading", null, term);
        if (controller) { try { controller.abort(); } catch (e) {} controller = null; }

        var ac = window.AbortController ? new AbortController() : null;
        controller = ac;
        var signal = ac ? ac.signal : undefined;

        var timedOut = false;
        var to = null;
        if (ac) {
           to = setTimeout(function() { timedOut = true; try { ac.abort(); } catch(e){} }, SUGGEST_TIMEOUT);
        }

        apiSearch(term, signal)
          .catch(function (err) {
            // User typed on — a newer request already owns the panel.
            if (timedOut) throw new Error("timeout");
            if (err && err.name === "AbortError" && input.value.trim().toLowerCase() !== term) throw err;
            return fallbackSearch(term, signal, false);
          })
          .then(function (entry) {
            if (to) clearTimeout(to);
            remember(term, entry);
            if (input.value.trim().toLowerCase() !== term) return;
            paintEntry(entry, term);
          })
          .catch(function (err) {
            if (to) clearTimeout(to);
            if (err && err.name === "AbortError") return;
            if (input.value.trim().toLowerCase() !== term) return;
            paint("error", null, term);
          });
      }

      input.setAttribute("autocomplete", "off");
      input.setAttribute("role", "combobox");
      input.setAttribute("aria-expanded", "false");

      input.addEventListener("input", function () {
        updateClearBtn();
        var term = input.value.trim().toLowerCase();
        if (timer) { clearTimeout(timer); timer = null; }
        var mode = wrap.getAttribute("data-sp-search-mode");
        if (mode === "collection") return; // Let the collection filter handle it.
        if (controller) { controller.abort(); controller = null; }

        if (term.length < 2) { hide(); return; }
        if (term in cache) { search(term); return; }
        timer = setTimeout(function () {
          if (input.value.trim().toLowerCase() === term) search(term);
        }, 180);
      });
      input.addEventListener("focus", function () {
        updateClearBtn();
        var mode = wrap.getAttribute("data-sp-search-mode");
        if (mode === "collection") return;
        var term = input.value.trim().toLowerCase();
        if (term.length >= 2) search(term);
      });
      input.addEventListener("keydown", function (e) {
        if (panel.classList.contains("hidden")) return;
        if (e.key === "ArrowDown") { e.preventDefault(); move(1); }
        else if (e.key === "ArrowUp") { e.preventDefault(); move(-1); }
        else if (e.key === "Enter") {
          var list = opts();
          if (active > -1 && list[active]) { e.preventDefault(); window.location.href = list[active].getAttribute("href"); }
        } else if (e.key === "Escape") { hide(); }
      });

      // Suggestion click → analytics (never blocks the navigation).
      panel.addEventListener("click", function (e) {
        var retry = e.target.closest("[data-sp-search-retry]");
        if (retry) {
           var term = input.value.trim().toLowerCase();
           if (term.length >= 2) search(term);
           return;
        }
        var focusBtn = e.target.closest("[data-sp-search-focus]");
        if (focusBtn) {
          e.preventDefault();
          input.value = "";
          updateClearBtn();
          hide();
          input.focus();
          return;
        }
      });

      panel.addEventListener("mousedown", function (e) {
        var link = e.target && e.target.closest ? e.target.closest("[data-sp-result]") : null;
        var customSign = e.target && e.target.closest ? e.target.closest("[data-sp-custom-sign]") : null;
        if (customSign) {
          try {
            spSearchEvent({
              type: "click",
              term: input.value.trim(),
              productHandle: "custom-signage-action",
              source: "suggest"
            });
          } catch (err) {}
          return;
        }
        if (!link) return;

        var isSeeAll = link.hasAttribute("data-sp-seeall");
        try {
          spSearchEvent({
            type: "click",
            term: input.value.trim(),
            productHandle: isSeeAll ? "view-all-results" : (link.getAttribute("data-sp-handle") || spHandleFromUrl(link.getAttribute("href")) || undefined),
            source: "suggest"
          });
        } catch (err) {}
      });

      document.addEventListener("mousedown", function (e) {
        if (!wrap.contains(e.target)) hide();
      });
    });
  })();

  /* ---------- Safety Signs category carousel ---------- */
  (function () {
    var carousel = document.querySelector("[data-sp-category-carousel]");
    if (!carousel) return;
    var viewport = carousel.querySelector("[data-sp-category-viewport]");
    var prev = carousel.querySelector("[data-sp-category-prev]");
    var next = carousel.querySelector("[data-sp-category-next]");
    if (!viewport || !prev || !next) return;

    function updateButtons() {
      var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var atStart = viewport.scrollLeft <= 2;
      var atEnd = viewport.scrollLeft >= max - 2;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.setAttribute("aria-disabled", atStart ? "true" : "false");
      next.setAttribute("aria-disabled", atEnd ? "true" : "false");
    }

    function move(direction) {
      viewport.scrollBy({
        left: direction * Math.max(viewport.clientWidth * 0.78, 220),
        behavior: "smooth"
      });
    }

    prev.addEventListener("click", function () { move(-1); });
    next.addEventListener("click", function () { move(1); });
    viewport.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  })();

  /* ---------- /search results page: analytics + "similar products" rescue ----------
     When Shopify returns zero results we ask the search API for its ranked
     (typo-corrected, keyword-aware) matches and render them instead of a dead
     end. If the API is unavailable the page simply keeps the existing empty
     state with its browse / request-a-quote links. */
  (function () {
    var page = document.querySelector("[data-sp-search-page]");
    if (!page) return;
    var term = (page.getAttribute("data-term") || "").trim();
    var count = parseInt(page.getAttribute("data-count") || "0", 10);
    if (isNaN(count)) count = 0;

    if (term) {
      spSearchEvent({
        type: "search",
        term: term,
        resultCount: count,
        zeroResult: count === 0,
        source: "results"
      });
    }

    // Clicking through to a product from the results grid.
    page.addEventListener("mousedown", function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!link) return;
      try {
        spSearchEvent({
          type: "click",
          term: term,
          productHandle: spHandleFromUrl(link.getAttribute("href")) || undefined,
          source: "results"
        });
      } catch (err) {}
    });

    var slot = page.querySelector("[data-sp-search-similar]");
    if (!slot || !term || count > 0 || !SP_SEARCH_API) return;

    function sEsc(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function sMoney(v) {
      var n = parseFloat(v);
      return isNaN(n) ? "" : "$" + n.toFixed(2);
    }
    function sImg(url) {
      if (!url) return "";
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=600";
    }
    function card(p) {
      var price = "";
      if (p.poa) {
        price = '<p class="mt-3 font-display text-xl font-extrabold leading-none text-black">POA</p>';
      } else {
        var n = parseFloat(p.priceMin);
        if (!isNaN(n) && n > 0) {
          price = '<div class="mt-3"><p class="text-[11px] font-medium text-black">From</p><p class="font-display text-xl font-extrabold leading-none text-black">' + sEsc(sMoney(n)) + "</p></div>";
        }
      }
      return '<div data-sp-card class="group flex flex-col rounded-2xl border border-gray-200 bg-white p-4 transition-all hover:-translate-y-1 hover:border-[var(--sp-blue)] hover:shadow-[0_22px_44px_-26px_rgba(83,95,251,0.55)]">' +
               '<a href="' + sEsc(p.url) + '" class="flex flex-1 flex-col">' +
                 '<div class="mx-auto w-[80%] pb-2 pt-1">' +
                   (p.image
                     ? '<img src="' + sEsc(sImg(p.image)) + '" alt="' + sEsc(p.title) + '" loading="lazy" decoding="async" width="300" height="300" class="aspect-square w-full object-contain">'
                     : '<span class="grid aspect-square w-full place-items-center rounded-xl bg-gray-50 text-gray-300"></span>') +
                 "</div>" +
                 '<div class="mt-3 flex flex-1 flex-col">' +
                   '<h3 class="font-display text-[15px] font-bold leading-tight text-black">' + sEsc(p.title) + "</h3>" +
                   (p.sku ? '<p class="mt-0.5 text-xs font-medium text-black">Code ' + sEsc(p.sku) + "</p>" : "") +
                   price +
                 "</div>" +
               "</a>" +
               '<a href="' + sEsc(p.url) + '" class="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-full border-2 border-white bg-[#16a34a] px-3.5 py-2 text-[13px] font-bold text-white transition-transform group-hover:scale-[1.02]"><span>View product</span></a>' +
             "</div>";
    }

    var ac = "AbortController" in window ? new AbortController() : null;
    var to = ac ? setTimeout(function () { ac.abort(); }, 4000) : null;
    fetch(SP_SEARCH_API + "/api/search/suggest?q=" + encodeURIComponent(term) + "&limit=12", {
      signal: ac ? ac.signal : undefined,
      mode: "cors",
      credentials: "omit",
      headers: { Accept: "application/json" }
    })
      .then(function (r) {
        if (to) clearTimeout(to);
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || data.ok !== true) throw new Error("not-ok");
        var products = (data.products || []).filter(function (p) {
          var u = String((p && (p.url || p.handle)) || "");
          return u.indexOf("custom-cut-") === -1 && u.indexOf("b2b-order-") === -1;
        });
        if (!products.length) return;
        var head = '<p class="font-display text-xl font-extrabold text-black">No exact results found. Showing similar products.</p>';
        if (data.correctedQuery) {
          head += '<p class="mt-1 text-sm text-gray-500">Showing results for &ldquo;<span class="font-bold text-black">' + sEsc(data.correctedQuery) + "</span>&rdquo;</p>";
        }
        slot.innerHTML = head +
          '<div class="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">' +
            products.map(card).join("") +
          "</div>";
        slot.classList.remove("hidden");
      })
      .catch(function () {
        if (to) clearTimeout(to);
      });
  })();

  /* ---------- Product page: relevance-ranked related products ----------
     Liquid provides a strict same-family fallback, but collection.products is
     capped at 50 items and cannot always see the best subject match. Use the
     full-catalogue search index to find candidates by title/description/tags,
     then verify each candidate against Shopify product JSON before rendering.
     No query ever asks for or falls back to the All Products collection. */
  (function () {
    var section = document.querySelector("[data-sp-related]");
    if (!section) return;
    var grid = section.querySelector("[data-sp-related-grid]");
    var configEl = section.querySelector("[data-sp-related-config]");
    if (!grid || !configEl) return;

    var cfg;
    try { cfg = JSON.parse(configEl.textContent || "{}"); } catch (err) { return; }
    var apiBase = String(cfg.apiBase || SP_SEARCH_API || "").replace(/\/+$/, "");
    if (!apiBase || !cfg.handle || !cfg.familyKey) return;
    var maxItems = Math.max(1, Math.min(5, parseInt(cfg.maxItems || "5", 10) || 5));
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    function rEsc(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function normalise(s) {
      return String(s || "").toLowerCase().replace(/&amp;|&/g, " and ").replace(/[^a-z0-9]+/g, " ").trim();
    }
    function unique(list) {
      var seen = Object.create(null);
      return list.filter(function (value) {
        var key = String(value || "").trim().toLowerCase();
        if (!key || seen[key]) return false;
        seen[key] = 1;
        return true;
      });
    }
    function tagsText(p) {
      return Array.isArray(p.tags) ? p.tags.join(" ") : String(p.tags || "");
    }
    function productText(p) {
      return normalise([p.title, p.description, p.body_html, tagsText(p), p.type, p.vendor].join(" "));
    }
    function isStencil(p) {
      var text = productText(p) + " " + normalise(p.handle);
      return text.indexOf("stencil") !== -1;
    }
    function strictFamily(p) {
      var text = productText(p);
      var tags = normalise(tagsText(p));
      if (cfg.familyKey === "stencil") return isStencil(p);
      if (isStencil(p)) return false;
      if (cfg.familyKey === "danger") return tags.indexOf("danger signs") !== -1 || /^danger\b/.test(normalise(p.title));
      if (cfg.familyKey === "mandatory") return tags.indexOf("mandatory signs") !== -1 || /^mandatory\b/.test(normalise(p.title));
      if (cfg.familyKey === "prohibition") return tags.indexOf("prohibition signs") !== -1 || /^prohibition\b/.test(normalise(p.title));
      if (cfg.familyKey === "warning") return tags.indexOf("warning signs") !== -1 || /^warning\b/.test(normalise(p.title));
      if (cfg.familyKey === "electrical") return text.indexOf("electrical") !== -1 && (text.indexOf("label") !== -1 || text.indexOf("solar") !== -1 || text.indexOf("battery") !== -1);
      return true;
    }
    function broadSafety(p) {
      if (cfg.familyKey === "stencil" || isStencil(p)) return false;
      var text = productText(p);
      return text.indexOf("safety signs") !== -1 || normalise(p.type).indexOf("safety sign") !== -1;
    }

    var stop = {
      a: 1, an: 1, and: 1, area: 1, australian: 1, be: 1, custom: 1,
      danger: 1, for: 1, general: 1, in: 1, label: 1, labels: 1,
      landscape: 1, mandatory: 1, must: 1, notice: 1, on: 1,
      pictogram: 1, portrait: 1, prohibition: 1, required: 1, safety: 1,
      sign: 1, signs: 1, site: 1, stencil: 1, stencils: 1, the: 1,
      this: 1, warning: 1, with: 1, your: 1
    };
    var titleTerms = unique(normalise(cfg.title).split(/\s+/).filter(function (word) {
      if (!word || stop[word]) return false;
      if (/^\d+(?:kph|kmh|v|kv)?$/.test(word)) return false;
      return word.length >= 3 || word === "no";
    }));
    var currentText = normalise([cfg.title, cfg.description, tagsText(cfg), cfg.type].join(" "));
    var familyTerm = {
      danger: "danger", mandatory: "mandatory", prohibition: "prohibition",
      warning: "warning", stencil: "stencil", electrical: "electrical labels"
    }[cfg.familyKey] || normalise(cfg.familyLabel);

    var queries = [];
    function addQuery(q) {
      q = String(q || "").replace(/\s+/g, " ").trim();
      if (q && queries.indexOf(q) === -1) queries.push(q);
    }
    addQuery(familyTerm + " " + titleTerms.slice(0, 4).join(" "));
    if (currentText.indexOf("volt") !== -1 || currentText.indexOf("voltage") !== -1) {
      addQuery((cfg.familyKey === "danger" ? "danger " : "") + "volts");
      addQuery((cfg.familyKey === "danger" ? "danger " : "") + "voltage");
    }
    if (currentText.indexOf("eye protection") !== -1) addQuery("mandatory eye protection");
    if (currentText.indexOf("no smoking") !== -1) addQuery("prohibition no smoking");
    if (currentText.indexOf("speed limit") !== -1 && cfg.familyKey === "stencil") addQuery("speed limit stencil");
    if (/\bsolar\b|\bpv\b/.test(currentText) && cfg.familyKey === "electrical") {
      addQuery("solar label");
      addQuery("pv label");
    }
    if (cfg.familyKey === "electrical") addQuery("electrical label");
    addQuery(familyTerm);
    if (cfg.familyKey !== "stencil" && cfg.familyKey !== "electrical") addQuery("safety signs");

    function search(query, queryIndex) {
      return fetch(apiBase + "/api/search/suggest?q=" + encodeURIComponent(query) + "&limit=24", {
        mode: "cors",
        credentials: "omit",
        headers: { Accept: "application/json" }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (data) {
          if (!data || data.ok !== true || data.visibilityPolicy !== "public-only-v1") {
            throw new Error("unsafe-search-index");
          }
          return (data.products || []).map(function (p, rank) {
            return { meta: p, handle: p.handle || spHandleFromUrl(p.url), queryIndex: queryIndex, rank: rank };
          });
        });
    }

    function productJson(candidate) {
      var url = shopRoot + "products/" + encodeURIComponent(candidate.handle) + ".js";
      return fetch(url, { headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (product) {
          product._meta = candidate.meta || {};
          product._searchOrder = candidate.queryIndex * 100 + candidate.rank;
          return product;
        });
    }

    function hydrateCandidates(candidates) {
      var limit = Math.min(18, candidates.length);
      var nextIndex = 0;
      var hydrated = [];
      function worker() {
        if (nextIndex >= limit) return Promise.resolve();
        var candidate = candidates[nextIndex++];
        return productJson(candidate)
          .then(function (product) { hydrated.push(product); })
          .catch(function () {})
          .then(worker);
      }
      return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
        return hydrated;
      });
    }

    var subjectGroups = [
      ["electrical", "electric", "voltage", "volt", "live wire", "power line", "switchboard"],
      ["fire"], ["first aid", "emergency"], ["chemical", "hazardous"], ["confined space"],
      ["forklift", "warehouse"], ["traffic", "parking"], ["speed", "vehicle"],
      ["construction"], ["ppe", "personal protective"], ["eye", "face protection"],
      ["hearing protection"], ["head protection"], ["foot protection"], ["hand protection"],
      ["respiratory"], ["security", "surveillance", "camera", "cctv"], ["food", "kitchen", "hygiene"],
      ["pool", "swimming"], ["marine", "boat"], ["gas", "cylinder"], ["asbestos"],
      ["radiation"], ["laser"], ["biohazard"], ["slip", "trip"], ["fall", "height"],
      ["smoking"], ["alcohol"], ["mobile phone"], ["authorised", "restricted"],
      ["evacuation", "exit"], ["defibrillator", "aed"]
    ];
    function hasAny(text, terms) {
      for (var i = 0; i < terms.length; i++) if (text.indexOf(terms[i]) !== -1) return true;
      return false;
    }
    function relevance(p) {
      var text = productText(p);
      var score = 0;
      titleTerms.forEach(function (term) { if (text.indexOf(term) !== -1) score += 5; });
      subjectGroups.forEach(function (group) {
        if (hasAny(currentText, group) && hasAny(text, group)) score += 4;
      });
      if ((currentText.indexOf("volt") !== -1 || currentText.indexOf("voltage") !== -1) &&
          (text.indexOf("volt") !== -1 || text.indexOf("voltage") !== -1)) score += 8;
      return score;
    }

    function card(p, index) {
      var meta = p._meta || {};
      var url = p.url || meta.url || (shopRoot + "products/" + p.handle);
      var image = p.featured_image || meta.image || "";
      if (image && typeof image === "object") image = image.src || image.url || "";
      var priceCents = Number(p.price_min != null ? p.price_min : p.price);
      var price = priceCents > 0
        ? '<div class="mt-3">' + (p.price_varies ? '<p class="text-[11px] font-medium text-black">From</p>' : "") +
          '<p class="font-display text-xl font-extrabold leading-none text-black">$' + (priceCents / 100).toFixed(2) + "</p></div>"
        : "";
       var hidden = index >= 4 ? ' class="hidden h-full xl:block"' : ' class="h-full"';
      return "<div" + hidden + ">" +
        '<div data-sp-card data-title="' + rEsc(p.title) + '" data-handle="' + rEsc(p.handle) + '" class="group flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-4 transition-all hover:-translate-y-1 hover:border-[var(--sp-blue)] hover:shadow-[0_22px_44px_-26px_rgba(83,95,251,0.55)]">' +
          '<a href="' + rEsc(url) + '" class="flex flex-1 flex-col">' +
            '<div class="flex min-h-[24px] items-start"></div>' +
            '<div class="mx-auto w-full pb-2 pt-1">' +
              (image ? '<img src="' + rEsc(image) + '" alt="' + rEsc(p.title) + '" loading="lazy" decoding="async" width="300" height="300" class="aspect-square w-full object-contain">' : '<span class="grid aspect-square w-full place-items-center rounded-xl bg-gray-50 text-gray-300"></span>') +
            "</div>" +
           '<div class="mt-3 flex flex-1 flex-col"><h3 class="min-h-[2.25rem] font-display text-[15px] font-bold leading-tight text-black">' + rEsc(p.title) + "</h3>" + price + "</div>" +
          "</a>" +
          '<a href="' + rEsc(url) + '" class="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-full border-2 border-white bg-[#16a34a] px-3.5 py-2 text-[13px] font-bold text-white transition-transform group-hover:scale-[1.02]">View product</a>' +
        "</div></div>";
    }

    Promise.all(queries.map(search))
      .then(function (sets) {
        var seen = Object.create(null);
        var candidates = [];
        sets.forEach(function (set) {
          set.forEach(function (candidate) {
            if (!candidate.handle || candidate.handle === cfg.handle || seen[candidate.handle]) return;
            if (candidate.handle.indexOf("custom-cut-") !== -1 || candidate.handle.indexOf("b2b-order-") !== -1) return;
            seen[candidate.handle] = 1;
            candidates.push(candidate);
          });
        });
        return hydrateCandidates(candidates);
      })
      .then(function (products) {
        products = products.filter(function (p) { return p && p.available && p.handle !== cfg.handle; });
        products.forEach(function (p) { p._relevance = relevance(p); });
        function order(a, b) {
          return b._relevance - a._relevance || a._searchOrder - b._searchOrder || String(a.title).localeCompare(String(b.title));
        }
        var strict = products.filter(strictFamily).sort(order);
        var selected = strict.slice(0, maxItems);
        if (selected.length < maxItems && cfg.familyKey !== "stencil" && cfg.familyKey !== "electrical") {
          var selectedHandles = Object.create(null);
          selected.forEach(function (p) { selectedHandles[p.handle] = 1; });
          products.filter(function (p) { return !selectedHandles[p.handle] && broadSafety(p); })
            .sort(order)
            .some(function (p) {
              selected.push(p);
              selectedHandles[p.handle] = 1;
              return selected.length >= maxItems;
            });
        }
        if (!selected.length) return;
        grid.innerHTML = selected.map(card).join("");
      })
      .catch(function () {
        // Keep the server-rendered, same-family fallback if catalogue search fails.
      });
  })();

  /* ---------- Click-to-play video ---------- */
  document.querySelectorAll("[data-video-embed]").forEach(function (box) {
    var btn = box.querySelector("[data-video-play]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var id = box.getAttribute("data-video-id");
      var title = box.getAttribute("data-video-title") || "";
      var iframe = document.createElement("iframe");
      iframe.className = "absolute inset-0 h-full w-full";
      iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("title", title);
      iframe.src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0";
      box.innerHTML = "";
      box.appendChild(iframe);
    });
  });

  /* ---------- Collection: AJAX filters/sort + infinite load + column switcher ---------- */
  (function () {
    var root = document.querySelector("[data-sp-collection]");
    if (!root) return;
    var sectionId = root.getAttribute("data-section-id");
    var baseUrl = root.getAttribute("data-base-url") || window.location.pathname;
    var COLS_KEY = "sp-cols";

    function prefs() {
      var d = 4, m = 2;
      try {
        var s = JSON.parse(localStorage.getItem(COLS_KEY) || "{}");
        if (s.desktop) d = parseInt(s.desktop, 10);
        if (s.mobile) m = parseInt(s.mobile, 10);
      } catch (e) {}
      if ([3, 4, 5].indexOf(d) === -1) d = 4;
      if ([1, 2].indexOf(m) === -1) m = 2;
      return { desktop: d, mobile: m };
    }
    function savePrefs(p) {
      try { localStorage.setItem(COLS_KEY, JSON.stringify(p)); } catch (e) {}
    }
    function applyCols() {
      var p = prefs();
      var grid = root.querySelector("[data-sp-grid]");
      if (grid) {
        grid.setAttribute("data-cols-desktop", p.desktop);
        grid.setAttribute("data-cols-mobile", p.mobile);
      }
      root.querySelectorAll("[data-sp-col-desktop]").forEach(function (b) {
        b.classList.toggle("sp-col-on", parseInt(b.getAttribute("data-sp-col-desktop"), 10) === p.desktop);
      });
      root.querySelectorAll("[data-sp-col-mobile]").forEach(function (b) {
        b.classList.toggle("sp-col-on", parseInt(b.getAttribute("data-sp-col-mobile"), 10) === p.mobile);
      });
    }

    function sectionUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set("section_id", sectionId);
      return u.toString();
    }
    function cleanUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete("section_id");
      return u.pathname + (u.search || "");
    }

    var busy = false;
    function setBusy(on) {
      busy = on;
      root.style.opacity = on ? "0.6" : "";
      root.style.pointerEvents = on ? "none" : "";
    }

    function updateProgress() {
      var grid = root.querySelector("[data-sp-grid]");
      // Count only cards actually visible (the client-side keyword search
      // hides non-matching cards with display:none).
      var shown = 0;
      if (grid) {
        Array.prototype.forEach.call(grid.children, function (card) {
          if (card.style && card.style.display === "none") return;
          shown++;
        });
      }
      var totalEl = root.querySelector("[data-sp-total]");
      var total = totalEl ? parseInt((totalEl.textContent || "").replace(/[^0-9]/g, ""), 10) : shown;
      root.querySelectorAll("[data-sp-shown]").forEach(function (el) { el.textContent = shown; });
      var bar = root.querySelector("[data-sp-progress]");
      if (bar && total) bar.style.width = Math.min(100, (shown / total) * 100) + "%";
    }

    // Sync sidebar checkbox states to a target URL's params. The sidebar is NOT
    // re-rendered on filter changes (so filter-value counts stay frozen at their
    // full/unfiltered totals — "union" counts), so we reconcile checked state here
    // to keep clear-all / chip-remove in sync with the persistent sidebar.
    function syncFiltersFromUrl(url) {
      var form = root.querySelector("[data-sp-filter-form]");
      if (!form) return;
      var u = new URL(url, window.location.origin);
      var active = {};
      u.searchParams.forEach(function (v, k) { active[k + "=" + v] = true; });
      form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (cb) {
        cb.checked = !!active[cb.name + "=" + cb.value];
      });
      syncAllLink();
      syncCollectionTitle();
      updateClearAll();
    }

    // Sync the page H1, breadcrumb dynamic crumb, and filter-count badge to the
    // currently-active tag filter. Only tag filters (name contains "filter.p.tag")
    // drive the H1; material, size, etc. are ignored.
    function syncCollectionTitle() {
      var form = root.querySelector("[data-sp-filter-form]");
      var header = document.querySelector("[data-sp-collection-header]");
      var baseTitle = header ? header.getAttribute("data-sp-base-title") : null;
      if (!baseTitle) return;

      // Find the active tag-filter radio label (sign category only)
      var activeTagLabel = null;
      if (form) {
        form.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
          if (radio.name.indexOf("filter.p.tag") !== -1) {
            var lbl = radio.closest("label");
            if (lbl) {
              var span = lbl.querySelector(".flex-1");
              if (span) activeTagLabel = (span.textContent || "").trim();
            }
          }
        });
      }

      // H1
      var h1 = document.querySelector("[data-sp-collection-title]");
      if (h1) h1.textContent = activeTagLabel || baseTitle;

      // Dynamic breadcrumb crumb
      var bcFilter = document.querySelector("[data-sp-bc-filter]");
      if (bcFilter) {
        if (activeTagLabel) {
          bcFilter.removeAttribute("hidden");
          var nameEl = bcFilter.querySelector("[data-sp-bc-filter-name]");
          if (nameEl) nameEl.textContent = activeTagLabel;
        } else {
          bcFilter.setAttribute("hidden", "");
        }
      }

      // Filter-count badge on the stable toggle button
      if (form) {
        var count = form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').length;
        root.querySelectorAll("[data-sp-filter-count]").forEach(function (badge) {
          badge.textContent = count || "";
          badge.style.display = count > 0 ? "" : "none";
        });
      }
    }

    // Keep "All" link visually in sync — active (filled) when no radio is checked,
    // inactive when any radio/checkbox in the same filter group is checked.
    function syncAllLink() {
      root.querySelectorAll("[data-sp-filter-all]").forEach(function (link) {
        var group = link.closest(".sp-filter-group") || link.closest("[data-sp-filter-groups]");
        var anyChecked = group ? !!group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') : false;
        if (anyChecked) {
          link.removeAttribute("data-sp-all-active");
        } else {
          link.setAttribute("data-sp-all-active", "1");
        }
      });
    }

    // Sidebar "Clear all" only shows while something can actually be cleared:
    // a checked filter radio/checkbox or text in the client-side search box.
    function updateClearAll() {
      var wrap = root.querySelector("[data-sp-clear-wrap]");
      if (!wrap) return;
      var anyChecked = !!root.querySelector('[data-sp-filter-form] input[type="radio"]:checked, [data-sp-filter-form] input[type="checkbox"]:checked');
      var input = root.querySelector("[data-sp-search]");
      var hasQuery = !!(input && (input.value || "").trim());
      wrap.style.display = anyChecked || hasQuery ? "" : "none";
    }

    function hasFilterParams() {
      var u = new URL(window.location.href);
      var found = false;
      u.searchParams.forEach(function (v, k) {
        if (k !== "sort_by" && k !== "page" && k !== "section_id" && k !== "q") found = true;
      });
      return found;
    }
    // When landing directly on a pre-filtered URL, the sidebar's per-value counts
    // are already narrowed (and zero-count values dropped). Fetch the unfiltered
    // section once and swap in its filter groups so counts reflect full totals and
    // every value is available — then re-check the active boxes from the URL.
    function hydrateUnfilteredSidebar() {
      fetch(sectionUrl(baseUrl), { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var freshGroups = doc.querySelector("[data-sp-filter-groups]");
          var groups = root.querySelector("[data-sp-filter-groups]");
          if (freshGroups && groups) {
            groups.innerHTML = freshGroups.innerHTML;
            syncFiltersFromUrl(window.location.href);
          }
        })
        .catch(function () {});
    }

    // If a swap is requested while one is in flight (fast successive filter
    // clicks), remember the latest URL and run it when the current one lands —
    // silently dropping it would leave the sidebar showing a filter that was
    // never actually applied.
    var pendingSwapUrl = null;
    function swap(url, skipHistory) {
      if (busy) { pendingSwapUrl = url; return; }
      setBusy(true);
      fetch(sectionUrl(url), { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          // :not([role="listbox"]) skips the suggestion dropdown which also carries
          // data-sp-results; the sort bar that contains it sits outside this zone.
          var freshResults = doc.querySelector("[data-sp-results]:not([role='listbox'])");
          var results = root.querySelector("[data-sp-results]:not([role='listbox'])");
          if (freshResults && results) {
            // Replace only the results column; leave the filter sidebar (and its
            // frozen counts) untouched.
            results.innerHTML = freshResults.innerHTML;
            syncFiltersFromUrl(url);
            // The "Showing X/Y" total (not the per-value counts) should reflect the
            // filtered set — copy it from the fresh results into every total slot.
            var rt = results.querySelector("[data-sp-total]");
            if (rt) {
              root.querySelectorAll("[data-sp-total]").forEach(function (el) {
                if (el !== rt) el.textContent = rt.textContent;
              });
            }
          } else {
            var fresh = doc.querySelector("[data-sp-collection]");
            if (fresh) root.innerHTML = fresh.innerHTML;
          }
          if (!skipHistory) { try { history.pushState({}, "", cleanUrl(url)); } catch (e) {} }
          applyCols();
          // applySearch() before updateProgress(): "Showing X/Y" counts only
          // the cards actually visible after the client-side keyword filter.
          applySearch();
          updateProgress();
          setBusy(false);
          if (pendingSwapUrl) {
            var next = pendingSwapUrl;
            pendingSwapUrl = null;
            swap(next, skipHistory);
            return;
          }
          var top = root.getBoundingClientRect().top + window.scrollY - 90;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: "smooth" });
        })
        .catch(function () { window.location.href = cleanUrl(url); });
    }

    // Collection keyword search — uses the same API as the header search bar when
    // data-sp-search-api is set on the wrapper (which it always is for collections).
    // Falls back to client-side token scoring if no API is configured.
    function applySearch() {
      // Input is now inside a [data-sp-search] wrapper; fall back to old selector for compat.
      var inputEl = root.querySelector("[data-sp-search-input]") || root.querySelector("[data-sp-search]");
      var grid = root.querySelector("[data-sp-grid]");
      if (!grid) return;
      var q = inputEl ? (inputEl.value || "").trim().toLowerCase() : "";
      var tokens = q ? q.split(/\s+/).filter(function (t) { return t.length > 0; }) : [];
      var visible = 0;

      if (!tokens.length) {
        // Empty query — restore all cards and clear search state.
        Array.prototype.forEach.call(grid.children, function (card) {
          if (card.style) card.style.display = "";
          visible++;
        });
        apLastQ = "";
        apLastHandles = null;
        apLastCorrected = null;
        hideCorrectedQuery();
        updateSearchEmpty(q, visible);
        updateClearAll();
        return;
      }

      var wrap = root.querySelector("[data-sp-search]");
      var apiBase = wrap ? (wrap.getAttribute("data-sp-search-api") || "").trim()
                        : (inputEl ? (inputEl.getAttribute("data-sp-search-api") || "").trim() : "");

      if (!apiBase) {
        // No API configured — fall back to client-side token scoring.
        var cards = Array.prototype.slice.call(grid.children);
        var scores = cards.map(function (card) {
          if (!card.hasAttribute || !card.hasAttribute("data-title")) return -1;
          var raw = (card.getAttribute("data-title") || "").toLowerCase();
          var norm = raw.replace(/[^a-z0-9]+/g, " ");
          return tokens.reduce(function (n, t) {
            return n + (raw.indexOf(t) !== -1 || norm.indexOf(t) !== -1 ? 1 : 0);
          }, 0);
        });
        var maxScore = 0;
        scores.forEach(function (s) { if (s > maxScore) maxScore = s; });
        var threshold = maxScore > 0 ? maxScore : tokens.length;
        cards.forEach(function (card, i) {
          if (scores[i] < 0) return;
          var show = scores[i] >= threshold;
          card.style.display = show ? "" : "none";
          if (show) visible++;
        });
        updateSearchEmpty(q, visible);
        updateClearAll();
        return;
      }

      // API-driven path — same search engine as the header bar.
      // Re-use cached handles when the query hasn't changed (e.g. loadMore calls
      // applySearch again with the same q after appending new cards).
      if (q === apLastQ && apLastHandles !== null) {
        applyHandleFilter(grid, apLastHandles, apLastCorrected);
        return;
      }

      // Debounce the fetch so rapid keystrokes don't spam the API.
      if (apTimer) clearTimeout(apTimer);
      apTimer = setTimeout(function () {
        var fq = input ? (input.value || "").trim().toLowerCase() : "";
        if (fq !== q) return; // query changed before timer fired
        apLastQ = fq;
        apLastHandles = null;
        if (apController) { try { apController.abort(); } catch (e) {} }
        apController = "AbortController" in window ? new AbortController() : null;
        var sig = apController ? apController.signal : undefined;

        function doFetch(searchQ, cb) {
          var url = apiBase + "/api/search/suggest?q=" + encodeURIComponent(searchQ) + "&limit=500";
          fetch(url, { signal: sig, headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (data) { cb(null, data); })
            .catch(function (err) { cb(err, null); });
        }

        doFetch(fq, function (err, data) {
          if (err && err.name === "AbortError") return;
          if ((input.value || "").trim().toLowerCase() !== fq) return; // stale
          var products = (data && data.products) || [];
          var corrected = (data && data.correctedQuery) || null;

          // Retry without last word if 0 results and ≥2 tokens (same as header).
          if (products.length === 0 && !corrected && tokens.length >= 2) {
            var shorter = tokens.slice(0, -1).join(" ");
            doFetch(shorter, function (err2, data2) {
              if (err2 && err2.name === "AbortError") return;
              if ((input.value || "").trim().toLowerCase() !== fq) return;
              var p2 = (data2 && data2.products) || [];
              var h2 = new Set(p2.map(function (p) { return p.handle; }));
              apLastHandles = h2;
              apLastCorrected = p2.length > 0 ? shorter : null;
              var g = root.querySelector("[data-sp-grid]");
              if (g) applyHandleFilter(g, h2, apLastCorrected);
            });
            return;
          }

          var handles = new Set(products.map(function (p) { return p.handle; }));
          apLastHandles = handles;
          apLastCorrected = corrected;
          var g = root.querySelector("[data-sp-grid]");
          if (g) applyHandleFilter(g, handles, corrected);
        });
      }, 150);
    }

    /* ---- API-driven collection search state ----------------------------- */
    var apTimer = null;
    var apController = null;
    var apLastQ = "";
    var apLastHandles = null; // null = not yet fetched; Set<string> once fetched
    var apLastCorrected = null;

    /* ---- No-results cross-suggestion ------------------------------------ */
    var seCache = Object.create(null);
    var seTimer = null;
    var seController = null;

    function seEsc(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function seNounFor(handleOrTitle) {
      var h = (handleOrTitle || "").toLowerCase();
      if (h.indexOf("label") !== -1) return "labels";
      if (h.indexOf("stencil") !== -1) return "stencils";
      return "signs";
    }
    function sePanel() { return root.querySelector("[data-sp-search-empty]"); }

    function seShow(html) {
      var panel = sePanel();
      if (!panel) return;
      panel.innerHTML = html;
      panel.classList.remove("hidden");
    }
    function seHide() {
      var panel = sePanel();
      if (!panel) return;
      panel.classList.add("hidden");
      panel.innerHTML = "";
    }
    // Returns the label text of the currently-checked sign-type radio (or null).
    function seActiveFilterLabel() {
      var form = root ? root.querySelector("[data-sp-filter-form]") : null;
      if (!form) return null;
      var radio = form.querySelector("input[type=radio]:checked");
      if (!radio) return null;
      var allLabels = form.querySelectorAll("label");
      for (var i = 0; i < allLabels.length; i++) {
        if (allLabels[i].querySelector("input[type=radio]:checked") === radio) {
          var nameSpan = allLabels[i].querySelector(".flex-1");
          return nameSpan ? nameSpan.textContent.trim() : radio.value;
        }
      }
      return radio.value;
    }
    function showCorrectedQuery(term) {
      var el = root.querySelector("[data-sp-corrected]");
      if (!el) return;
      el.innerHTML = "Showing results for &ldquo;<strong>" + seEsc(term) + "</strong>&rdquo;";
      el.classList.remove("hidden");
    }
    function hideCorrectedQuery() {
      var el = root.querySelector("[data-sp-corrected]");
      if (el) el.classList.add("hidden");
    }
    // Filter visible grid cards to those whose handle appears in the API result set.
    // Auto-loads more pages when matches are expected but not yet in the DOM.
    function applyHandleFilter(grid, handles, correctedQuery) {
      var visible = 0;
      Array.prototype.forEach.call(grid.children, function (card) {
        if (!card.getAttribute) return;
        var h = card.getAttribute("data-handle");
        if (h === null) return; // no handle attribute — leave unchanged
        var show = handles.size > 0 && handles.has(h);
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (correctedQuery) showCorrectedQuery(correctedQuery);
      else hideCorrectedQuery();
      // API found matches but none are in the DOM yet — keep loading pages.
      var btn = root.querySelector("[data-sp-loadmore]");
      if (visible === 0 && handles.size > 0 && btn && !btn.disabled) {
        loadMore();
        return;
      }
      var qInput = root.querySelector("[data-sp-search-input]") || root.querySelector("[data-sp-search]");
      var q = qInput ? (qInput.value || "").trim().toLowerCase() : "";
      updateSearchEmpty(q, visible);
      updateClearAll();
      updateProgress();
    }

    // Pick the best other collection: the one carrying the most matched
    // products, excluding the current collection and catch-all handles.
    function seBestCollection(products, currentHandle) {
      var tally = Object.create(null);
      var skip = { all: 1, frontpage: 1 };
      skip[currentHandle] = 1;
      products.forEach(function (p) {
        (p.collections || []).forEach(function (c) {
          if (!c || !c.handle || skip[c.handle]) return;
          if (!tally[c.handle]) tally[c.handle] = { n: 0, title: c.title, url: c.url, handle: c.handle };
          tally[c.handle].n++;
        });
      });
      var best = null;
      Object.keys(tally).forEach(function (h) {
        if (!best || tally[h].n > best.n) best = tally[h];
      });
      return best;
    }

    function seRender(term, data) {
      var panel = sePanel();
      if (!panel) return;
      var curTitle = panel.getAttribute("data-collection-title") || "this collection";
      var curNoun = panel.getAttribute("data-noun") || "signs";
      var count = (data && data.count) || 0;
      var termHtml = "&ldquo;" + seEsc(term) + "&rdquo;";

      if (!count) {
        seShow(
          '<p class="font-display text-xl font-extrabold text-black">No ' + termHtml + " " + curNoun + " found</p>" +
          '<p class="mt-2 text-sm text-black">We couldn&rsquo;t find any matches for ' + termHtml + ' anywhere in the store &mdash; but we can make it for you.</p>' +
          '<a href="/pages/request-a-quote" class="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white" style="background-image: var(--sp-grad-btn)">Request a custom sign <span aria-hidden="true">&rarr;</span></a>'
        );
        return;
      }

      var best = seBestCollection(data.products || [], panel.getAttribute("data-collection-handle") || "");
      var countLabel = count + (count === 1 ? " match" : " matches");
      if (best) {
        var noun = seNounFor(best.handle + " " + best.title);
        var target = best.url + (best.url.indexOf("?") > -1 ? "&" : "?") + "q=" + encodeURIComponent(term);
        seShow(
          '<p class="font-display text-xl font-extrabold text-black">No ' + termHtml + " " + curNoun + " in " + seEsc(curTitle) + "</p>" +
          '<p class="mt-2 text-sm text-black">But we found <strong>' + countLabel + "</strong> elsewhere in the store &mdash; most of them in <strong>" + seEsc(best.title) + "</strong>.</p>" +
          '<a href="' + seEsc(target) + '" class="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white" style="background-image: var(--sp-grad-btn)">View ' + seEsc(best.title) + " " + noun + ' <span aria-hidden="true">&rarr;</span></a>'
        );
      } else {
        var searchUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") +
          "search?q=" + encodeURIComponent(term) + "&type=product";
        seShow(
          '<p class="font-display text-xl font-extrabold text-black">No ' + termHtml + " " + curNoun + " in " + seEsc(curTitle) + "</p>" +
          '<p class="mt-2 text-sm text-black">But we found <strong>' + countLabel + "</strong> elsewhere in the store.</p>" +
          '<a href="' + seEsc(searchUrl) + '" class="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white" style="background-image: var(--sp-grad-btn)">See all results <span aria-hidden="true">&rarr;</span></a>'
        );
      }
    }

    // Render inline product cards when a sign-type filter returned 0 results.
    function seRenderFiltered(term, filterLabel, products, curNoun) {
      var termHtml = "&ldquo;" + seEsc(term) + "&rdquo;";
      if (!products || products.length === 0) {
        seShow(
          '<p class="font-display text-xl font-extrabold text-black">No ' + termHtml + " " + seEsc(curNoun) + " in " + seEsc(filterLabel) + "</p>" +
          '<p class="mt-2 text-sm text-black">We couldn&rsquo;t find any similar signs across the store &mdash; but we can make it for you.</p>' +
          '<a href="/pages/request-a-quote" class="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white" style="background-image: var(--sp-grad-btn)">Request a custom sign <span aria-hidden="true">&rarr;</span></a>'
        );
        return;
      }
      var cardsHtml = products.slice(0, 8).map(function (p) {
        var imgHtml = p.image
          ? '<img src="' + seEsc(p.image) + '" alt="' + seEsc(p.title) + '" loading="lazy" width="200" height="200" class="h-full w-full object-contain p-2 transition-transform duration-300 group-hover:scale-105">'
          : '<div class="h-full w-full bg-gray-100 flex items-center justify-center text-gray-300"><svg xmlns=\'http://www.w3.org/2000/svg\' class=\'h-8 w-8\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'currentColor\'><path stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z\'/></svg></div>';
        var priceHtml = p.poa
          ? '<span class="text-xs font-semibold text-[var(--sp-purple)]">Get instant price</span>'
          : (p.priceMin != null ? '<span class="text-xs font-semibold text-black">From $' + p.priceMin.toFixed(2) + '</span>' : '');
        var catHtml = p.category ? '<span class="mt-0.5 block truncate text-[10px] text-gray-400">' + seEsc(p.category) + '</span>' : '';
        return '<a href="' + seEsc(p.url) + '" class="group flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white transition-all hover:-translate-y-0.5 hover:border-[var(--sp-blue)] hover:shadow-md">' +
          '<div class="aspect-square bg-gray-50">' + imgHtml + '</div>' +
          '<div class="p-2.5">' +
            '<p class="line-clamp-2 text-xs font-bold leading-tight text-black group-hover:text-[var(--sp-blue)]">' + seEsc(p.title) + '</p>' +
            catHtml +
            '<div class="mt-1.5">' + priceHtml + '</div>' +
          '</div>' +
          '</a>';
      }).join('');
      seShow(
        '<div class="text-left">' +
          '<p class="font-display text-xl font-extrabold text-black">No ' + termHtml + ' ' + seEsc(curNoun) + ' in ' + seEsc(filterLabel) + '</p>' +
          '<p class="mt-2 mb-5 text-sm text-black">However, here are some ' + seEsc(curNoun) + ' that are close:</p>' +
          '<div class="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">' + cardsHtml + '</div>' +
        '</div>'
      );
    }
    // Fetch cross-collection suggestions from the API and render inline cards.
    function seLookupFiltered(term, apiBase, filterLabel, curNoun) {
      var cacheKey = "\x00f\x00" + term; // distinct from seCache[term] (unfiltered)
      if (seCache[cacheKey] !== undefined) {
        seRenderFiltered(term, filterLabel, seCache[cacheKey], curNoun);
        return;
      }
      seShow(
        '<p class="text-sm font-semibold text-gray-400">No ' + seEsc(term) + ' ' + seEsc(curNoun) +
        ' in ' + seEsc(filterLabel) + ' &mdash; checking other sign types&hellip;</p>'
      );
      if (seController) { try { seController.abort(); } catch (e) {} }
      seController = "AbortController" in window ? new AbortController() : null;
      var url = apiBase + "/api/search/suggest?q=" + encodeURIComponent(term) + "&limit=12";
      fetch(url, { signal: seController ? seController.signal : undefined, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          seCache[cacheKey] = products;
          var input = root.querySelector("[data-sp-search]");
          if (!input || (input.value || "").trim().toLowerCase() !== term) return;
          var fl = seActiveFilterLabel() || filterLabel;
          var panel = sePanel();
          var noun = panel ? (panel.getAttribute("data-noun") || "signs") : "signs";
          seRenderFiltered(term, fl, products, noun);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          // Fall back to the existing store-wide count approach.
          seLookup(term);
        });
    }
    function seLookup(term) {
      if (seCache[term]) { seRender(term, seCache[term]); return; }
      seShow('<p class="text-sm font-semibold text-gray-400">Checking the rest of the store for &ldquo;' + seEsc(term) + '&rdquo;&hellip;</p>');
      if (seController) seController.abort();
      seController = "AbortController" in window ? new AbortController() : null;
      var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") +
        "search?q=" + encodeURIComponent(term) + "&type=product&view=sp-count";
      fetch(url, { signal: seController ? seController.signal : undefined, headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        })
        .then(function (data) {
          seCache[term] = data;
          var input = root.querySelector("[data-sp-search]");
          if (!input || (input.value || "").trim().toLowerCase() !== term) return;
          seRender(term, data);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          var input = root.querySelector("[data-sp-search]");
          if (!input || (input.value || "").trim().toLowerCase() !== term) return;
          var searchUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") +
            "search?q=" + encodeURIComponent(term) + "&type=product";
          seShow(
            '<p class="font-display text-xl font-extrabold text-black">No matches here for &ldquo;' + seEsc(term) + '&rdquo;</p>' +
            '<p class="mt-2 text-sm text-black">Try searching the whole store instead.</p>' +
            '<a href="' + seEsc(searchUrl) + '" class="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white" style="background-image: var(--sp-grad-btn)">Search all signs <span aria-hidden="true">&rarr;</span></a>'
          );
        });
    }

    function updateSearchEmpty(q, visible) {
      if (seTimer) { clearTimeout(seTimer); seTimer = null; }
      if (!q || visible > 0) {
        if (seController) { seController.abort(); seController = null; }
        seHide();
        return;
      }
      // More pages exist — a match may simply not be loaded yet. Keep chasing
      // them before declaring "no results" (loadMore() re-runs applySearch()).
      var btn = root.querySelector("[data-sp-loadmore]");
      if (btn) {
        seHide();
        if (!btn.disabled) loadMore();
        return;
      }
      seTimer = setTimeout(function () {
        var input = root.querySelector("[data-sp-search]");
        if (!input || (input.value || "").trim().toLowerCase() !== q) return;
        var fl = seActiveFilterLabel();
        var ab = (input.getAttribute("data-sp-search-api") || "").trim();
        if (fl && ab) {
          // Active sign-type filter + 0 results: show inline cross-collection cards.
          var panel = sePanel();
          var noun = panel ? (panel.getAttribute("data-noun") || "signs") : "signs";
          seLookupFiltered(q, ab, fl, noun);
        } else {
          // No active filter: existing store-wide count + best-collection link.
          if (seCache[q]) { seRender(q, seCache[q]); return; }
          seLookup(q);
        }
      }, 300);
    }

    function formUrl() {
      var form = root.querySelector("[data-sp-filter-form]");
      if (!form) return baseUrl;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (v !== "" && v != null) params.append(k, v);
      });
      var qs = params.toString();
      return baseUrl + (qs ? "?" + qs : "");
    }

    function loadMore() {
      var btn = root.querySelector("[data-sp-loadmore]");
      if (!btn || btn.disabled) return;
      var next = btn.getAttribute("data-next-url");
      if (!next) return;
      btn.disabled = true;
      var label = btn.querySelector("[data-sp-loadmore-label]");
      var spin = btn.querySelector("[data-sp-loadmore-spinner]");
      var idleLabel = btn.getAttribute("data-label") || "Load more signs";
      if (label) label.textContent = "Loading…";
      if (spin) spin.classList.remove("hidden");
      fetch(sectionUrl(next), { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // The results column may have been swapped (filter change) while
          // this page was in flight — the old button is then detached from
          // the DOM. Appending stale cards into the new grid would mix
          // filtered and unfiltered products; abandon this response instead.
          if (!btn.isConnected) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var freshGrid = doc.querySelector("[data-sp-grid]");
          var grid = root.querySelector("[data-sp-grid]");
          if (freshGrid && grid) {
            while (freshGrid.firstElementChild) grid.appendChild(freshGrid.firstElementChild);
          }
          var freshBtn = doc.querySelector("[data-sp-loadmore]");
          var newNext = freshBtn ? freshBtn.getAttribute("data-next-url") : "";
          applySearch();
          updateProgress();
          if (newNext) {
            btn.setAttribute("data-next-url", newNext);
            btn.disabled = false;
            if (label) label.textContent = idleLabel;
            if (spin) spin.classList.add("hidden");
          } else {
            btn.remove();
          }
        })
        .catch(function () {
          btn.disabled = false;
          if (label) label.textContent = idleLabel;
          if (spin) spin.classList.add("hidden");
        });
    }

    // Close the mobile filter panel (no-op on desktop where the toggle is hidden).
    function closeFilterPanel() {
      var tg = root.querySelector("[data-sp-filter-toggle]");
      if (!tg || tg.offsetParent === null) return; // desktop — panel always visible
      var panel = root.querySelector("[data-sp-filter-panel]");
      if (panel && !panel.classList.contains("hidden")) {
        panel.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
        var flabel = tg.querySelector("[data-sp-filter-label]");
        if (flabel) flabel.textContent = "Filter signs";
        if (filterLastFocus) {
          try { filterLastFocus.focus(); } catch (err) {}
          filterLastFocus = null;
        }
      }
    }

    // Delegated change → filters + sort apply via AJAX (the client-side search
    // input lives inside the form but must never trigger a server round-trip).
    root.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.hasAttribute && (t.hasAttribute("data-sp-search-input") || t.hasAttribute("data-sp-search"))) return;
      if (t.closest("[data-sp-filter-form]")) {
        // Tag filters are conjunctive on Shopify (a product must carry ALL selected
        // tags), and sign-type tags are mutually exclusive — so ticking two tags can
        // only return 0 results. Make tag checkboxes behave single-select instead.
        if (t.type === "checkbox" && t.checked && t.name && t.name.indexOf("filter.p.tag") === 0) {
          var grp = t.closest(".sp-filter-group") || t.closest("[data-sp-filter-form]");
          grp.querySelectorAll('input[type="checkbox"][name^="filter.p.tag"]').forEach(function (cb) {
            if (cb !== t) cb.checked = false;
          });
        }
        swap(formUrl());
        closeFilterPanel();
      }
    });

    // Instant client-side title search as the user types.
    root.addEventListener("input", function (e) {
      var t = e.target;
      if (t && t.hasAttribute && (t.hasAttribute("data-sp-search-input") || t.hasAttribute("data-sp-search"))) { applySearch(); updateProgress(); }
    });
    // Enter in the search box must not submit the filter form.
    root.addEventListener("keydown", function (e) {
      var t = e.target;
      if (e.key === "Enter" && t && t.hasAttribute && (t.hasAttribute("data-sp-search-input") || t.hasAttribute("data-sp-search"))) e.preventDefault();
    });

    // Delegated click → load more, column switcher, mobile toggle, filter links
    root.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var tg = t.closest("[data-sp-filter-toggle]");
      if (tg) {
        var panel = root.querySelector("[data-sp-filter-panel]");
        if (panel) {
          filterLastFocus = tg;
          var hidden = panel.classList.toggle("hidden");
          document.body.classList.toggle("overflow-hidden", !hidden);
          var flabel = tg.querySelector("[data-sp-filter-label]");
          if (flabel) flabel.textContent = hidden ? "Filter signs" : "Hide filters";
        }
        return;
      }

      var filterClose = t.closest("[data-sp-filter-close]");
      if (filterClose) {
        e.preventDefault();
        closeFilterPanel();
        return;
      }

      var lm = t.closest("[data-sp-loadmore]");
      if (lm) { e.preventDefault(); loadMore(); return; }

      var cd = t.closest("[data-sp-col-desktop]");
      if (cd) {
        var p = prefs(); p.desktop = parseInt(cd.getAttribute("data-sp-col-desktop"), 10);
        savePrefs(p); applyCols(); return;
      }
      var cm = t.closest("[data-sp-col-mobile]");
      if (cm) {
        var p2 = prefs(); p2.mobile = parseInt(cm.getAttribute("data-sp-col-mobile"), 10);
        savePrefs(p2); applyCols(); return;
      }

      var fl = t.closest("[data-sp-filter-link]");
      if (fl) {
        var href = fl.getAttribute("href");
        if (href) { e.preventDefault(); swap(href); closeFilterPanel(); }
      }
    });

    window.addEventListener("popstate", function () {
      swap(window.location.pathname + window.location.search, true);
    });

    applyCols();
    updateProgress();
    // Arriving with ?q= (e.g. from another collection's no-results suggestion)
    // pre-fills the search box; applySearch() then filters and, if needed,
    // auto-loads the remaining pages so the whole collection is searched.
    try {
      var qParam = new URLSearchParams(window.location.search).get("q");
      if (qParam) {
        var qInput = root.querySelector("[data-sp-search-input]") || root.querySelector("[data-sp-search]");
        if (qInput && !qInput.value) qInput.value = qParam;
      }
    } catch (e) {}
    applySearch();
    if (hasFilterParams()) hydrateUnfilteredSidebar();
  })();

  /* ---------- Home: vertical coverflow auto-scroll + manual controls ---------- */
  var spReduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll(".sp-vflow").forEach(function (vf) {
    var trackEls = vf.querySelectorAll(".sp-vflow-track");
    if (!trackEls.length) return;
    var wrap = vf.closest("[data-sp-vflow-wrap]") || vf.parentElement;
    var upBtn = wrap ? wrap.querySelector("[data-sp-vflow-up]") : null;
    var downBtn = wrap ? wrap.querySelector("[data-sp-vflow-down]") : null;

    var items = [];
    trackEls.forEach(function (t, i) {
      t.style.animation = "none"; // JS takes over the CSS keyframe scroll
      var card = t.children[0];
      items.push({
        el: t,
        pos: 0,
        half: t.scrollHeight / 2,
        step: card ? card.offsetHeight + 20 : 200,
        dur: i === 0 ? 34 : 44 // seconds for one full loop (mirrors the old CSS)
      });
    });

    var hoverPause = false, manualPause = false;
    var hoverTarget = wrap || vf; // includes the buttons so aiming/clicking keeps it paused
    hoverTarget.addEventListener("mouseenter", function () { hoverPause = true; });
    hoverTarget.addEventListener("mouseleave", function () { hoverPause = false; });

    function refresh(it) { if (!it.half || it.half < 1) it.half = it.el.scrollHeight / 2; }
    function norm(it) {
      if (it.half < 1) return;
      while (it.pos >= it.half) it.pos -= it.half;
      while (it.pos < 0) it.pos += it.half;
    }
    function setInstant(it) { it.el.style.transition = "none"; it.el.style.transform = "translateY(" + (-it.pos) + "px)"; }

    var last = null;
    function frame(ts) {
      if (last == null) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if (!hoverPause && !manualPause && !spReduceMotion) {
        items.forEach(function (it) {
          refresh(it);
          if (it.half >= 1) { it.pos += (it.half / it.dur) * dt; norm(it); setInstant(it); }
        });
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    function step(dir) {
      if (manualPause) return; // ignore rapid clicks mid-transition
      manualPause = true;
      items.forEach(function (it) {
        refresh(it);
        if (it.half < 1) return;
        // keep within range so the eased step never crosses the loop seam
        if (dir < 0 && it.pos - it.step < 0) { it.pos += it.half; setInstant(it); }
        if (dir > 0 && it.pos + it.step >= it.half) { it.pos -= it.half; setInstant(it); }
      });
      void vf.offsetHeight; // commit the seam reset before animating
      items.forEach(function (it) {
        it.pos += dir * it.step;
        it.el.style.transition = "transform 0.5s ease";
        it.el.style.transform = "translateY(" + (-it.pos) + "px)";
      });
      setTimeout(function () {
        items.forEach(function (it) { norm(it); setInstant(it); });
        manualPause = false;
      }, 540);
    }

    if (upBtn) { upBtn.classList.remove("hidden"); upBtn.addEventListener("click", function () { step(-1); }); }
    if (downBtn) { downBtn.classList.remove("hidden"); downBtn.addEventListener("click", function () { step(1); }); }
  });

  /* ---------- Product page: gallery + variants + qty + add to cart ---------- */
  document.querySelectorAll("[data-sp-product]").forEach(function (root) {
    // Thumbnail → main image
    var mainImg = root.querySelector("[data-sp-main-image]");
    function setGalleryImage(src) {
      if (!mainImg || !src) return;
      // The initial Liquid image has responsive candidates for the first photo.
      // Clear them when changing photos, otherwise currentSrc can ignore src.
      mainImg.removeAttribute("srcset");
      mainImg.removeAttribute("sizes");
      mainImg.src = src;
    }
    root.querySelectorAll("[data-sp-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setGalleryImage(btn.getAttribute("data-sp-thumb"));
        root.querySelectorAll("[data-sp-thumb]").forEach(function (b) {
          b.className = "rounded-lg border p-2 transition border-gray-200 bg-white hover:border-gray-400";
        });
        btn.className = "rounded-lg border-2 border-[var(--sp-blue)] bg-white p-2 transition";
      });
    });

    // Quantity stepper
    var qty = root.querySelector("[data-sp-qty]");
    var minus = root.querySelector("[data-sp-qty-minus]");
    var plus = root.querySelector("[data-sp-qty-plus]");
    if (minus && qty) minus.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (plus && qty) plus.addEventListener("click", function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    // Variant selection
    var variants = [];
    try {
      var raw = root.querySelector("[data-sp-variants]");
      if (raw) variants = JSON.parse(raw.textContent);
    } catch (e) { variants = []; }
    var idField = root.querySelector("[data-sp-variant-id]");
    var priceEl = root.querySelector("[data-sp-price]");
    var compareEl = root.querySelector("[data-sp-compare]");
    var addBtn = root.querySelector("[data-sp-add]");
    var addLabel = root.querySelector("[data-sp-add-label]");
    var skuEl = root.querySelector("[data-sp-sku]");
    var skuRow = root.querySelector("[data-sp-sku-row]");

    // AJAX add to cart → refresh cart count.
    // Registered FIRST — before any variant/tier wiring below — so that an
    // exception anywhere later in this init can never leave the form without
    // its submit handler (which would fall back to the native submit and
    // redirect the customer to /cart). vt / vtQty / vtConfigureAdd are
    // hoisted declarations from further down in this same scope; if the
    // vtiers wiring never ran, vt is simply undefined and the handler takes
    // the plain native-variant AJAX path.
    var form = root.querySelector("#sp-product-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        // Acrylic, Labels and the generic backend calculator use their own server-pricing
        // submit. Always block the native add here so a failed init can never silently add the
        // base ($0) variant.
        if (form.querySelector("[data-sp-acrylic-calc]") || form.querySelector("[data-sp-labels-calc]") || form.querySelector("[data-sp-acrylicprint-calc]") || form.querySelector("[data-sp-acm-calc]") || form.querySelector("[data-sp-stickers-calc]") || form.querySelector("[data-sp-lettering-calc]") || form.querySelector("[data-sp-cutsize-calc]") || form.querySelector("[data-sp-mesh-calc]") || form.querySelector("[data-sp-bragmat-calc]") || form.querySelector("[data-sp-calc]")) { e.preventDefault(); return; }
        if (e.submitter && e.submitter !== addBtn) return;
        // Quantity-tier products: discounts (5+) and every drilled Safety Sign
        // must be priced by the backend so the checkout charge is authoritative.
        if (vt && (vtQty() >= 5 || mountingHolesCode() !== "none")) {
          e.preventDefault();
          vtConfigureAdd(vtQty());
          return;
        }
        e.preventDefault();
        spCartBtn(addBtn, "loading");
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (!m) return;
          if (el.disabled) return;
          if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
          // Blank line-item properties are noise in checkout. In particular,
          // Safety Sign "No Holes" is intentionally represented by no metadata.
          if (el.value === "") return;
          props[m[1]] = el.value;
        });
        var payload = { id: idField.value, quantity: parseInt(qty ? qty.value : 1, 10) || 1 };
        if (Object.keys(props).length) payload.properties = props;
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json(); })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function () { window.location.href = "/cart"; });
      });
    }

    function money(cents) {
      return "$" + (cents / 100).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll("[data-sp-option]").forEach(function (input) {
        var idx = parseInt(input.getAttribute("data-sp-option"), 10) - 1;
        if (input.tagName === "SELECT") opts[idx] = input.value;
        else if (input.checked) opts[idx] = input.value;
      });
      return opts;
    }
    function highlight() {
      root.querySelectorAll("[data-sp-option]").forEach(function (input) {
        if (input.tagName !== "INPUT") return; // dropdown options (vtiers) need no pill styling
        var label = input.closest("label");
        if (!label) return;
        if (input.checked) label.className = "flex items-center gap-3 cursor-pointer rounded-xl border-2 px-4 py-2.5 text-sm font-bold transition border-[var(--sp-blue)] bg-[var(--sp-light)]/40 text-black";
        else label.className = "flex items-center gap-3 cursor-pointer rounded-xl border-2 px-4 py-2.5 text-sm font-bold transition border-gray-200 text-black hover:border-gray-300";
      });
    }
    function update() {
      highlight();
      if (!variants.length) return;
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === sel[i]; });
      });
      if (!match) match = variants[0];
      if (idField) idField.value = match.id;
      // Sync gallery image to the variant's featured image (if it has one)
      if (match.featured_image && mainImg) {
        var fi = match.featured_image;
        var thumbBtns = Array.from(root.querySelectorAll("[data-sp-thumb]"));
        var targetBtn = thumbBtns[fi.position - 1] || null;
        if (targetBtn) {
          setGalleryImage(targetBtn.getAttribute("data-sp-thumb"));
          thumbBtns.forEach(function (b) {
            b.className = "rounded-lg border p-2 transition border-gray-200 bg-white hover:border-gray-400";
          });
          targetBtn.className = "rounded-lg border-2 border-[var(--sp-blue)] bg-white p-2 transition";
        } else {
          setGalleryImage(fi.src);
        }
      }
      syncMountingHoles();
      if (priceEl) priceEl.textContent = money(match.price + mountingHolesSurchargeCents());
      if (compareEl) compareEl.style.display = match.compare_at_price > match.price ? "" : "none";
      if (compareEl && match.compare_at_price > match.price) compareEl.textContent = money(match.compare_at_price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? "Add to cart" : "Sold out";
      }
      if (skuEl) skuEl.textContent = match.sku || "";
      if (skuRow) skuRow.style.display = match.sku ? "" : "none";
      root.querySelectorAll("[data-sp-opt-price]").forEach(function (el) {
        var pos = parseInt(el.getAttribute("data-sp-opt-pos"), 10);
        var val = el.getAttribute("data-sp-opt-val");
        var cand = variants.find(function (v) {
          return (v.options || []).every(function (o, i) {
            return i === pos - 1 ? o === val : o === sel[i];
          });
        });
        if (!cand) cand = variants.find(function (v) { return (v.options || [])[pos - 1] === val; });
        if (cand) el.textContent = money(cand.price);
      });
      // Keep Safety Sign mounting-hole eligibility current for both user-driven
      // and programmatic variant/material updates.
      vtRepaint();
    }
    root.querySelectorAll("[data-sp-option]").forEach(function (input) {
      input.addEventListener("change", update);
    });
    root.querySelectorAll("[data-sp-mounting-holes-select]").forEach(function (input) {
      input.addEventListener("change", update);
    });

    /* ---------- Quantity-tier pricing (vtiers) — calculator-style panel on standard priced products ----------
       Tiers: 1–4 none, 5–9 5%, 10–19 10%, 20+ 15% off the native variant price
       (shop tax basis). Display only here; the REAL discounted charge is made by the
       pricing backend at submit time (see the form handler below). */
    var vt = root.querySelector("[data-sp-vtiers]");
    var vtErrEl = vt ? vt.querySelector("[data-sp-vt-error]") : null;
    function mountingHolesMaterial() {
      var material = "";
      var materialControl = root.querySelector("[data-sp-vt-material]");
      if (!materialControl) {
        var optionControls = root.querySelectorAll("[data-sp-option][data-sp-opt-name]");
        for (var i = 0; i < optionControls.length; i++) {
          var optionName = optionControls[i].getAttribute("data-sp-opt-name") || "";
          if (/material/i.test(optionName) && (optionControls[i].tagName === "SELECT" || optionControls[i].checked)) {
            materialControl = optionControls[i];
            break;
          }
        }
      }
      // Legacy app-configured Safety Signs post their material as a property,
      // rather than as a Shopify variant option.
      if (!materialControl) materialControl = root.querySelector('select[name*="[Material]"], input[name*="[Material]"]:checked');
      if (materialControl) material = materialControl.value || "";
      return material;
    }
    function materialSupportsMountingHoles(material) {
      // Material labels include punctuation and a leading or trailing thickness
      // in some catalogues. Strip only that thickness, then match the approved
      // aliases exactly so, for example, an arbitrary "ACP-like" material is
      // not mistakenly offered drilling.
      var materialLabel = String(material || "").toLowerCase().trim();
      materialLabel = materialLabel
        .replace(/^\d+(?:\.\d+)?\s*(?:mm|micron|um)\s*/, "")
        .replace(/\s*\d+(?:\.\d+)?\s*(?:mm|micron|um)$/, "")
        .trim();
      // This is a confirmed live label and the only approved parenthetical
      // alias. Other qualifiers must remain part of the value and fail the
      // exact canonical-material match below.
      if (materialLabel.replace(/\s+/g, " ") === "aluminium composite panel (acp)") {
        materialLabel = "aluminium composite panel";
      }
      var normalized = materialLabel.replace(/[^a-z0-9]+/g, "");
      return [
        "acp",
        "aluminiumcompositepanel",
        "polypropylene",
        // Some legacy Safety Sign variants retain this catalogue misspelling.
        "polyproperlene",
        "aluminium",
        "foampvc",
        "corflute",
        "reflectivealuminiumcomposite",
        "c1reflectivealuminiumcompositepanelacp",
        "c2reflectivealuminiumcompositepanelacp"
      ].indexOf(normalized) !== -1;
    }
    function mountingHolesCode() {
      var select = root.querySelector("[data-sp-mounting-holes-select]");
      var value = select && !select.disabled ? select.value : "";
      if (/^2 x 5mm Holes/i.test(value)) return "two_top_bottom_center";
      if (/^4 x 5mm Holes/i.test(value)) return "four_corners";
      return "none";
    }
    function mountingHolesSurchargeCents() {
      // Preserve the configure service's native-price surcharge contract.
      // Tax display below follows shop.taxes_included, not an assumed basis.
      return mountingHolesCode() === "none" ? 0 : 330;
    }
    function syncMountingHoles() {
      root.querySelectorAll("[data-sp-mounting-holes]").forEach(function (field) {
        var select = field.querySelector("[data-sp-mounting-holes-select]");
        if (!select) return;
        var supported = materialSupportsMountingHoles(mountingHolesMaterial());
        field.hidden = !supported;
        select.disabled = !supported;
        if (!supported) select.value = "";
         var rich = select._spMountingHolesRichSelect;
         var richButton = field.querySelector(".sp-rsel-btn");
         if (richButton) richButton.disabled = !supported;
         if (rich) rich.sync();
      });
    }
    function vtShowErr(msg) {
      if (!vtErrEl) return;
      vtErrEl.textContent = msg;
      vtErrEl.classList.remove("hidden");
    }
    function vtClearErr() {
      if (!vtErrEl) return;
      vtErrEl.textContent = "";
      vtErrEl.classList.add("hidden");
    }
    function vtQty() {
      return Math.max(1, parseInt(qty ? qty.value : 1, 10) || 1);
    }
    function vtVariant() {
      if (!variants.length) return null;
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === sel[i]; });
      });
      return match || variants[0];
    }
    function vtTierDiscount(q) {
      return q >= 20 ? 0.15 : q >= 10 ? 0.1 : q >= 5 ? 0.05 : 0;
    }
    // Per-unit native Shopify cents, discounted then rounded to the cent —
    // must mirror the backend's /api/variant/configure math exactly.
    function vtUnitCents(baseCents, q) {
      return Math.max(1, Math.round(baseCents * (1 - vtTierDiscount(q))) + mountingHolesSurchargeCents());
    }
    function vtRepaint() {
      if (!vt) return;
      syncMountingHoles();
      var m = vtVariant();
      if (!m || !(m.price > 0)) { spClearLead(vt); return; }
      var q = vtQty();
      vt.setAttribute("data-sp-native-taxable", m.taxable === false ? "false" : "true");
      var base = (m.price + mountingHolesSurchargeCents()) / 100;
      var per = vtUnitCents(m.price, q) / 100;
      spRenderLead(vt, per, base, q);
      spRenderTiers(vt, [
        { qtyMin: 1, qtyMax: 4, qtyLabel: "1\u20134", perPiece: vtUnitCents(m.price, 1) / 100 },
        { qtyMin: 5, qtyMax: 9, qtyLabel: "5\u20139", perPiece: vtUnitCents(m.price, 5) / 100 },
        { qtyMin: 10, qtyMax: 19, qtyLabel: "10\u201319", perPiece: vtUnitCents(m.price, 10) / 100 },
        { qtyMin: 20, qtyMax: null, qtyLabel: "20+", perPiece: vtUnitCents(m.price, 20) / 100 }
      ], q, base);
      var amounts = window.SignPortalNativeTax.breakdown(
        vtUnitCents(m.price, q) * q,
        vt.getAttribute("data-sp-taxes-included") === "true",
        m.taxable !== false && vt.getAttribute("data-sp-charge-gst") !== "false"
      );
      var total = amounts.total / 100;
      var sell = amounts.subtotal / 100;
      var sellEl = vt.querySelector("[data-sp-vt-sell]");
      var gstEl = vt.querySelector("[data-sp-vt-gst]");
      var totalEl = vt.querySelector("[data-sp-vt-total]");
      if (sellEl) sellEl.textContent = spMoney(sell);
      if (gstEl) gstEl.textContent = spMoney(amounts.gst / 100);
      if (totalEl) totalEl.textContent = spMoney(total);
    }
    // Backend-priced add for discounted quantities (5+). No silent fallback:
    // any failure shows an error and adds NOTHING (never add at full price).
    function vtConfigureAdd(q) {
      var apiBase = (vt.getAttribute("data-sp-vt-api") || "").trim().replace(/\/+$/, "");
      vtClearErr();
      if (!apiBase) { vtShowErr("Online pricing is temporarily unavailable. Please contact us to place this order."); return; }
      var m = vtVariant();
      if (!m) { vtShowErr("Please select the product options."); return; }
      spCartBtn(addBtn, "loading");
      fetch(apiBase + "/api/variant/configure", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ variantId: String(m.id), qty: q, mountingHoles: mountingHolesCode() })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || !res.body.variantId) {
            throw new Error((res.body && res.body.error) || "We couldn't apply the quantity discount. Please try again.");
          }
          var props = {};
          // The transient product has no options — post the real selections as
          // line-item properties so the cart/checkout line shows the full spec.
          root.querySelectorAll("select[data-sp-option]").forEach(function (s) {
            var n = s.getAttribute("data-sp-opt-name");
            if (n) props[n] = s.value;
          });
          form.querySelectorAll('[name^="properties["]').forEach(function (el) {
            if (el.disabled) return;
            var mm = el.name.match(/^properties\[(.+)\]$/);
            if (mm && el.value !== "") props[mm[1]] = el.value;
          });
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
           body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || q, properties: (props._sp_original_url = root.getAttribute("data-sp-vt-url") || "", props) })
          }).then(function (r) {
            if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
            return r.json();
          });
        })
        .then(function () {
          spCartBtn(addBtn, "done");
          document.dispatchEvent(new Event("cart:refresh"));
          setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
        })
        .catch(function (err) {
          vtShowErr((err && err.message) || "Something went wrong. Please try again.");
          spCartBtn(addBtn, "idle");
        });
    }
    if (vt) {
      if (minus) minus.addEventListener("click", vtRepaint);
      if (plus) plus.addEventListener("click", vtRepaint);
      if (qty) qty.addEventListener("input", vtRepaint);
    }
    root.addEventListener("change", function () { syncMountingHoles(); });

    // Do not wait for a customer change: an eligible default material must show
    // an enabled Mounting Holes field as soon as the PDP is initialized.
    syncMountingHoles();
    update();
  });

  /* ---------- Shape selector (acrylic / aluminium / polycarbonate cut-to-size) ----------
     "Custom Shape" hides all option fields, the totals box and the buy buttons, and shows a
     contact-for-quote message so custom shapes can't be purchased online (quote only). */
  document.querySelectorAll("[data-sp-shape]").forEach(function (sel) {
    var root = sel.closest("[data-sp-acrylic-calc],[data-sp-cutsize-calc],[data-sp-acp-calc]");
    if (!root) return;
    var body = root.querySelector("[data-sp-shape-body]");
    var custom = root.querySelector("[data-sp-shape-custom]");
    // Only "custom-internal" (outer shape + internal cut-outs) is quote-only:
    // it hides the body/price/add-to-cart and shows the contact-for-quote panel.
    // "custom" (outer shape only) stays fully purchasable and feeds ×1.25 into pricing.
    function apply() {
      var quoteOnly = sel.value === "custom-internal";
      if (body) body.hidden = quoteOnly;
      if (custom) custom.hidden = !quoteOnly;
    }
    sel.addEventListener("change", apply);
    apply();
  });

  /* ---------- Acrylic Cut-To-Size calculator ---------- */
  document.querySelectorAll("[data-sp-acrylic-calc]").forEach(function (root) {
    var pricing = [];
    try { pricing = JSON.parse(root.querySelector("[data-sp-acrylic-pricing]").textContent); } catch (e) { return; }
    if (!pricing.length) return;

    var tSel = root.querySelector("[data-sp-acrylic-thickness]");
    var cSel = root.querySelector("[data-sp-acrylic-colour]");
    var wIn = root.querySelector("[data-sp-acrylic-w]");
    var hIn = root.querySelector("[data-sp-acrylic-h]");
    var qIn = root.querySelector("[data-sp-acrylic-qty]");
    var qMinus = root.querySelector("[data-sp-acrylic-qty-minus]");
    var qPlus = root.querySelector("[data-sp-acrylic-qty-plus]");
    var errEl = root.querySelector("[data-sp-acrylic-error]");
    var qtyField = root.querySelector("[data-sp-qty]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var MAX_W = 1220, MAX_H = 2440, OVER_W = 1220, OVER_H = 2440;
    var LASER_RATE = 140, MIN_MIN = 3, HANDLING = 20, MIN_DIM = 5, MIN_ORDER = 50;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function thicknesses() { var s = []; pricing.forEach(function (r) { if (s.indexOf(r[0]) < 0) s.push(r[0]); }); return s.sort(function (a, b) { return a - b; }); }
    function coloursFor(t) { return pricing.filter(function (r) { return r[0] === t; }).map(function (r) { return r[1]; }); }
    function rowFor(t, c) { return pricing.find(function (r) { return r[0] === t && r[1] === c; }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-acrylic-prop="' + name + '"]'); if (el) el.value = v; }

    thicknesses().forEach(function (t) {
      var o = document.createElement("option"); o.value = t; o.textContent = t + " mm"; tSel.appendChild(o);
    });
    if (coloursFor(3).length) tSel.value = "3";

    // Mirror the configurable options into the Specifications table.
    (function fillSpecRows() {
      if (!productRoot) return;
      var specT = productRoot.querySelector("[data-sp-acrylic-spec-thickness]");
      var specC = productRoot.querySelector("[data-sp-acrylic-spec-colour]");
      if (specT) {
        specT.textContent = thicknesses().map(function (t) { return t + " mm"; }).join(", ");
      }
      if (specC) {
        var cols = [];
        pricing.forEach(function (r) { if (cols.indexOf(r[1]) < 0) cols.push(r[1]); });
        specC.textContent = cols.join(", ");
      }
    })();

    function populateColours() {
      var t = parseFloat(tSel.value);
      var prev = cSel.value;
      var cols = coloursFor(t);
      cSel.innerHTML = "";
      cols.forEach(function (c) { var o = document.createElement("option"); o.value = c; o.textContent = c; cSel.appendChild(o); });
      if (cols.indexOf(prev) >= 0) cSel.value = prev;
    }

    var shapeSel = root.querySelector("[data-sp-shape]");
    function shapeMult() { return (shapeSel && shapeSel.value === "custom") ? 1.25 : 1; }

    function recalc() {
      var t = parseFloat(tSel.value);
      var c = cSel.value;
      var row = rowFor(t, c);
      var W = parseInt(wIn.value, 10);
      var H = parseInt(hIn.value, 10);
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (!row) err = "That thickness and colour combination isn't available.";
      else if (!W || W < MIN_DIM || W > MAX_W) err = "Width must be between " + MIN_DIM + " and " + MAX_W + " mm.";
      else if (!H || H < MIN_DIM || H > MAX_H) err = "Length must be between " + MIN_DIM + " and " + MAX_H + " mm.";
      else if (!qty || qty < 1) err = "Quantity must be at least 1 piece.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your sizes";
        setText("[data-sp-acrylic-total]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var costM2 = row[2], speed = row[3], markup = row[4];
      var wastage = (W < 200 && H < 200) ? 1.3 : ((W <= 500 && H <= 500) ? 1.2 : 1.1);
      var perim = 2 * (W + H);
      var area = (W / 1000) * (H / 1000);
      // Per-piece is qty-dependent (min-minute laser floor + min-order floor
      // amortize as quantity grows), so the whole cost stack is a function of q.
      function priceAt(q) {
        var laserTime = (perim * q) / (speed || 3000);
        var effTime = Math.max(laserTime, MIN_MIN);
        var laserCost = (effTime / 60) * LASER_RATE;
        var areaWaste = area * q * wastage;
        var materialCost = areaWaste * costM2;
        var oversized = (W > OVER_W || H > OVER_H) ? round2(materialCost * 0.3) : 0;
        var subtotal = materialCost + oversized + laserCost;
        var markupAmt = subtotal * markup;
        // Custom (Outer shape only): ×1.25 on the pre-handling portion
        // (material + oversized + laser + markup). Handling/setup is un-multiplied.
        var sm = shapeMult();
        var preHandling = (subtotal + markupAmt) * sm;
        // Markup is folded into the displayed Material line (no separate Markup row).
        var materialShown = (materialCost + markupAmt) * sm;
        // $50 minimum order: absorb any shortfall into the Handling & setup fee.
        var baseSellExcl = preHandling + HANDLING;
        var handlingShown = HANDLING + Math.max(0, MIN_ORDER - baseSellExcl);
        var sellExcl = round2(Math.max(baseSellExcl, MIN_ORDER));
        var gst = round2(sellExcl * 0.1);
        var total = round2(sellExcl * 1.1);
        // The cart line carries quantity = pieces, so the variant is priced per
        // piece. Quantize so quantity × unit equals the charged total exactly.
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { materialShown: materialShown, laserCost: laserCost * sm, oversized: oversized * sm, handlingShown: handlingShown, sellExcl: sellExcl, gst: gst, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      setText("[data-sp-acrylic-material]", money(pr.materialShown));
      setText("[data-sp-acrylic-laser]", money(pr.laserCost));
      var ovRow = root.querySelector("[data-sp-acrylic-oversized-row]");
      if (ovRow) ovRow.style.display = pr.oversized > 0 ? "flex" : "none";
      setText("[data-sp-acrylic-oversized]", money(pr.oversized));
      setText("[data-sp-acrylic-handling]", money(pr.handlingShown));
      setText("[data-sp-acrylic-sell]", money(pr.sellExcl));
      setText("[data-sp-acrylic-gst]", money(pr.gst));
      setText("[data-sp-acrylic-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, null);

      setProp("Thickness", t + " mm");
      setProp("Colour", c);
      setProp("Size", W + " × " + H + " mm");
      setProp("Shape", shapeSel && shapeSel.value === "custom" ? "Custom (Outer shape only)" : "Standard (Square / Rectangle)");

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    if (shapeSel) shapeSel.addEventListener("change", recalc);
    populateColours();
    tSel.addEventListener("change", function () { populateColours(); recalc(); });
    cSel.addEventListener("change", recalc);
    [wIn, hIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = (parseInt(qIn.value, 10) || 1) + 1; recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant qty 1
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-acrylic-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var t = parseFloat(tSel.value);
        var c = cSel.value;
        var W = parseInt(wIn.value, 10);
        var H = parseInt(hIn.value, 10);
        var qty = parseInt(qIn.value, 10);
        if (!rowFor(t, c) || !W || W < MIN_DIM || W > MAX_W || !H || H < MIN_DIM || H > MAX_H || !qty || qty < 1) {
          recalc();
          return;
        }
        // Never coerce the shape: custom-internal (or any non rect/custom value) is
        // quote-only and must not be silently priced as standard. Abort instead.
        var shapeVal = shapeSel ? shapeSel.value : "rect";
        if (shapeVal !== "rect" && shapeVal !== "custom") {
          if (errEl) { errEl.textContent = "This shape is quote-only. Please contact us for a quote on this configuration."; errEl.classList.remove("hidden"); }
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-acrylic-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { thicknessMm: t, colour: c, widthMm: W, heightMm: H, shape: shapeVal, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/acrylic/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; });
          })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  // Rich-select: visually replace a native <select> with a thumbnail + label +
  // description picker, while keeping the native <select> in the DOM as the
  // source of truth for the value and for change events (so existing listeners
  // and the posted form value keep working). metaFor(value) -> option object
  // that may carry { thumb, desc }; missing thumb/desc degrade gracefully.
  // Shared by the stickers calculator and the generic backend calculator.
  // opts.noThumb = true → hides thumbnails while keeping all thumbnail code intact (easily restored).
  function makeRichSelect(sel, metaFor, opts) {
    opts = opts || {};
    var wrap = document.createElement("div");
    wrap.className = "sp-rsel" + (opts.className ? " " + opts.className : "");
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sp-rsel-btn";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    var panel = document.createElement("div");
    panel.className = "sp-rsel-panel";
    panel.setAttribute("role", "listbox");
    panel.hidden = true;
    wrap.appendChild(btn);
    wrap.appendChild(panel);

    function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function thumbHtml(m) { return m && m.thumb ? '<img class="sp-rsel-thumb" src="' + esc(m.thumb) + '" alt="" loading="lazy">' : '<span class="sp-rsel-thumb"></span>'; }
    function maybeThumb(m) { return opts.noThumb ? '' : thumbHtml(m); }

    function syncBtn() {
      var v = sel.value;
      var m = metaFor(v) || {};
      var label = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : "";
      btn.innerHTML = maybeThumb(m) + '<span class="sp-rsel-btn-label">' + esc(label) + '</span><span class="sp-rsel-caret" aria-hidden="true"></span>';
      Array.prototype.forEach.call(panel.children, function (r) { r.setAttribute("aria-selected", r.getAttribute("data-value") === v ? "true" : "false"); });
    }

    function choose(v) {
      if (sel.value !== v) { sel.value = v; sel.dispatchEvent(new Event("change", { bubbles: true })); }
      syncBtn();
    }

    function close() { panel.hidden = true; btn.setAttribute("aria-expanded", "false"); wrap.removeAttribute("data-open"); }
    function open() { panel.hidden = false; btn.setAttribute("aria-expanded", "true"); wrap.setAttribute("data-open", ""); }

    function rebuild() {
      panel.innerHTML = "";
      Array.prototype.forEach.call(sel.options, function (o) {
        var m = metaFor(o.value) || {};
        var row = document.createElement("button");
        row.type = "button";
        row.className = "sp-rsel-opt";
        row.setAttribute("role", "option");
        row.setAttribute("data-value", o.value);
        row.innerHTML = maybeThumb(m) + '<span class="sp-rsel-text"><span class="sp-rsel-label">' + esc(o.textContent) + '</span>' + (m && m.desc ? '<span class="sp-rsel-desc">' + esc(m.desc) + '</span>' : '') + '</span>';
        row.addEventListener("click", function () { choose(o.value); close(); btn.focus(); });
        panel.appendChild(row);
      });
      syncBtn();
    }

    btn.addEventListener("click", function () { if (panel.hidden) open(); else close(); });
    btn.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    document.addEventListener("click", function (e) { if (!wrap.contains(e.target)) close(); });
    sel.addEventListener("change", syncBtn);

    rebuild();
    return { rebuild: rebuild, sync: syncBtn };
  }

  // Safety Sign mounting holes use the same accessible rich-select interaction
  // as calculator options, with the three supplied hole-position thumbnails.
  document.querySelectorAll("[data-sp-mounting-holes-select]").forEach(function (sel) {
    var field = sel.closest("[data-sp-mounting-holes]");
    if (!field) return;
    var rich = makeRichSelect(sel, function (value) {
      var image = value.indexOf("2 x 5mm") === 0
        ? field.getAttribute("data-sp-mounting-holes-two")
        : value.indexOf("4 x 5mm") === 0
          ? field.getAttribute("data-sp-mounting-holes-four")
          : field.getAttribute("data-sp-mounting-holes-no");
      return { thumb: image };
    }, { className: "sp-mounting-holes-rsel" });
    sel._spMountingHolesRichSelect = rich;
  });

  /* ---------- Generic backend calculator (Easy Signs / Sign Portal imports) ---------- */
  document.querySelectorAll("[data-sp-calc]").forEach(function (root) {
    var apiBase = (root.getAttribute("data-sp-calc-api") || "").trim().replace(/\/+$/, "");
    var productId = (root.getAttribute("data-sp-calc-product") || "").trim();
    var assetBase = (root.getAttribute("data-sp-calc-asset-base") || "").trim();
    var fieldsWrap = root.querySelector("[data-sp-calc-fields]");
    var qIn = root.querySelector("[data-sp-calc-qty]");
    var qMinus = root.querySelector("[data-sp-calc-qty-minus]");
    var qPlus = root.querySelector("[data-sp-calc-qty-plus]");
    var errEl = root.querySelector("[data-sp-calc-error]");
    var qtyField = root.querySelector("[data-sp-qty]");
    var propsWrap = root.querySelector("[data-sp-calc-props]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;
    var form = root.closest("form");
    var controlScope = (
      root.getAttribute("data-sp-control-scope") ||
      [root.id, productRoot && productRoot.id, root.getAttribute("data-sp-calc-product")]
        .filter(function (value) { return value; }).join("-")
    ).replace(/[^A-Za-z0-9_-]+/g, "-");
    if (!controlScope) controlScope = "calc";
    function controlId(kind, key) {
      var suffix = key ? "-" + String(key).replace(/[^A-Za-z0-9_-]+/g, "-") : "";
      return "sp-generic-" + controlScope + "-" + kind + suffix;
    }

    var config = null;
    var selects = {};
    var fieldLabels = {};
    var fieldWraps = {};
    var priceTimer = null;
    var customWrap = null;
    var customW = null;
    var customH = null;
    var designsInput = null; // Unique Designs stepper input (only when config.designs)

    function money(n) { return "$" + Number(n).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function showErr(msg) {
      if (errEl) { errEl.textContent = msg; errEl.classList.remove("hidden"); }
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = "Check your options";
    }
    function clearErr() { if (errEl) errEl.classList.add("hidden"); }

    function currentOptions() {
      var o = {};
      Object.keys(selects).forEach(function (k) { o[k] = selects[k].value; });
      return o;
    }
    function currentQty() { return Math.max(1, parseInt(qIn && qIn.value, 10) || 1); }
    // Unique Designs (1..100). Present only when the backend config advertises
    // `designs: true`; otherwise fixed at 1 and omitted from payloads.
    function designsEnabled() { return !!(config && config.designs); }
    function currentDesigns() {
      if (!designsInput) return 1;
      var n = parseInt(designsInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 100) n = 100;
      return n;
    }

    // Is the "Custom Size" option currently selected on the size field?
    function customActive() {
      var cs = config && config.customSize;
      return !!(cs && selects[cs.fieldKey] && selects[cs.fieldKey].value === cs.value);
    }
    // Freeform width/height (mm) from the custom inputs, or null if incomplete.
    function customDims() {
      if (!customW || !customH) return null;
      var w = parseFloat(customW.value), h = parseFloat(customH.value);
      if (!(w > 0) || !(h > 0)) return null;
      return { widthMm: w, heightMm: h };
    }
    // Show the W×H inputs only while "Custom Size" is chosen.
    function syncCustomVisibility() {
      if (!customWrap) return;
      customWrap.hidden = !customActive();
    }
    // Parse "600mm W x 450mm H" (or "600 × 450 mm") → { w, h } from an option label.
    function dimsFromLabel(txt) {
      var nums = String(txt || "").match(/\d+(?:\.\d+)?/g);
      if (!nums || nums.length < 2) return null;
      return { w: parseFloat(nums[0]), h: parseFloat(nums[1]) };
    }
    // Seed the custom W×H inputs with the currently-selected preset size, so when
    // the shopper switches to "Custom Size" they start from the last real size.
    function prefillFromPreset() {
      var cs = config && config.customSize;
      if (!cs || !customW || !customH || !selects[cs.fieldKey] || customActive()) return;
      var sel = selects[cs.fieldKey];
      var chosen = sel.options[sel.selectedIndex];
      var d = dimsFromLabel(chosen ? chosen.textContent : "");
      if (d) { customW.value = d.w; customH.value = d.h; }
    }

    // Turn the backend's [{qty, perPieceIncl}] breakpoints into ranged rows,
    // dropping any breakpoint whose per-piece price didn't drop from the previous.
    function tiersFromBackend(tiers) {
      if (!Array.isArray(tiers)) return [];
      var sorted = tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
      var rows = [];
      for (var i = 0; i < sorted.length; i++) {
        var t = sorted[i];
        if (typeof t.qty !== "number" || typeof t.perPieceIncl !== "number") continue;
        var prev = rows.length ? rows[rows.length - 1] : null;
        if (prev && t.perPieceIncl >= prev.perPiece - 0.005) continue;
        rows.push({ qtyMin: t.qty, perPiece: t.perPieceIncl });
      }
      for (var k = 0; k < rows.length; k++) {
        var next = rows[k + 1];
        rows[k].qtyMax = next ? next.qtyMin - 1 : null;
        rows[k].qtyLabel = next ? (rows[k].qtyMin === rows[k].qtyMax ? String(rows[k].qtyMin) : rows[k].qtyMin + "–" + rows[k].qtyMax) : rows[k].qtyMin + "+";
      }
      return rows;
    }

    function requestPrice() {
      if (!apiBase) { showErr("Online pricing is temporarily unavailable. Please contact us to place this order."); return; }
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = "Calculating…";
      setText("[data-sp-calc-total]", "…");
      var ppLoading = root.querySelector("[data-sp-pp]");
      if (ppLoading) ppLoading.textContent = "…";
      var qty = currentQty();
      if (qtyField) qtyField.value = qty;
      // Unique designs cannot exceed the quantity (spec-exact message).
      if (designsEnabled() && currentDesigns() > qty) {
        setText("[data-sp-calc-total]", "—");
        setText("[data-sp-calc-sell]", "—");
        setText("[data-sp-calc-gst]", "—");
        spClearLead(root);
        showErr("Unique designs cannot exceed the quantity. Please increase the quantity.");
        return;
      }
      var pricePayload = { productId: productId, qty: qty, options: currentOptions() };
      if (designsEnabled()) pricePayload.designs = currentDesigns();
      if (customActive()) {
        var d = customDims();
        if (!d) {
          setText("[data-sp-calc-total]", "—");
          setText("[data-sp-calc-sell]", "—");
          setText("[data-sp-calc-gst]", "—");
          spClearLead(root);
          showErr("Enter a custom width and height in millimetres.");
          return;
        }
        pricePayload.widthMm = d.widthMm;
        pricePayload.heightMm = d.heightMm;
      }
      fetch(apiBase + "/api/calc/price", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(pricePayload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || typeof res.body.totalIncl !== "number") {
            throw new Error((res.body && res.body.error) || "We couldn't price that combination.");
          }
          clearErr();
          var b = res.body;
          setText("[data-sp-calc-sell]", money(b.sellExcl));
          setText("[data-sp-calc-gst]", money(b.gst));
          setText("[data-sp-calc-total]", money(b.totalIncl));
          var base = typeof b.basePerPieceIncl === "number" ? b.basePerPieceIncl : b.perPieceIncl;
          spRenderLead(root, b.perPieceIncl, base, qty);
          spRenderTiers(root, tiersFromBackend(b.tiers), qty, base);
          if (addBtn) addBtn.disabled = false;
          if (addLabel) addLabel.textContent = "Add to cart";
        })
        .catch(function (err) {
          setText("[data-sp-calc-total]", "—");
          setText("[data-sp-calc-sell]", "—");
          setText("[data-sp-calc-gst]", "—");
          spClearLead(root);
          showErr((err && err.message) || "Something went wrong. Please try again.");
        });
    }

    function schedulePrice() {
      if (priceTimer) clearTimeout(priceTimer);
      priceTimer = setTimeout(requestPrice, 250);
    }

    // Conditional visibility (config showIf rules): a field is shown only
    // while its controlling field holds one of the allowed values. Hidden
    // fields keep their value but are excluded from line-item properties;
    // pricing stays safe because the backend never surcharges an option that
    // isn't in play for the chosen combination.
    function fieldVisible(f) {
      if (!f.showIf) return true;
      var ctrl = selects[f.showIf.fieldKey];
      if (!ctrl) return true;
      return f.showIf.values.indexOf(ctrl.value) >= 0;
    }
    function updateFieldVisibility() {
      (config.fields || []).forEach(function (f) {
        var el = fieldWraps[f.key];
        if (!el || !f.showIf) return;
        // Inline style, NOT a `hidden` class/attribute: the wrapper carries
        // display utilities (.block) that would override either.
        el.style.display = fieldVisible(f) ? "" : "none";
      });
      // Field visibility can change the visible cell count → re-balance parity.
      if (typeof applyGridParity === "function") applyGridParity();
    }

    function renderFields() {
      fieldsWrap.innerHTML = "";
      var labelEls = [];
      var sizeFieldIdx = -1;
      var csKey = config && config.customSize && config.customSize.fieldKey;
      (config.fields || []).forEach(function (f) {
        fieldLabels[f.key] = f.label;
        var label = document.createElement("label");
        // Long option lists (>8) stay full-width; flag so the parity pass keeps them.
        var wideList = (f.options || []).length > 8;
        label.className = wideList ? "block col-span-2" : "block";
        if (wideList) label.setAttribute("data-sp-keep-wide", "");
        var span = document.createElement("span");
        span.className = "mb-1.5 block text-xs font-bold uppercase tracking-wide text-black";
        span.textContent = f.label;
        var sel = document.createElement("select");
        var fieldId = controlId("select", f.key);
        label.htmlFor = fieldId;
        sel.id = fieldId;
        sel.className = "w-full rounded-xl border-2 border-gray-200 bg-white px-4 py-2.5 text-sm font-bold text-black outline-none focus:border-[var(--sp-blue)]";
        (f.options || []).forEach(function (o) {
          var opt = document.createElement("option");
          opt.value = o.value; opt.textContent = o.label;
          sel.appendChild(opt);
        });
        sel.addEventListener("change", function () { updateFieldVisibility(); schedulePrice(); });
        selects[f.key] = sel;
        fieldWraps[f.key] = label;
        label.appendChild(span);
        label.appendChild(sel);
        fieldsWrap.appendChild(label);
        labelEls.push(label);
        if (csKey && f.key === csKey) sizeFieldIdx = labelEls.length - 1;
        // Upgrade to a thumbnail/description picker when Easy Signs supplied
        // per-option imagery or copy for this field. Thumbnails arrive as bundled
        // asset basenames (e.g. "es-tip-ground-spike.webp") and are resolved to
        // full URLs via the theme asset base. Fields with no imagery/copy stay
        // as plain native selects.
        var hasMeta = (f.options || []).some(function (o) { return o.thumbnail || o.description; });
        if (hasMeta) {
          makeRichSelect(sel, function (v) {
            var opts = f.options || [];
            for (var i = 0; i < opts.length; i++) {
              if (opts[i].value === v) {
                var o = opts[i];
                return { thumb: o.thumbnail ? assetBase + o.thumbnail : null, desc: o.description || null };
              }
            }
            return null;
          });
        }
      });

      // "Custom Size" support: inject W×H inputs shown only when the size field's
      // custom option is chosen. The backend prices freeform dimensions by
      // interpolating the snapshot sizes across area (bounded to the largest real
      // size), so we surface its min/max and thread widthMm/heightMm through.
      customWrap = null; customW = null; customH = null;
      var cs = config && config.customSize;
      if (cs && selects[cs.fieldKey]) {
        var selCls = "w-full rounded-xl border-2 border-gray-200 bg-white px-4 py-2.5 text-sm font-bold text-black outline-none focus:border-[var(--sp-blue)]";
        var spanCls = "mb-1.5 block text-xs font-bold uppercase tracking-wide text-black";
        customWrap = document.createElement("div");
        customWrap.className = "col-span-2";
        customWrap.setAttribute("data-sp-custom-size", "");
        var grid = document.createElement("div");
        grid.className = "grid grid-cols-2 gap-3";
        function dimField(labelText, key) {
          var wrap = document.createElement("label");
          wrap.className = "block";
          var inputId = controlId("custom", key);
          wrap.htmlFor = inputId;
          var s = document.createElement("span");
          s.className = spanCls;
          s.textContent = labelText;
          var inp = document.createElement("input");
          inp.type = "number";
          inp.id = inputId;
          inp.className = selCls;
          inp.min = String(cs.minMm);
          inp.step = "1";
          inp.inputMode = "numeric";
          inp.placeholder = "mm";
          inp.addEventListener("input", schedulePrice);
          wrap.appendChild(s);
          wrap.appendChild(inp);
          return { wrap: wrap, input: inp };
        }
        var wf = dimField("Width (mm)", "width");
        var hf = dimField("Height (mm)", "height");
        customW = wf.input;
        customH = hf.input;
        grid.appendChild(wf.wrap);
        grid.appendChild(hf.wrap);
        customWrap.appendChild(grid);
        var hint = document.createElement("p");
        hint.className = "mt-2 text-xs text-gray-500";
        hint.textContent = "Enter any size from " + cs.minMm + " mm up to " + cs.maxLongMm + " × " + cs.maxShortMm + " mm.";
        customWrap.appendChild(hint);
        // Place the W×H block directly under the top row (the row that holds the
        // Size field), matching the acrylic layout, instead of at the very bottom.
        var anchor = null;
        if (sizeFieldIdx >= 0) {
          var rowEndIdx = sizeFieldIdx - (sizeFieldIdx % 2) + 1;
          anchor = labelEls[rowEndIdx] || labelEls[sizeFieldIdx];
        }
        if (anchor && anchor.parentNode === fieldsWrap) fieldsWrap.insertBefore(customWrap, anchor.nextSibling);
        else fieldsWrap.appendChild(customWrap);
        selects[cs.fieldKey].addEventListener("change", function () { prefillFromPreset(); syncCustomVisibility(); });
        prefillFromPreset();
        syncCustomVisibility();
      }

      // Conditional fields: base_size is only relevant when base === 'flatbase'
      // (Heavy Duty Square Base). For every other base option it is hidden so
      // shoppers aren't shown a meaningless dropdown.
      if (selects["base"] && selects["base_size"]) {
        var syncBaseSizeVis = function () {
          var baseSizeLbl = selects["base_size"].closest ? selects["base_size"].closest("label") : selects["base_size"].parentElement;
          if (baseSizeLbl) baseSizeLbl.hidden = (selects["base"].value !== "flatbase");
        };
        selects["base"].addEventListener("change", syncBaseSizeVis);
        syncBaseSizeVis();
      }

      // Unique Designs stepper — rendered only when the backend advertises it.
      designsInput = null;
      if (designsEnabled()) {
        var dWrap = document.createElement("div");
        dWrap.className = "sp-designs-stepper block w-full max-w-[12rem]";
        dWrap.setAttribute("data-sp-calc-designs-wrap", "");
        var dSpan = document.createElement("label");
        dSpan.className = "mb-1.5 block text-xs font-bold uppercase tracking-wide text-black";
        dSpan.textContent = "Unique Designs";
        var dCtl = document.createElement("div");
        dCtl.className = "flex w-full items-stretch overflow-hidden rounded-xl border-2 border-gray-200 bg-white focus-within:border-[var(--sp-blue)]";
        var dCol = document.createElement("div");
        dCol.className = "flex w-9 flex-col justify-center";
        var dPlus = document.createElement("button");
        dPlus.type = "button";
        dPlus.setAttribute("aria-label", "Increase");
        dPlus.className = "grid h-[18px] w-9 place-items-center text-black hover:bg-gray-50";
        dPlus.textContent = "+";
        var dMinus = document.createElement("button");
        dMinus.type = "button";
        dMinus.setAttribute("aria-label", "Decrease");
        dMinus.className = "grid h-[18px] w-9 place-items-center text-black hover:bg-gray-50";
        dMinus.textContent = "−";
        var dInput = document.createElement("input");
        var designsId = controlId("number", "unique-designs");
        dSpan.htmlFor = designsId;
        dInput.type = "number";
        dInput.id = designsId;
        dInput.inputMode = "numeric";
        dInput.min = "1"; dInput.max = "100"; dInput.value = "1";
        dInput.className = "min-w-0 flex-1 border-0 bg-transparent px-4 py-2.5 text-left text-sm font-bold text-black outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
        dMinus.addEventListener("click", function () { dInput.value = Math.max(1, (parseInt(dInput.value, 10) || 1) - 1); schedulePrice(); });
        dPlus.addEventListener("click", function () { dInput.value = Math.min(100, (parseInt(dInput.value, 10) || 1) + 1); schedulePrice(); });
        dInput.addEventListener("input", schedulePrice);
        dInput.addEventListener("blur", function () { dInput.value = currentDesigns(); schedulePrice(); });
        dCol.appendChild(dPlus); dCol.appendChild(dMinus);
        dCtl.appendChild(dCol); dCtl.appendChild(dInput);
        dWrap.appendChild(dSpan); dWrap.appendChild(dCtl);
        fieldsWrap.appendChild(dWrap);
        designsInput = dInput;
      }

      // 50/50 layout pass: with an even number of grid cells every field pairs up;
      // when the count is odd, only the LAST field spans both columns so the grid
      // never leaves a lonely half-width cell. Custom-size/W×H blocks already carry
      // col-span-2 and are excluded from the parity count.
      applyGridParity();
    }

    // Normalise col-span-2 across the top-level grid children (native <label>
    // fields + the designs stepper) so an odd count only widens the last cell.
    function applyGridParity() {
      if (!fieldsWrap) return;
      var cells = [];
      Array.prototype.forEach.call(fieldsWrap.children, function (el) {
        if (el.hasAttribute && (el.hasAttribute("data-sp-custom-size"))) return; // full-width already
        if (el.style && el.style.display === "none") return;
        if (el.hidden) return;
        cells.push(el);
      });
      // Options>8 selects intentionally stay full-width; leave those as-is but still
      // count them as occupying a full row for parity purposes.
      cells.forEach(function (el) {
        var wide = el.className.indexOf("col-span-2") >= 0;
        // reset non-intentional spans first
        if (wide && !el.getAttribute("data-sp-keep-wide")) el.className = el.className.replace(/\s*col-span-2/, "");
      });
      // Re-flag options>8 as keep-wide during render already; recompute parity on the
      // remaining single-cell fields.
      var singles = cells.filter(function (el) { return el.className.indexOf("col-span-2") < 0; });
      if (singles.length % 2 === 1) {
        var last = singles[singles.length - 1];
        // The Unique Designs stepper looks bad stretched full-width — it stays a
        // single column even when it's the odd one out.
        if (last && last.hasAttribute && last.hasAttribute("data-sp-calc-designs-wrap")) return;
        if (last && last.className.indexOf("col-span-2") < 0) last.className += " col-span-2";
      }
    }

    // Populate the Specifications table from the backend config so matrix
    // calculators (Teardrop, Bollard, A-Frame, …) list their real options with
    // appropriate icons. Rows are inserted as direct <dl> children (before the
    // hidden placeholder) so the divide-y borders stay correct.
    function renderSpec() {
      var slot = document.querySelector("[data-sp-calc-spec]");
      if (!slot || !config) return;
      var bank = document.querySelector("[data-sp-spec-icons]");
      function iconFor(name) {
        if (bank) { var s = bank.querySelector('[data-icon="' + name + '"]'); if (s) return s.innerHTML; }
        return "";
      }
      function pickIcon(label) {
        var n = (label || "").toLowerCase();
        if (n.indexOf("material") >= 0) return "layers";
        if (n.indexOf("colour") >= 0 || n.indexOf("color") >= 0) return "palette";
        if (n.indexOf("size") >= 0 || n.indexOf("dimension") >= 0 || n.indexOf("height") >= 0 || n.indexOf("width") >= 0) return "ruler";
        if (n.indexOf("thick") >= 0 || n.indexOf("depth") >= 0 || n.indexOf("gauge") >= 0) return "sliders";
        if (n.indexOf("finish") >= 0 || n.indexOf("laminat") >= 0) return "sparkles";
        if (n.indexOf("shape") >= 0) return "grid-3x3";
        if (n.indexOf("mount") >= 0 || n.indexOf("fix") >= 0 || n.indexOf("install") >= 0 || n.indexOf("base") >= 0 || n.indexOf("stand") >= 0 || n.indexOf("pole") >= 0 || n.indexOf("spike") >= 0) return "scan-line";
        if (n.indexOf("orient") >= 0 || n.indexOf("rotat") >= 0) return "rotate-ccw";
        if (n.indexOf("text") >= 0 || n.indexOf("word") >= 0) return "pen-tool";
        if (n.indexOf("quantity") >= 0 || n.indexOf("pack") >= 0 || n.indexOf("qty") >= 0) return "boxes";
        if (n.indexOf("side") >= 0 || n.indexOf("print") >= 0) return "layers";
        return "tag";
      }
      function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
      var html = "";
      (config.fields || []).forEach(function (f) {
        var vals = (f.options || []).map(function (o) { return o.label; }).filter(Boolean);
        if (!vals.length || !f.label) return;
        html += '<div class="flex items-start gap-3 px-4 py-3">' + iconFor(pickIcon(f.label)) +
          '<div><dt class="text-xs font-bold uppercase tracking-wide text-black">' + esc(f.label) +
          '</dt><dd class="text-sm text-black">' + esc(vals.join(", ")) + "</dd></div></div>";
      });
      slot.insertAdjacentHTML("beforebegin", html);
    }

    // Mirror current selections into line-item property inputs for /cart/add.js.
    function syncProps() {
      if (!propsWrap) return;
      propsWrap.innerHTML = "";
      var cs = config && config.customSize;
      var byKey = {};
      (config.fields || []).forEach(function (f) { byKey[f.key] = f; });
      Object.keys(selects).forEach(function (k) {
        // Hidden (conditionally irrelevant) fields never become order properties.
        if (byKey[k] && !fieldVisible(byKey[k])) return;
        var sel = selects[k];
        var chosen = sel.options[sel.selectedIndex];
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + (fieldLabels[k] || k) + "]";
        // Custom size: show the entered dimensions instead of "Custom Size".
        if (cs && k === cs.fieldKey && customActive()) {
          var d = customDims();
          input.value = d ? "Custom — " + d.widthMm + " × " + d.heightMm + " mm" : "Custom Size";
        } else {
          input.value = chosen ? chosen.textContent : sel.value;
        }
        propsWrap.appendChild(input);
      });
      if (designsEnabled()) {
        var di = document.createElement("input");
        di.type = "hidden";
        di.name = "properties[Unique Designs]";
        di.value = String(currentDesigns());
        propsWrap.appendChild(di);
      }
    }

    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, currentQty() - 1); schedulePrice(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = currentQty() + 1; schedulePrice(); });
    if (qIn) qIn.addEventListener("input", schedulePrice);

    // Submit → price + create the exactly-priced product server-side → add variant.
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!apiBase) { showErr("Online pricing is temporarily unavailable. Please contact us to place this order."); return; }
        clearErr();
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-calc-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        if (designsEnabled() && currentDesigns() > currentQty()) {
          showErr("Unique designs cannot exceed the quantity. Please increase the quantity.");
          spCartBtn(addBtn, "idle");
          return;
        }
        var payload = { productId: productId, qty: currentQty(), options: currentOptions() };
        if (designsEnabled()) payload.designs = currentDesigns();
        if (customActive()) {
          var cd = customDims();
          if (!cd) { showErr("Enter a custom width and height in millimetres."); spCartBtn(addBtn, "idle"); return; }
          payload.widthMm = cd.widthMm;
          payload.heightMm = cd.heightMm;
        }
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/calc/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            syncProps();
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            showErr((err && err.message) || "Something went wrong. Please try again.");
            spCartBtn(addBtn, "idle");
          });
      });
    }

    // Load the option set, render the fields, then fetch the first live price.
    if (addBtn) addBtn.disabled = true;
    if (!apiBase) { showErr("Online pricing is temporarily unavailable. Please contact us to place this order."); return; }
    fetch(apiBase + "/api/calc/config?productId=" + encodeURIComponent(productId), { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("config"); return r.json(); })
      .then(function (cfg) {
        config = cfg;
        // Per-item noun by calculator key (Liquid defaults the generic panel to
        // "piece"; unmapped keys keep that default).
        var SP_CALC_UNITS = { fluteBoard: "sign", foamPvc: "sign", bollard: "sign", aframe: "frame", premiumPullUp: "banner", teardrop: "banner", vinylBanner: "banner", crowdControl: "barrier", floorDecals: "decal" };
        var unitNoun = SP_CALC_UNITS[cfg.key];
        if (unitNoun) {
          var ppUnitEl = root.querySelector("[data-sp-pp-unit]");
          if (ppUnitEl) ppUnitEl.textContent = "per " + unitNoun;
          var bmUnitEl = root.querySelector("[data-sp-buymore-unit]");
          if (bmUnitEl) bmUnitEl.textContent = unitNoun;
        }
        renderFields();
        updateFieldVisibility();
        renderSpec();
        requestPrice();
      })
      .catch(function () {
        if (fieldsWrap) fieldsWrap.innerHTML = "";
        showErr("This configurator is temporarily unavailable. Please contact us to place this order.");
      });
  });

  /* ---------- Custom Electrical & Warning Labels calculator ---------- */
  document.querySelectorAll("[data-sp-labels-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-labels-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var matSel = root.querySelector("[data-sp-labels-material]");
    var colSel = root.querySelector("[data-sp-labels-colour]");
    var wIn = root.querySelector("[data-sp-labels-w]");
    var hIn = root.querySelector("[data-sp-labels-h]");
    var textIn = root.querySelector("[data-sp-labels-text]");
    var adhSel = root.querySelector("[data-sp-labels-adhesive]");
    var holesSel = root.querySelector("[data-sp-labels-holes]");
    var designsIn = root.querySelector("[data-sp-labels-designs]");
    var qIn = root.querySelector("[data-sp-labels-qty]");
    var qMinus = root.querySelector("[data-sp-labels-qty-minus]");
    var qPlus = root.querySelector("[data-sp-labels-qty-plus]");
    var errEl = root.querySelector("[data-sp-labels-error]");
    var qtyField = root.querySelector("[data-sp-qty]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var HANDLING = cfg.handling, GST_RATE = cfg.gstRate, MIN_DIM = cfg.minDim, MAX_DIM = cfg.maxDim, MAX_QTY = cfg.maxQty, ACRYLIC_FACTOR = cfg.acrylicFactor, TIERS = cfg.tiers;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-labels-prop="' + name + '"]'); if (el) el.value = v; }

    // Per-m² rate for a given area (m²) and material. Mirrors the server exactly.
    function rateFor(areaM2, material) {
      var base = TIERS[TIERS.length - 1][1];
      for (var i = 0; i < TIERS.length; i++) {
        var max = TIERS[i][0];
        if (max === null || areaM2 <= max) { base = TIERS[i][1]; break; }
      }
      return material === "Acrylic" ? base * ACRYLIC_FACTOR : base;
    }

    function recalc() {
      var material = matSel.value;
      var W = parseInt(wIn.value, 10);
      var H = parseInt(hIn.value, 10);
      var designs = parseInt(designsIn && designsIn.value, 10) || 1;
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (!W || W < MIN_DIM || W > MAX_DIM) err = "Width must be between " + MIN_DIM + " and " + MAX_DIM + " mm.";
      else if (!H || H < MIN_DIM || H > MAX_DIM) err = "Height must be between " + MIN_DIM + " and " + MAX_DIM + " mm.";
      else if (designs < 1 || designs > 100) err = "Number of unique designs must be between 1 and 100.";
      else if (!qty || qty < 1 || qty > MAX_QTY) err = "Quantity must be between 1 and " + MAX_QTY + " labels.";
      else if (designs > qty) err = "Unique designs cannot exceed the quantity. Please increase the quantity.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your sizes";
        setText("[data-sp-labels-total]", "—");
        setText("[data-sp-labels-material-cost]", "—");
        setText("[data-sp-labels-handling]", "—");
        setText("[data-sp-labels-sell]", "—");
        setText("[data-sp-labels-gst]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var area = (W / 1000) * (H / 1000);
      var rate = rateFor(area, material);
      var unit = area * rate;
      // Unique Designs: flat (designs−1)×$10 inc GST once per order, added AFTER
      // markup and NOT multiplied by anything (ex-GST equivalent folded into sellExcl).
      var designsExcl = designs > 1 ? (designs - 1) * 10 / (1 + GST_RATE) : 0;
      // Per-label drops as the fixed handling fee amortizes over more labels.
      function priceAt(q) {
        var sellExcl = round2(unit * q + HANDLING + designsExcl);
        var gst = round2(sellExcl * GST_RATE);
        var total = round2(sellExcl * (1 + GST_RATE));
        // Cart line carries quantity = labels, so the variant is priced per label.
        // Quantize so quantity × unit equals the charged total exactly.
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { subtotal: unit * q, sellExcl: sellExcl, gst: gst, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      setText("[data-sp-labels-material-cost]", money(round2(pr.subtotal)));
      setText("[data-sp-labels-handling]", money(round2(HANDLING + designsExcl)));
      setText("[data-sp-labels-sell]", money(pr.sellExcl));
      setText("[data-sp-labels-gst]", money(pr.gst));
      setText("[data-sp-labels-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, MAX_QTY);

      setProp("Material", material);
      setProp("Colour", colSel.value);
      setProp("Size", W + " × " + H + " mm");
      setProp("Text", textIn ? textIn.value.trim() : "");
      setProp("Adhesive Backing", adhSel && adhSel.value === "Yes" ? "Yes" : "");
      setProp("Mounting Holes", holesSel && holesSel.value === "Yes" ? "Yes" : "");
      setProp("Unique Designs", String(designs));
      setProp("Quantity", String(qty));

      // Text is required: price still shows live, but the cart is gated until
      // the customer has entered their label text.
      if (textIn && !textIn.value.trim()) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Enter your label text";
      } else {
        if (addBtn) addBtn.disabled = false;
        if (addLabel) addLabel.textContent = "Add to cart";
      }
    }

    matSel.addEventListener("change", recalc);
    colSel.addEventListener("change", recalc);
    [wIn, hIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    if (textIn) textIn.addEventListener("input", recalc);
    if (adhSel) adhSel.addEventListener("change", recalc);
    if (holesSel) holesSel.addEventListener("change", recalc);
    spWireDesignsStepper(root, "sp-labels-designs", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = Math.min(MAX_QTY, (parseInt(qIn.value, 10) || 1) + 1); recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant.
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-labels-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var material = matSel.value;
        var W = parseInt(wIn.value, 10);
        var H = parseInt(hIn.value, 10);
        var designs = parseInt(designsIn && designsIn.value, 10) || 1;
        var qty = parseInt(qIn.value, 10);
        if (!W || W < MIN_DIM || W > MAX_DIM || !H || H < MIN_DIM || H > MAX_DIM || designs < 1 || designs > 100 || !qty || qty < 1 || qty > MAX_QTY || designs > qty) {
          recalc();
          return;
        }
        if (textIn && !textIn.value.trim()) {
          if (errEl) { errEl.textContent = "Please enter the text for your label(s) before adding to cart."; errEl.classList.remove("hidden"); }
          textIn.focus();
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-labels-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { material: material, widthMm: W, heightMm: H, designs: designs, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/labels/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; });
          })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- Cut-to-size calculators (aluminium / polycarbonate / laser-cut stencils) ---------- */
  document.querySelectorAll("[data-sp-cutsize-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-cutsize-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var matSel = root.querySelector("[data-sp-cutsize-material]");
    var matLabel = root.querySelector("[data-sp-cutsize-material-label]");
    var lIn = root.querySelector("[data-sp-cutsize-l]");
    var wIn = root.querySelector("[data-sp-cutsize-w]");
    var shapeSel = root.querySelector("[data-sp-shape]");
    var qIn = root.querySelector("[data-sp-cutsize-qty]");
    var qMinus = root.querySelector("[data-sp-cutsize-qty-minus]");
    var qPlus = root.querySelector("[data-sp-cutsize-qty-plus]");
    var errEl = root.querySelector("[data-sp-cutsize-error]");
    var ovRow = root.querySelector("[data-sp-cutsize-oversized-row]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var MIN_DIM = cfg.minDim, MAX_L = cfg.maxL, MAX_W = cfg.maxW, OVER_L = cfg.overL, OVER_W = cfg.overW;
    var CUT_RATE = cfg.cutRate, MIN_MIN = cfg.minMinutes, CUT_MULT = cfg.cutMultiplier, HANDLING_BASE = cfg.handlingBase, GST_RATE = cfg.gstRate;
    var MAX_QTY = cfg.maxQty || null;
    var MATERIALS = cfg.materials || [], FIXED = cfg.fixedProps || {};

    if (matLabel && cfg.selectLabel) matLabel.textContent = cfg.selectLabel;
    MATERIALS.forEach(function (m) {
      var opt = document.createElement("option");
      opt.value = m.label; opt.textContent = m.label;
      matSel.appendChild(opt);
    });

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-cutsize-prop="' + name + '"]'); if (el) el.value = v; }
    function findMat() { for (var i = 0; i < MATERIALS.length; i++) { if (MATERIALS[i].label === matSel.value) return MATERIALS[i]; } return null; }
    function dash() {
      setText("[data-sp-cutsize-material-cost]", "—"); setText("[data-sp-cutsize-cut]", "—");
      setText("[data-sp-cutsize-handling]", "—"); setText("[data-sp-cutsize-sell]", "—");
      setText("[data-sp-cutsize-gst]", "—"); setText("[data-sp-cutsize-total]", "—");
      if (ovRow) { ovRow.classList.add("hidden"); ovRow.classList.remove("flex"); }
      spClearLead(root);
    }

    function recalc() {
      var mat = findMat();
      var L = parseInt(lIn.value, 10);
      var W = parseInt(wIn.value, 10);
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (!mat) err = "Please choose a material.";
      else if (!L || L < MIN_DIM || L > MAX_L) err = "Length must be between " + MIN_DIM + " and " + MAX_L + " mm.";
      else if (!W || W < MIN_DIM || W > MAX_W) err = "Width must be between " + MIN_DIM + " and " + MAX_W + " mm.";
      else if (!qty || qty < 1) err = "Quantity must be at least 1 piece.";
      else if (MAX_QTY && qty > MAX_QTY) err = "Maximum quantity is " + MAX_QTY + " pieces.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your config";
        dash();
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var wastage = L < 200 && W < 200 ? 1.3 : L <= 500 && W <= 500 ? 1.2 : 1.1;
      var perim = 2 * (L + W);
      var area = (L / 1000) * (W / 1000);
      var handling = HANDLING_BASE + (mat.handlingSurcharge || 0);
      // Custom (Outer shape only): ×1.25 on the pre-handling portion
      // (material + oversized + cut + markup). Handling is un-multiplied.
      var sm = (shapeSel && shapeSel.value === "custom") ? 1.25 : 1;
      // Per-piece price function. When cfg.qtyDiscountTable is set, the base
      // (qty=1) formula price is computed and the tiered discount is applied so
      // per-piece = base × (1 − discount); all displayed line items are scaled
      // proportionally so they sum correctly. Otherwise the natural
      // handling-amortisation curve is used.
      function priceAt(q) {
        var fq = cfg.qtyDiscountTable ? 1 : q;
        var cutDist = perim * CUT_MULT * fq;
        var cutTime = cutDist / mat.speed;
        var effTime = Math.max(cutTime, MIN_MIN);
        var cutCost = (effTime / 60) * CUT_RATE;
        var materialCost = area * fq * wastage * mat.costPerM2;
        var oversized = L > OVER_L || W > OVER_W ? round2(materialCost * 0.3) : 0;
        var subtotal = materialCost + oversized + cutCost;
        var markupAmt = subtotal * mat.markup;
        var sellExcl = round2((subtotal + markupAmt) * sm + handling);
        var gst = round2(sellExcl * GST_RATE);
        var total = round2(sellExcl * (1 + GST_RATE));

        if (cfg.qtyDiscountTable) {
          var disc = 0;
          var dt = cfg.qtyDiscountTable;
          for (var di = dt.length - 1; di >= 0; di--) {
            if (q >= dt[di].minQty) { disc = dt[di].discount; break; }
          }
          var df = 1 - disc;
          var ppCents = Math.max(1, Math.round(total * df * 100));
          var chargedTotal = round2((ppCents * q) / 100);
          var dispSellExcl = round2(chargedTotal / (1 + GST_RATE));
          return {
            materialCost: round2(materialCost * sm * q * df),
            cutCost: round2(cutCost * sm * df),
            oversized: round2(oversized * sm * df),
            dispHandling: round2(handling * df),
            sellExcl: dispSellExcl,
            // Derive GST as remainder so sellExcl + gst === chargedTotal exactly.
            gst: round2(chargedTotal - dispSellExcl),
            chargedTotal: chargedTotal,
            perPiece: ppCents / 100
          };
        }

        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { materialCost: materialCost * sm, cutCost: cutCost * sm, oversized: oversized * sm, dispHandling: handling, sellExcl: sellExcl, gst: gst, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      // Material is the remainder of sellExcl so all three breakdown lines sum exactly.
      var dispCutCost = round2(pr.cutCost);
      var dispOversized = pr.oversized > 0 ? round2(pr.oversized) : 0;
      var dispHandling = round2(pr.dispHandling);
      var dispMaterial = round2(pr.sellExcl - dispCutCost - dispOversized - dispHandling);
      setText("[data-sp-cutsize-material-cost]", money(dispMaterial));
      setText("[data-sp-cutsize-cut]", money(dispCutCost));
      if (pr.oversized > 0) { if (ovRow) { ovRow.classList.remove("hidden"); ovRow.classList.add("flex"); } setText("[data-sp-cutsize-oversized]", money(dispOversized)); }
      else if (ovRow) { ovRow.classList.add("hidden"); ovRow.classList.remove("flex"); }
      setText("[data-sp-cutsize-handling]", money(dispHandling));
      setText("[data-sp-cutsize-sell]", money(pr.sellExcl));
      setText("[data-sp-cutsize-gst]", money(pr.gst));
      setText("[data-sp-cutsize-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, cfg.maxQty || null, cfg.discountOffset || 0);

      setProp("Material", mat.label);
      setProp("Size", L + " × " + W + " mm");
      setProp("Cutting Method", mat.method || "");
      setProp("Finish", FIXED.Finish || "");
      setProp("Colour", FIXED.Colour || "");
      setProp("Shape", shapeSel ? (shapeSel.value === "custom" ? "Custom (Outer shape only)" : "Standard (Square / Rectangle)") : "");
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    matSel.addEventListener("change", recalc);
    if (shapeSel) shapeSel.addEventListener("change", recalc);
    [lIn, wIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = MAX_QTY ? Math.min(MAX_QTY, (parseInt(qIn.value, 10) || 1) + 1) : (parseInt(qIn.value, 10) || 1) + 1; recalc(); });

    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-cutsize-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var mat = findMat();
        var L = parseInt(lIn.value, 10);
        var W = parseInt(wIn.value, 10);
        var qty = parseInt(qIn.value, 10);
        if (!mat || !L || L < MIN_DIM || L > MAX_L || !W || W < MIN_DIM || W > MAX_W || !qty || qty < 1 || (MAX_QTY && qty > MAX_QTY)) { recalc(); return; }
        // Never coerce the shape: custom-internal (or any non rect/custom value) is
        // quote-only and must not be silently priced as standard. Abort instead.
        // When the shape field isn't present (e.g. stencil) the value is a plain rect.
        var shapeVal = shapeSel ? shapeSel.value : "rect";
        if (shapeVal !== "rect" && shapeVal !== "custom") {
          if (errEl) { errEl.textContent = "This shape is quote-only. Please contact us for a quote on this configuration."; errEl.classList.remove("hidden"); }
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-cutsize-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { key: cfg.key, material: mat.label, lengthMm: L, widthMm: W, shape: shapeVal, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/cutsize/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again."); return r.json(); });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- ACP (Aluminium Composite Panel) Cut-to-Size calculator ---------- */
  document.querySelectorAll("[data-sp-acp-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-acp-cfg]").textContent); } catch (e) { return; }
    if (!cfg) return;

    // DOM refs
    var shapeSel  = root.querySelector("[data-sp-shape]");
    var finishSel = root.querySelector("[data-sp-acp-finish]");
    var lIn       = root.querySelector("[data-sp-acp-l]");
    var wIn       = root.querySelector("[data-sp-acp-w]");
    var qIn       = root.querySelector("[data-sp-acp-qty]");
    var qMinus    = root.querySelector("[data-sp-acp-qty-minus]");
    var qPlus     = root.querySelector("[data-sp-acp-qty-plus]");
    var errEl     = root.querySelector("[data-sp-acp-error]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn    = productRoot ? productRoot.querySelector("[data-sp-add]")       : null;
    var addLabel  = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;
    var apiBase   = (root.getAttribute("data-sp-acp-api") || "").trim().replace(/\/+$/, "");

    // Unpack config
    var SHEET_L   = cfg.sheetL;
    var SHEET_W   = cfg.sheetW;
    var WHITE_COST   = cfg.whiteCost;
    var COLOURED_COST = cfg.colouredCost;
    var PRICING_METHOD = cfg.pricingMethod; // "NESTING" | "AREA"
    var GAP       = cfg.gap;
    var EDGE      = cfg.edge;
    var CUT_RATE  = cfg.cutRate;
    var CUT_SPEED = cfg.cutSpeed;
    var CUT_MIN   = cfg.cutMin;
    var MARKUP    = cfg.markup;
    var HANDLING  = cfg.handling;
    var VINYL_RATES = cfg.vinylRates;  // { WHITE_DIGITAL_PRINT: 38.4, WHITE_CAST: 48 }
    var VINYL_WASTE = cfg.vinylWaste;
    var VINYL_INIT  = cfg.vinylInit;
    var VINYL_INCL  = cfg.vinylIncl;
    var VINYL_ADD   = cfg.vinylAdd;
    var FINISHES  = cfg.finishes;
    var SHEET_AREA = (SHEET_L / 1000) * (SHEET_W / 1000);

    // Populate finish dropdown from config
    FINISHES.forEach(function (f) {
      var opt = document.createElement("option");
      opt.value = f.value;
      opt.textContent = f.label;
      finishSel.appendChild(opt);
    });

    // Helpers
    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) {
      return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function setText(attr, v) {
      var el = root.querySelector("[" + attr + "]");
      if (el) el.textContent = v;
    }
    function setProp(name, v) {
      var el = root.querySelector('[data-sp-acp-prop="' + name + '"]');
      if (el) el.value = v;
    }

    // Nesting engine (mirrors acp.ts calculateNestingYield)
    function nestOrient(panelL, panelW) {
      var usableL = SHEET_L - 2 * EDGE;
      var usableW = SHEET_W - 2 * EDGE;
      var g = GAP;
      var inL = Math.floor((usableL + g) / (panelL + g));
      var inW = Math.floor((usableW + g) / (panelW + g));
      return Math.max(0, inL * inW);
    }
    function bestYield(L, W) {
      return Math.max(1, nestOrient(L, W), nestOrient(W, L));
    }

    // Sub-calculators
    function calcMaterial(finishVal, L, W, qty) {
      var sheetCost = (finishVal === "COLOURED") ? COLOURED_COST : WHITE_COST;
      if (PRICING_METHOD === "NESTING") {
        var sheets = Math.ceil(qty / bestYield(L, W));
        return round2(sheets * sheetCost);
      }
      var area = (L / 1000) * (W / 1000) * qty;
      return round2((area / SHEET_AREA) * sheetCost);
    }
    function calcVinylMat(finishVal, totalArea) {
      var rate = VINYL_RATES[finishVal];
      if (!rate) return 0;
      return round2(totalArea * VINYL_WASTE * rate);
    }
    function calcVinylApp(finishVal, totalArea) {
      if (!VINYL_RATES[finishVal] || totalArea <= 0) return 0;
      if (totalArea <= VINYL_INCL) return VINYL_INIT;
      return round2(VINYL_INIT + (totalArea - VINYL_INCL) * VINYL_ADD);
    }

    // Compute total for a given qty (used by the live per-piece panel)
    function totalForQty(finishVal, L, W, qty, shapeFactor) {
      var mat = calcMaterial(finishVal, L, W, qty);
      var cutTime = Math.max((2 * (L + W) * qty) / CUT_SPEED, CUT_MIN);
      var cut = (cutTime / 60) * CUT_RATE;
      var mkp = (mat + cut) * MARKUP;
      var pre = (mat + cut + mkp) * shapeFactor;
      var ta = (L / 1000) * (W / 1000) * qty;
      var vm = calcVinylMat(finishVal, ta);
      var va = calcVinylApp(finishVal, ta);
      return round2((round2(pre + HANDLING + vm + va)) * 1.1);
    }

    function dash() {
      ["data-sp-acp-material","data-sp-acp-cutting","data-sp-acp-vinyl","data-sp-acp-handling",
       "data-sp-acp-sell","data-sp-acp-gst","data-sp-acp-total"].forEach(function (a) { setText(a, "—"); });
      var vRow = root.querySelector("[data-sp-acp-vinyl-row]");
      if (vRow) { vRow.classList.add("hidden"); vRow.classList.remove("flex"); }
      spClearLead(root);
    }

    function recalc() {
      var finishVal = finishSel.value;
      var L   = parseInt(lIn.value, 10);
      var W   = parseInt(wIn.value, 10);
      var qty = parseInt(qIn.value, 10);
      var shapeVal = shapeSel ? shapeSel.value : "rect";

      // Validation
      var err = "";
      if (!L || isNaN(L) || L < 1)           err = "Please enter a valid Length in mm.";
      else if (L < 100)                     err = "Minimum length is 100mm \u2014 our equipment cannot cut panels smaller than this. Please enter 100mm or more.";
      else if (!W || isNaN(W) || W < 1)     err = "Please enter a valid Width in mm.";
      else if (W < 100)                     err = "Minimum width is 100mm \u2014 our equipment cannot cut panels smaller than this. Please enter 100mm or more.";
      else if (!((L <= SHEET_L && W <= SHEET_W) || (L <= SHEET_W && W <= SHEET_L))) {
        err = "Maximum single panel size is " + SHEET_L + " \u00d7 " + SHEET_W +
              " mm. Please reduce your dimensions or contact us for larger fabricated panels.";
      } else if (!qty || qty < 1 || isNaN(qty)) err = "Quantity must be at least 1.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn)   addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your config";
        dash();
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var shapeFactor = (shapeVal === "custom") ? 1.25 : 1;
      var mat  = calcMaterial(finishVal, L, W, qty);
      var cutTime = Math.max((2 * (L + W) * qty) / CUT_SPEED, CUT_MIN);
      var cut  = (cutTime / 60) * CUT_RATE;
      var mkp  = (mat + cut) * MARKUP;
      var pre  = (mat + cut + mkp) * shapeFactor;
      var ta   = (L / 1000) * (W / 1000) * qty;
      var vm   = calcVinylMat(finishVal, ta);
      var va   = calcVinylApp(finishVal, ta);
      var vinylTotal = round2(vm + va);
      var sellExcl   = round2(pre + HANDLING + vinylTotal);
      var gst  = round2(sellExcl * 0.1);
      var total = round2(sellExcl * 1.1);

      // Quantize per-piece so qty × unit = total exactly
      var unitCents = Math.max(1, Math.round(Math.round(total * 100) / qty));
      var chargedTotal = round2((unitCents * qty) / 100);

      // Presentation split: Material is the remainder so the lines sum exactly.
      var dispCut  = round2(cut * shapeFactor);
      var dispVinyl = vinylTotal;
      var dispHandl = HANDLING;
      var dispMat  = round2(sellExcl - dispCut - dispHandl - dispVinyl);

      setText("data-sp-acp-material", money(dispMat));
      setText("data-sp-acp-cutting",  money(dispCut));
      setText("data-sp-acp-handling", money(dispHandl));
      setText("data-sp-acp-sell",     money(sellExcl));
      setText("data-sp-acp-gst",      money(gst));
      setText("data-sp-acp-total",    money(chargedTotal));

      // Vinyl row visibility
      var vRow = root.querySelector("[data-sp-acp-vinyl-row]");
      if (vinylTotal > 0) {
        setText("data-sp-acp-vinyl", money(dispVinyl));
        if (vRow) { vRow.classList.remove("hidden"); vRow.classList.add("flex"); }
      } else {
        if (vRow) { vRow.classList.add("hidden"); vRow.classList.remove("flex"); }
      }

      // Live per-piece panel
      var fv = finishVal, lv = L, wv = W, sf = shapeFactor;
      spLivePanel(root, function (q) {
        var t = totalForQty(fv, lv, wv, q, sf);
        var uc = Math.max(1, Math.round(Math.round(t * 100) / q));
        return uc / 100;
      }, qty, 1, null, 0);

      // Line-item properties
      var finishLabel = "";
      for (var fi = 0; fi < FINISHES.length; fi++) {
        if (FINISHES[fi].value === finishVal) { finishLabel = FINISHES[fi].label; break; }
      }
      setProp("Finish", finishLabel);
      setProp("Size", L + " \u00d7 " + W + " mm");
      setProp("Shape", shapeVal === "custom" ? "Custom (Outer shape only)" : "Standard (Square / Rectangle)");
      setProp("Quantity", String(qty));

      if (addBtn)   addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    // Event listeners
    finishSel.addEventListener("change", recalc);
    if (shapeSel) shapeSel.addEventListener("change", recalc);
    [lIn, wIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    if (qIn) qIn.addEventListener("input", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () {
      qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc();
    });
    if (qPlus && qIn) qPlus.addEventListener("click", function () {
      qIn.value = (parseInt(qIn.value, 10) || 1) + 1; recalc();
    });

    // Cart submit
    var form = root.closest("form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var shapeVal = shapeSel ? shapeSel.value : "rect";
        if (shapeVal === "custom-internal") {
          if (errEl) {
            errEl.textContent = "This shape is quote-only. Please contact us for a quote on this configuration.";
            errEl.classList.remove("hidden");
          }
          return;
        }
        var L   = parseInt(lIn.value, 10);
        var W   = parseInt(wIn.value, 10);
        var qty = parseInt(qIn.value, 10);
        if (!L || L < 1 || !W || W < 1 || !qty || qty < 1) { recalc(); return; }
        if (!apiBase) {
          if (errEl) {
            errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order.";
            errEl.classList.remove("hidden");
          }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");

        var imageUrl = (root.getAttribute("data-sp-acp-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = {
          finish: finishSel.value,
          lengthMm: L,
          widthMm: W,
          shape: shapeVal,
          qty: qty
        };
        if (imageUrl) payload.imageUrl = imageUrl;

        fetch(apiBase + "/api/acp/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            return r.json().then(
              function (j) { return { ok: r.ok, body: j }; },
              function ()  { return { ok: false, body: null }; }
            );
          })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn\u2019t price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn\u2019t add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) {
              errEl.textContent = (err && err.message) || "Something went wrong. Please try again.";
              errEl.classList.remove("hidden");
            }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- Banner / Fence Mesh calculator (length-based, no markup) ---------- */
  document.querySelectorAll("[data-sp-mesh-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-mesh-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var gradeSel = root.querySelector("[data-sp-mesh-grade]");
    var heightSel = root.querySelector("[data-sp-mesh-height]");
    var lengthIn = root.querySelector("[data-sp-mesh-length]");
    var designsIn = root.querySelector("[data-sp-mesh-designs]");
    var qtyIn = root.querySelector("[data-sp-mesh-qty]");
    var errEl = root.querySelector("[data-sp-mesh-error]");
    var rollRow = root.querySelector("[data-sp-mesh-roll-row]");
    var bannerRow = root.querySelector("[data-sp-mesh-banner-row]");
    var designsRow = root.querySelector("[data-sp-mesh-designs-row]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var GRADES = cfg.grades || [], HEIGHTS = cfg.heights || [], ROLL_LEN = cfg.rollLength, ROLL_RATE = cfg.rollRate, BANNER_RATE = cfg.bannerRate, MAX_LEN = cfg.maxLength, GST_RATE = cfg.gstRate, GRADE_MULT = cfg.gradeMultipliers || {};

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-mesh-prop="' + name + '"]'); if (el) el.value = v; }
    function dash() {
      setText("[data-sp-mesh-total-len]", "—");
      setText("[data-sp-mesh-sell]", "—"); setText("[data-sp-mesh-gst]", "—"); setText("[data-sp-mesh-total]", "—");
      if (rollRow) { rollRow.classList.add("hidden"); rollRow.classList.remove("flex"); }
      if (bannerRow) { bannerRow.classList.add("hidden"); bannerRow.classList.remove("flex"); }
      if (designsRow) { designsRow.classList.add("hidden"); designsRow.classList.remove("flex"); }
    }

    // Total priced length = quantity × length-each. Pricing (roll vs remainder)
    // is applied to that combined total, so 5 × 20 m and 1 × 100 m both bill as
    // 100 m. Returns { error } on invalid input, else the parsed order.
    function readOrder() {
      var grade = gradeSel.value;
      var height = parseFloat(heightSel.value);
      var lengthEach = parseFloat(lengthIn.value);
      var designs = parseInt(designsIn && designsIn.value, 10) || 1;
      var qty = qtyIn ? Number(qtyIn.value) : 1;
      var err = "";
      if (GRADES.indexOf(grade) < 0) err = "Please choose a mesh material.";
      else if (HEIGHTS.indexOf(height) < 0) err = "Please choose a valid height.";
      else if (!isFinite(lengthEach) || lengthEach < 1) err = "Length each must be at least 1 m.";
      else if (!Number.isInteger(qty) || qty < 1) err = "Quantity must be a whole number of 1 or more.";
      else if (designs < 1 || designs > 100) err = "Number of unique designs must be between 1 and 100.";
      else if (designs > qty) err = "Unique designs cannot exceed the quantity. Please increase the quantity.";
      else {
        var totalLen = round2(qty * lengthEach);
        if (totalLen < 1 || totalLen > MAX_LEN) err = "Total length must be between 1 and " + MAX_LEN + " m.";
      }
      if (err) return { error: err };
      return { grade: grade, height: height, lengthEach: lengthEach, designs: designs, qty: qty, totalLen: round2(qty * lengthEach) };
    }

    function recalc() {
      var o = readOrder();

      if (o.error) {
        if (errEl) { errEl.textContent = o.error; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your config";
        dash();
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var grade = o.grade, height = o.height, length = o.totalLen;
      var mult = GRADE_MULT[grade] || 1;
      var fullRolls = Math.floor(length / ROLL_LEN);
      var remainder = round2(length - fullRolls * ROLL_LEN);
      var rollCost = fullRolls * ROLL_LEN * height * ROLL_RATE * mult;
      var bannerCost = remainder * height * BANNER_RATE * mult;
      // Unique Designs: flat (designs−1)×$10 inc GST once, added after the length
      // pricing and NOT multiplied by anything (ex-GST equivalent).
      var designsExcl = o.designs > 1 ? (o.designs - 1) * 10 / (1 + GST_RATE) : 0;
      var sellExcl = round2(rollCost + bannerCost + designsExcl);
      var gst = round2(sellExcl * GST_RATE);
      var total = round2(sellExcl * (1 + GST_RATE));

      setText("[data-sp-mesh-total-len]", o.qty > 1 ? (o.qty + " × " + o.lengthEach + " m = " + length + " m") : (length + " m"));

      if (fullRolls > 0) {
        if (rollRow) { rollRow.classList.remove("hidden"); rollRow.classList.add("flex"); }
        setText("[data-sp-mesh-rolls]", String(fullRolls));
        setText("[data-sp-mesh-roll-cost]", money(round2(rollCost)));
      } else if (rollRow) { rollRow.classList.add("hidden"); rollRow.classList.remove("flex"); }
      // Remainder row only shown alongside full rolls — for orders under one
      // roll length it just duplicates the Subtotal, so it stays hidden.
      if (remainder > 0 && fullRolls > 0) {
        if (bannerRow) { bannerRow.classList.remove("hidden"); bannerRow.classList.add("flex"); }
        setText("[data-sp-mesh-remainder]", String(remainder));
        setText("[data-sp-mesh-banner-cost]", money(round2(bannerCost)));
      } else if (bannerRow) { bannerRow.classList.add("hidden"); bannerRow.classList.remove("flex"); }
      if (designsExcl > 0) {
        if (designsRow) { designsRow.classList.remove("hidden"); designsRow.classList.add("flex"); }
        setText("[data-sp-mesh-designs-cost]", money(round2(designsExcl)));
      } else if (designsRow) { designsRow.classList.add("hidden"); designsRow.classList.remove("flex"); }
      setText("[data-sp-mesh-sell]", money(sellExcl));
      setText("[data-sp-mesh-gst]", money(gst));
      setText("[data-sp-mesh-total]", money(total));

      setProp("Grade", grade);
      setProp("Height", height + " m");
      // For a single continuous run keep just the total; only list pieces/each
      // when the customer ordered multiple lengths.
      setProp("Quantity", o.qty > 1 ? String(o.qty) : "");
      setProp("Length Each", o.qty > 1 ? (o.lengthEach + " m") : "");
      setProp("Total Length", length + " m");
      setProp("Unique Designs", String(o.designs));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    gradeSel.addEventListener("change", recalc);
    heightSel.addEventListener("change", recalc);
    if (lengthIn) lengthIn.addEventListener("input", recalc);
    if (qtyIn) qtyIn.addEventListener("input", recalc);
    spWireDesignsStepper(root, "sp-mesh-designs", recalc);

    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-mesh-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var o = readOrder();
        if (o.error) { recalc(); return; }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-mesh-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        // Backend prices by total linear length (roll + remainder), so send the
        // combined length; the per-piece breakdown travels as line-item props.
        var payload = { grade: o.grade, heightM: o.height, lengthM: o.totalLen, designs: o.designs };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/mesh/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again."); return r.json(); });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- Mobile collection introduction disclosure ---------- */
  document.querySelectorAll("[data-sp-col-desc-wrap]").forEach(function (wrap) {
    var body = wrap.querySelector("[data-sp-col-desc-body]");
    var toggle = wrap.querySelector("[data-sp-desc-toggle]");
    if (!body || !toggle) return;
    toggle.addEventListener("click", function () {
      var collapsed = body.classList.toggle("sp-col-intro-collapsed");
      toggle.textContent = collapsed ? "Read more" : "Show less";
      toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
      if (collapsed && wrap.getBoundingClientRect().top < 0) {
        wrap.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  });

  /* ---------- Long product description "Read more" (blue text link) ---------- */
  document.querySelectorAll("[data-sp-desc-more]").forEach(function (wrap) {
    var body = wrap.querySelector("[data-sp-desc-body]");
    var toggle = wrap.querySelector("[data-sp-desc-toggle]");
    if (!body || !toggle) return;
    toggle.addEventListener("click", function () {
      var clamped = body.classList.toggle("sp-desc-clamped");
      toggle.textContent = clamped ? "Read more" : "Read less";
      toggle.setAttribute("aria-expanded", clamped ? "false" : "true");
      // On collapse, keep the description in view instead of stranding the
      // user far below where the shortened block now ends.
      if (clamped && wrap.getBoundingClientRect().top < 0) wrap.scrollIntoView({ block: "start", behavior: "smooth" });
    });
  });

  /* ---------- Custom Brag Mats / Fishing Rulers calculator (tiered, min 10) ---------- */
  document.querySelectorAll("[data-sp-bragmat-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-bragmat-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var sizeSel = root.querySelector("[data-sp-bragmat-size]");
    var noseSel = root.querySelector("[data-sp-bragmat-nose]");
    var endSel = root.querySelector("[data-sp-bragmat-end]");
    var designsIn = root.querySelector("[data-sp-bragmat-designs]");
    var qIn = root.querySelector("[data-sp-bragmat-qty]");
    var qMinus = root.querySelector("[data-sp-bragmat-qty-minus]");
    var qPlus = root.querySelector("[data-sp-bragmat-qty-plus]");
    var errEl = root.querySelector("[data-sp-bragmat-error]");
    var discRow = root.querySelector("[data-sp-bragmat-discount-row]");
    var setupRow = root.querySelector("[data-sp-bragmat-setup-row]");
    var designsRow = root.querySelector("[data-sp-bragmat-designs-row]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var SIZES = cfg.sizes || [], NOSES = cfg.noses || [], ENDS = cfg.ends || [];
    var MIN_QTY = cfg.minQty, SETUP_FEE = cfg.setupFee, SETUP_BELOW = cfg.setupBelow;
    var VOL_TIERS = cfg.volTiers || [], GST_RATE = cfg.gstRate;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-bragmat-prop="' + name + '"]'); if (el) el.value = v; }
    function findOpt(arr, val) { for (var i = 0; i < arr.length; i++) { if (arr[i].label === val) return arr[i]; } return null; }
    function dash() {
      setText("[data-sp-bragmat-unit]", "—");
      setText("[data-sp-bragmat-sell]", "—"); setText("[data-sp-bragmat-gst]", "—"); setText("[data-sp-bragmat-total]", "—");
      if (discRow) { discRow.classList.add("hidden"); discRow.classList.remove("flex"); }
      if (setupRow) { setupRow.classList.add("hidden"); setupRow.classList.remove("flex"); }
      if (designsRow) { designsRow.classList.add("hidden"); designsRow.classList.remove("flex"); }
      spClearLead(root);
    }

    function recalc() {
      var size = findOpt(SIZES, sizeSel.value);
      var nose = findOpt(NOSES, noseSel.value);
      var end = findOpt(ENDS, endSel.value);
      var designs = parseInt(designsIn && designsIn.value, 10) || 1;
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (!size || !nose || !end) err = "Please choose valid options.";
      else if (!qty || qty < MIN_QTY) err = "Minimum order is " + MIN_QTY + " units.";
      else if (designs < 1 || designs > 100) err = "Number of unique designs must be between 1 and 100.";
      else if (designs > qty) err = "Unique designs cannot exceed the quantity. Please increase the quantity.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your config";
        dash();
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var unit = round2(size.base + nose.add + end.add);
      // Unique Designs: flat (designs−1)×$10 inc GST once, added AFTER discount/setup
      // and NOT multiplied by anything (ex-GST equivalent).
      var designsExcl = designs > 1 ? (designs - 1) * 10 / (1 + GST_RATE) : 0;
      // Per-unit drops via volume-discount tiers + setup-fee amortization.
      function priceAt(q) {
        var subtotal = unit * q;
        var discountRate = 0;
        for (var i = 0; i < VOL_TIERS.length; i++) { if (q >= VOL_TIERS[i].from) { discountRate = VOL_TIERS[i].rate; break; } }
        var discounted = subtotal * (1 - discountRate);
        var setupFee = q < SETUP_BELOW ? SETUP_FEE : 0;
        var sellExcl = round2(discounted + setupFee + designsExcl);
        var gst = round2(sellExcl * GST_RATE);
        var total = round2(sellExcl * (1 + GST_RATE));
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { subtotal: subtotal, discountRate: discountRate, setupFee: setupFee, sellExcl: sellExcl, gst: gst, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      // "Material/Print" shows the undiscounted price for the whole set (unit × qty);
      // the optional discount + setup rows then sum to the Subtotal below.
      setText("[data-sp-bragmat-unit]", money(round2(pr.subtotal)));
      if (pr.discountRate > 0) {
        if (discRow) { discRow.classList.remove("hidden"); discRow.classList.add("flex"); }
        setText("[data-sp-bragmat-discount-pct]", String(Math.round(pr.discountRate * 100)));
        setText("[data-sp-bragmat-discount]", "−" + money(round2(pr.subtotal * pr.discountRate)));
      } else if (discRow) { discRow.classList.add("hidden"); discRow.classList.remove("flex"); }
      if (pr.setupFee > 0) {
        if (setupRow) { setupRow.classList.remove("hidden"); setupRow.classList.add("flex"); }
        setText("[data-sp-bragmat-setup]", money(pr.setupFee));
      } else if (setupRow) { setupRow.classList.add("hidden"); setupRow.classList.remove("flex"); }
      if (designsExcl > 0) {
        if (designsRow) { designsRow.classList.remove("hidden"); designsRow.classList.add("flex"); }
        setText("[data-sp-bragmat-designs-cost]", money(round2(designsExcl)));
      } else if (designsRow) { designsRow.classList.add("hidden"); designsRow.classList.remove("flex"); }
      setText("[data-sp-bragmat-sell]", money(pr.sellExcl));
      setText("[data-sp-bragmat-gst]", money(pr.gst));
      setText("[data-sp-bragmat-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, MIN_QTY, null);

      setProp("Size", size.label);
      setProp("Nose Piece", nose.label);
      setProp("End Piece", end.label);
      setProp("Unique Designs", String(designs));
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    sizeSel.addEventListener("change", recalc);
    noseSel.addEventListener("change", recalc);
    endSel.addEventListener("change", recalc);
    if (qIn) qIn.addEventListener("input", recalc);
    spWireDesignsStepper(root, "sp-bragmat-designs", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(MIN_QTY, (parseInt(qIn.value, 10) || MIN_QTY) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = (parseInt(qIn.value, 10) || MIN_QTY) + 1; recalc(); });

    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-bragmat-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var size = findOpt(SIZES, sizeSel.value);
        var nose = findOpt(NOSES, noseSel.value);
        var end = findOpt(ENDS, endSel.value);
        var designs = parseInt(designsIn && designsIn.value, 10) || 1;
        var qty = parseInt(qIn.value, 10);
        if (!size || !nose || !end || !qty || qty < MIN_QTY || designs < 1 || designs > 100 || designs > qty) { recalc(); return; }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-bragmat-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { size: size.label, nose: nose.label, end: end.label, designs: designs, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/bragmat/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again."); return r.json(); });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- Custom Stickers calculator (continuous size + formula) ---------- */
  document.querySelectorAll("[data-sp-stickers-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-stickers-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var matSel = root.querySelector("[data-sp-stickers-material]");
    var lamSel = root.querySelector("[data-sp-stickers-lamination]");
    var cutSel = root.querySelector("[data-sp-stickers-cut]");
    var sizeSel = root.querySelector("[data-sp-stickers-size]");
    var descEl = root.querySelector("[data-sp-stickers-material-desc]");
    var wIn = root.querySelector("[data-sp-stickers-w]");
    var hIn = root.querySelector("[data-sp-stickers-h]");
    var customEls = root.querySelectorAll("[data-sp-stickers-custom]");
    var designsIn = root.querySelector("[data-sp-stickers-designs]");
    var qIn = root.querySelector("[data-sp-stickers-qty]");
    var qMinus = root.querySelector("[data-sp-stickers-qty-minus]");
    var qPlus = root.querySelector("[data-sp-stickers-qty-plus]");
    var errEl = root.querySelector("[data-sp-stickers-error]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var CUSTOM = "__custom";

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-stickers-prop="' + name + '"]'); if (el) el.value = v; }
    function opt(value, label) { var o = document.createElement("option"); o.value = value; o.textContent = label; return o; }
    function find(arr, v) { for (var i = 0; i < arr.length; i++) { if (arr[i].value === v) return arr[i]; } return null; }

    cfg.materials.forEach(function (m) { matSel.appendChild(opt(m.value, m.label)); });
    cfg.cuts.forEach(function (c) { cutSel.appendChild(opt(c.value, c.label)); });
    cfg.sizes.forEach(function (s) { sizeSel.appendChild(opt(s.value, s.label)); });
    sizeSel.appendChild(opt(CUSTOM, "Custom size"));

    // Upgrade the material / lamination / cut pickers to show Easy Signs option
    // thumbnails + descriptions. Size stays a plain native select (no imagery).
    makeRichSelect(matSel, function (v) { return find(cfg.materials, v); }, { noThumb: true });
    makeRichSelect(cutSel, function (v) { return find(cfg.cuts, v); }, { noThumb: true });
    var lamRich = makeRichSelect(lamSel, function (v) { return find(cfg.laminations, v); }, { noThumb: true });

    // Lamination options depend on material (clear vinyl => gloss lamination only).
    function rebuildLam() {
      var prev = lamSel.value;
      lamSel.innerHTML = "";
      var allowed = cfg.laminations;
      if (matSel.value === cfg.clearMaterial) {
        allowed = cfg.laminations.filter(function (l) { return l.value === cfg.clearLam; });
      }
      allowed.forEach(function (l) { lamSel.appendChild(opt(l.value, l.label)); });
      if (find(allowed, prev)) lamSel.value = prev;
      if (lamRich) lamRich.rebuild();
    }

    function dims() {
      if (sizeSel.value === CUSTOM) return { w: parseFloat(wIn.value), h: parseFloat(hIn.value) };
      var s = find(cfg.sizes, sizeSel.value);
      return s ? { w: s.w, h: s.h } : { w: NaN, h: NaN };
    }

    function syncCustomVisibility() {
      var show = sizeSel.value === CUSTOM;
      customEls.forEach(function (el) { if (show) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); });
    }

    function recalc() {
      var mat = find(cfg.materials, matSel.value);
      var lam = find(cfg.laminations, lamSel.value);
      var cut = find(cfg.cuts, cutSel.value);
      var d = dims();
      var W = d.w, H = d.h;
      var designs = parseInt(designsIn.value, 10);
      var qty = parseInt(qIn.value, 10);

      if (descEl && mat) descEl.textContent = mat.desc || "";

      var err = "";
      if (!mat || !lam || !cut) err = "Please choose all options.";
      else if (!W || W < cfg.minDim || W > cfg.maxDim) err = "Width must be between " + cfg.minDim + " and " + cfg.maxDim + " mm.";
      else if (!H || H < cfg.minDim || H > cfg.maxDim) err = "Height must be between " + cfg.minDim + " and " + cfg.maxDim + " mm.";
      else if (!designs || designs < 1 || designs > cfg.maxDesigns) err = "Number of designs must be between 1 and " + cfg.maxDesigns + ".";
      else if (!qty || qty < 1 || qty > cfg.maxQty) err = "Quantity must be between 1 and " + cfg.maxQty + ".";
      else if (designs > qty) err = "Unique designs cannot exceed the quantity. Please increase the quantity.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your options";
        setText("[data-sp-stickers-cost-material]", "—");
        setText("[data-sp-stickers-cutting]", "—");
        setText("[data-sp-stickers-handling]", "—");
        setText("[data-sp-stickers-sell]", "—");
        setText("[data-sp-stickers-gst]", "—");
        setText("[data-sp-stickers-total]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var area = W * H;
      var areaScale = Math.sqrt(area / cfg.areaRef);
      var isCustomShape = cut.value === "custom-contour";
      // Unique Designs: (designs−1) × $10 inc GST once per order (ex-GST equivalent).
      var designsExcl = designs > 1 ? (designs - 1) * 10 / (1 + cfg.gstRate) : 0;
      // Per-sticker price with qty discount: 0% at qty 1, 15% at qty 2, 30% max at qty ≥ 30.
      // discount(q) = min(maxDiscount, maxDiscount × (q−1)^qtyDiscAlpha / 2)
      // Mirrors server-side qtyDiscount() in pricing/stickers.ts — keep in sync.
      function qtyDiscount(q) {
        if (q <= 1) return 0;
        if (q >= cfg.qtyDiscMaxQty) return cfg.maxDiscount;
        return cfg.maxDiscount * Math.pow(q - 1, cfg.qtyDiscAlpha) / 2;
      }
      function priceAt(q) {
        var discount = qtyDiscount(q);
        var base = cfg.k * Math.pow(area, cfg.areaExp) * mat.mult; // per-unit at qty 1
        var matPart = base * q * (1 - discount); // base material only (ex lamination)
        var lamPart = lam.add * areaScale * q; // lamination add-on (NOT multiplied by shape)
        var cutPart = isCustomShape ? 0.25 * matPart : 0; // Custom Shape = 25% of material
        var preFloor = matPart + lamPart + cutPart;
        var subtotal = Math.max(cfg.minOrder, preFloor);
        var sellExcl = round2(subtotal + designsExcl);
        var gst = round2(sellExcl * cfg.gstRate);
        var total = round2(sellExcl * (1 + cfg.gstRate));
        // Split into Material / Cutting / Handling & Setup (mirrors server stickers.ts
        // decomposeStickers). The three ALWAYS sum to sellExcl (Material is remainder).
        // designsExcl steers into Handling; cutPart (custom 25%) into Cutting.
        var topUp = Math.max(0, subtotal - preFloor); // min-order floor → setup
        var cutting = cfg.cutShare * matPart + cutPart;
        var handling = cfg.handlingShare * matPart + designsExcl + topUp;
        var cap = sellExcl * (1 - cfg.materialMinShare);
        var sum = cutting + handling;
        if (sum > cap && sum > 0) { var scale = cap / sum; cutting *= scale; handling *= scale; }
        // Integer-cent finalize: Material is the exact remainder; ensure each line
        // is >= 1c when the subtotal allows (>= 3c). Mirrors server finalizeSplit.
        var Sc = Math.round(sellExcl * 100);
        var cc = Math.max(0, Math.min(Math.round(cutting * 100), Sc));
        var hc = Math.max(0, Math.min(Math.round(handling * 100), Sc - cc));
        if (Sc >= 3) {
          if (cc < 1) cc = 1;
          if (hc < 1) hc = 1;
          var deficit = 1 - (Sc - cc - hc);
          while (deficit > 0 && (cc > 1 || hc > 1)) {
            if (hc >= cc && hc > 1) { hc -= 1; } else { cc -= 1; }
            deficit -= 1;
          }
        }
        cutting = cc / 100;
        handling = hc / 100;
        var material = (Sc - cc - hc) / 100;
        // Cart line carries quantity = stickers, so the variant is priced per sticker.
        // Quantize so quantity × unit equals the charged total exactly.
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { sellExcl: sellExcl, gst: gst, material: material, cutting: cutting, handling: handling, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      setText("[data-sp-stickers-cost-material]", money(pr.material));
      setText("[data-sp-stickers-cutting]", money(pr.cutting));
      setText("[data-sp-stickers-handling]", money(pr.handling));
      setText("[data-sp-stickers-sell]", money(pr.sellExcl));
      setText("[data-sp-stickers-gst]", money(pr.gst));
      setText("[data-sp-stickers-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, cfg.maxQty);

      setProp("Material", mat.label);
      setProp("Lamination", lam.label);
      setProp("Shape", cut.label);
      setProp("Size", W + " × " + H + " mm");
      setProp("Unique Designs", String(designs));
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    matSel.addEventListener("change", function () { rebuildLam(); recalc(); });
    lamSel.addEventListener("change", recalc);
    cutSel.addEventListener("change", recalc);
    sizeSel.addEventListener("change", function () { syncCustomVisibility(); recalc(); });
    [wIn, hIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    spWireDesignsStepper(root, "sp-stickers-designs", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = Math.min(cfg.maxQty, (parseInt(qIn.value, 10) || 1) + 1); recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant.
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-stickers-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var mat = find(cfg.materials, matSel.value);
        var lam = find(cfg.laminations, lamSel.value);
        var cut = find(cfg.cuts, cutSel.value);
        var d = dims();
        var W = d.w, H = d.h;
        var designs = parseInt(designsIn.value, 10);
        var qty = parseInt(qIn.value, 10);
        if (!mat || !lam || !cut || !W || W < cfg.minDim || W > cfg.maxDim || !H || H < cfg.minDim || H > cfg.maxDim || !designs || designs < 1 || designs > cfg.maxDesigns || !qty || qty < 1 || qty > cfg.maxQty || designs > qty) {
          recalc();
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-stickers-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { material: matSel.value, lamination: lamSel.value, cut: cutSel.value, widthMm: W, heightMm: H, numberOfDesigns: designs, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/stickers/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    rebuildLam();
    syncCustomVisibility();
    recalc();
  });

  /* ---------- Acrylic Lettering calculator (Sign Portal's own legacy formula) ---------- */
  document.querySelectorAll("[data-sp-lettering-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-lettering-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var thickSel = root.querySelector("[data-sp-lettering-thickness]");
    var colourSel = root.querySelector("[data-sp-lettering-colour]");
    var adhSel = root.querySelector("[data-sp-lettering-adhesive]");
    var tmplSel = root.querySelector("[data-sp-lettering-template]");
    var sizeIn = root.querySelector("[data-sp-lettering-size]");
    var textIn = root.querySelector("[data-sp-lettering-text]");
    var qIn = root.querySelector("[data-sp-lettering-qty]");
    var qMinus = root.querySelector("[data-sp-lettering-qty-minus]");
    var qPlus = root.querySelector("[data-sp-lettering-qty-plus]");
    var errEl = root.querySelector("[data-sp-lettering-error]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-lettering-prop="' + name + '"]'); if (el) el.value = v; }
    function opt(value, label) { var o = document.createElement("option"); o.value = value; o.textContent = label; return o; }
    function find(arr, v) { for (var i = 0; i < arr.length; i++) { if (arr[i].value === v) return arr[i]; } return null; }
    function textLen() { return (textIn.value || "").replace(/\s/g, "").length; }

    // ---------- Font picker (display-only; NEVER affects price) ----------
    // A lightweight searchable combobox. System fonts are pinned first (default
    // Arial), then the Google Fonts library. A Google webfont is fetched lazily
    // only when its family is actually selected, so the page never pulls the
    // whole library up front.
    var fontsCfg = null;
    try {
      var fontsEl = root.querySelector("[data-sp-lettering-fonts]");
      fontsCfg = fontsEl ? JSON.parse(fontsEl.textContent) : null;
    } catch (e) { fontsCfg = null; }
    var fontInput = root.querySelector("[data-sp-lettering-font-input]");
    var fontPanel = root.querySelector("[data-sp-lettering-font-panel]");
    var fontWrap = root.querySelector("[data-sp-lettering-fontpick]");
    var previewEl = root.querySelector("[data-sp-lettering-preview]");
    var scaleHost = root.querySelector("[data-sp-lettering-scale]");
    var dimsEl = root.querySelector("[data-sp-lettering-dims]");
    var dimsFriendlyEl = root.querySelector("[data-sp-lettering-dims-friendly]");

    var fontMeta = {};    // family -> { fallback, google }
    var fontGroups = [];  // [{ label, items: [family, ...] }]
    (function buildFontIndex() {
      if (!fontsCfg) return;
      var sys = (fontsCfg.system || []).map(function (f) { fontMeta[f.family] = { fallback: f.fallback || "sans-serif", google: false }; return f.family; });
      var goog = (fontsCfg.google || []).map(function (f) { fontMeta[f.family] = { fallback: f.fallback || "sans-serif", google: true }; return f.family; });
      if (sys.length) fontGroups.push({ label: "System", items: sys });
      if (goog.length) fontGroups.push({ label: "Google Fonts", items: goog });
    })();
    var selectedFont = (fontsCfg && fontsCfg.default && fontMeta[fontsCfg.default]) ? fontsCfg.default : (Object.keys(fontMeta)[0] || "Arial");
    if (!fontMeta[selectedFont]) fontMeta[selectedFont] = { fallback: "sans-serif", google: false };

    function fontCss(family) {
      var m = fontMeta[family] || { fallback: "sans-serif" };
      return '"' + family + '", ' + (m.fallback || "sans-serif");
    }
    var loadedFonts = {};
    function loadGoogleFont(family) {
      var m = fontMeta[family];
      if (!m || !m.google) return;
      var id = "sp-gfont-" + family.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      if (loadedFonts[id] || document.getElementById(id)) return;
      loadedFonts[id] = true;
      var link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=" + encodeURIComponent(family).replace(/%20/g, "+") + ":wght@400;700&display=swap";
      document.head.appendChild(link);
    }

    var fontOpen = false;
    function closeFontPanel() {
      if (!fontPanel) return;
      fontPanel.hidden = true; fontOpen = false;
      if (fontInput) { fontInput.setAttribute("aria-expanded", "false"); fontInput.value = selectedFont; }
    }
    function openFontPanel() {
      if (!fontPanel) return;
      fontPanel.hidden = false; fontOpen = true;
      if (fontInput) fontInput.setAttribute("aria-expanded", "true");
      renderFontList(fontInput ? fontInput.value : "");
    }
    function chooseFont(family) {
      if (!fontMeta[family]) return;
      selectedFont = family;
      loadGoogleFont(family);
      if (fontInput) fontInput.value = family;
      closeFontPanel();
      updateCosmetic();
    }
    // Lazily fetch a row's Google webfont only once it scrolls into view, so
    // opening the picker never fetches the whole ~65-font library up front.
    // The observer is scoped to the scrollable panel and rebuilt per render.
    var fontRowObserver = null;
    function ensureRowFont(fam) {
      var m = fontMeta[fam];
      if (!m || !m.google) return; // system fonts need no fetch
      loadGoogleFont(fam);
    }
    function renderFontList(filter) {
      if (!fontPanel) return;
      var q = (filter || "").trim().toLowerCase();
      // When the box still shows the selected family verbatim, treat it as "no
      // filter" so opening the picker always reveals the full grouped list.
      if (q === selectedFont.toLowerCase()) q = "";
      if (fontRowObserver) { fontRowObserver.disconnect(); fontRowObserver = null; }
      var supportsIO = typeof window.IntersectionObserver === "function";
      if (supportsIO) {
        fontRowObserver = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var fam = en.target.getAttribute("data-sp-font");
            if (fam) ensureRowFont(fam);
            obs.unobserve(en.target);
          });
        }, { root: fontPanel, rootMargin: "120px 0px" });
      }
      fontPanel.innerHTML = "";
      var any = false;
      fontGroups.forEach(function (g) {
        var matches = g.items.filter(function (fam) { return !q || fam.toLowerCase().indexOf(q) !== -1; });
        if (!matches.length) return;
        any = true;
        var head = document.createElement("div");
        head.className = "px-2 pb-1 pt-2 text-[11px] font-extrabold uppercase tracking-wide text-gray-400";
        head.textContent = g.label;
        fontPanel.appendChild(head);
        matches.forEach(function (fam) {
          var row = document.createElement("button");
          row.type = "button";
          row.className = "flex w-full items-center rounded-lg px-2 py-2 text-left text-[15px] leading-snug text-black hover:bg-gray-50" + (fam === selectedFont ? " bg-[#eef4ff]" : "");
          row.setAttribute("role", "option");
          row.setAttribute("aria-selected", fam === selectedFont ? "true" : "false");
          row.setAttribute("data-sp-font", fam);
          // Render the name in its own typeface (falls back to the family's
          // generic fallback until/if the webfont loads).
          row.style.fontFamily = fontCss(fam);
          row.textContent = fam;
          row.addEventListener("mousedown", function (e) { e.preventDefault(); });
          row.addEventListener("click", function () { chooseFont(fam); });
          fontPanel.appendChild(row);
          if (fontRowObserver) fontRowObserver.observe(row);
          else ensureRowFont(fam); // no IO support: fetch the filtered subset directly
        });
      });
      if (!any) {
        var none = document.createElement("div");
        none.className = "px-2 py-3 text-sm text-gray-500";
        none.textContent = "No fonts match \u201C" + (filter || "") + "\u201D.";
        fontPanel.appendChild(none);
      }
    }

    // ---------- Preview + approximate sign-size (both display-only) ----------
    function fmtDim(mm) {
      if (mm >= 1000) return (Math.round((mm / 1000) * 100) / 100) + " m";
      if (mm >= 100) return (Math.round((mm / 10) * 10) / 10) + " cm";
      return Math.round(mm) + " mm";
    }
    function renderScale(w, h, css, sample) {
      if (!scaleHost) return;
      scaleHost.innerHTML = "";
      var maxW = scaleHost.clientWidth || 320;
      var maxH = 150;
      var ratio = w / h;
      var dw = maxW, dh = dw / ratio;
      if (dh > maxH) { dh = maxH; dw = dh * ratio; }
      if (dw > maxW) { dw = maxW; dh = dw / ratio; }
      dw = Math.max(28, dw); dh = Math.max(18, dh);
      var box = document.createElement("div");
      box.className = "relative flex items-center justify-center overflow-hidden rounded border-2 border-dashed border-gray-300 bg-gray-50";
      box.style.width = dw + "px";
      box.style.height = dh + "px";
      var label = document.createElement("span");
      label.className = "px-1 font-bold text-gray-700";
      label.style.fontFamily = css;
      label.style.whiteSpace = "nowrap";
      label.style.lineHeight = "1";
      label.style.fontSize = Math.max(7, Math.min(dh * 0.5, (dw / Math.max(1, (sample || "").length)) * 1.4)) + "px";
      label.textContent = sample || "Your text";
      box.appendChild(label);
      scaleHost.appendChild(box);
    }
    function updateSize(css) {
      var H = parseFloat(sizeIn.value);
      var raw = textIn.value || "";
      var lines = raw.split(/\r?\n/).map(function (l) { return l.replace(/\s+$/, ""); });
      while (lines.length > 1 && lines[lines.length - 1] === "") lines.pop();
      var maxChars = 0;
      lines.forEach(function (l) { if (l.length > maxChars) maxChars = l.length; });
      var lineCount = Math.max(1, lines.length);
      if (!H || H <= 0 || maxChars < 1) {
        if (dimsEl) dimsEl.textContent = "\u2014";
        if (dimsFriendlyEl) { dimsFriendlyEl.textContent = ""; dimsFriendlyEl.classList.add("hidden"); }
        if (scaleHost) scaleHost.innerHTML = "";
        return;
      }
      // Width uses the SAME 0.75 ratio the pricing model uses, but counts spaces
      // (spaces aren't charged, yet they still take physical length on the sign).
      var w = maxChars * H * (cfg.widthRatio || 0.75);
      var h = lineCount * H;
      if (dimsEl) dimsEl.textContent = Math.round(w) + "mmW \u00D7 " + Math.round(h) + "mmH";
      if (dimsFriendlyEl) {
        if (w >= 1000 || h >= 1000) {
          dimsFriendlyEl.textContent = "\u2248 " + fmtDim(w) + " wide \u00D7 " + fmtDim(h) + " tall";
          dimsFriendlyEl.classList.remove("hidden");
        } else {
          dimsFriendlyEl.textContent = ""; dimsFriendlyEl.classList.add("hidden");
        }
      }
      renderScale(w, h, css, lines[0] || "");
    }
    function updateCosmetic() {
      var css = fontCss(selectedFont);
      if (previewEl) {
        var t = (textIn.value || "").replace(/\s+$/g, "");
        previewEl.textContent = t.length ? t : "Your text";
        previewEl.style.fontFamily = css;
      }
      if (textIn) textIn.style.fontFamily = css;
      setProp("Font", selectedFont);
      updateSize(css);
    }

    if (fontInput && fontPanel && fontGroups.length) {
      fontInput.value = selectedFont;
      loadGoogleFont(selectedFont);
      fontInput.addEventListener("focus", function () { openFontPanel(); fontInput.select(); });
      fontInput.addEventListener("click", function () { if (!fontOpen) openFontPanel(); });
      fontInput.addEventListener("input", function () { if (!fontOpen) openFontPanel(); else renderFontList(fontInput.value); });
      fontInput.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { closeFontPanel(); fontInput.blur(); }
        else if (e.key === "Enter") {
          e.preventDefault();
          var first = fontPanel.querySelector('[role="option"]');
          if (first) first.click();
        }
      });
      document.addEventListener("click", function (e) {
        if (fontOpen && fontWrap && !fontWrap.contains(e.target)) closeFontPanel();
      });
    } else if (fontInput) {
      fontInput.value = selectedFont;
    }

    cfg.thicknesses.forEach(function (t) { thickSel.appendChild(opt(t.value, t.label)); });
    cfg.adhesive.forEach(function (a) { adhSel.appendChild(opt(a.value, a.label)); });
    cfg.template.forEach(function (t) { tmplSel.appendChild(opt(t.value, t.label)); });

    // Display-only colour swatch. Clear renders as a transparent checkerboard,
    // Opal as milky white; named finishes map to a representative solid.
    var swatchEl = root.querySelector("[data-sp-lettering-swatch]");
    var CHECKER = "linear-gradient(45deg,#ccc 25%,transparent 25%),linear-gradient(-45deg,#ccc 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#ccc 75%),linear-gradient(-45deg,transparent 75%,#ccc 75%)";
    function updateSwatch() {
      if (!swatchEl) return;
      var c = colourSel.value || "";
      var lc = c.toLowerCase();
      swatchEl.style.background = "";
      swatchEl.style.backgroundImage = "";
      swatchEl.style.backgroundSize = "";
      swatchEl.style.backgroundPosition = "";
      if (lc === "clear") {
        swatchEl.style.backgroundColor = "#fff";
        swatchEl.style.backgroundImage = CHECKER;
        swatchEl.style.backgroundSize = "8px 8px";
        swatchEl.style.backgroundPosition = "0 0,0 4px,4px -4px,-4px 0";
      } else if (lc === "opal") {
        swatchEl.style.backgroundColor = "#f4f2ef";
      } else if (lc.indexOf("black") !== -1) {
        swatchEl.style.backgroundColor = "#111";
      } else if (lc.indexOf("white") !== -1) {
        swatchEl.style.backgroundColor = "#fff";
      } else if (lc.indexOf("gold") !== -1) {
        swatchEl.style.backgroundColor = "#d4af37";
      } else if (lc.indexOf("silver") !== -1) {
        swatchEl.style.backgroundColor = "#c0c0c0";
      } else {
        swatchEl.style.backgroundColor = "#e5e7eb";
      }
    }

    // Colour options depend on thickness (more finishes available on thinner acrylic).
    function rebuildColours() {
      var prev = colourSel.value;
      colourSel.innerHTML = "";
      var allowed = cfg.colours[thickSel.value] || [];
      allowed.forEach(function (c) { colourSel.appendChild(opt(c, c)); });
      if (allowed.indexOf(prev) !== -1) colourSel.value = prev;
      updateSwatch();
    }

    function recalc() {
      // Preview + approximate size are display-only and must reflect the current
      // text/size/font regardless of whether the pricing inputs validate.
      updateCosmetic();
      var thick = find(cfg.thicknesses, thickSel.value);
      var adh = find(cfg.adhesive, adhSel.value);
      var tmpl = find(cfg.template, tmplSel.value);
      var allowedColours = cfg.colours[thickSel.value] || [];
      var colour = colourSel.value;
      var H = parseFloat(sizeIn.value);
      var len = textLen();
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (!thick || !adh || !tmpl) err = "Please choose all options.";
      else if (allowedColours.indexOf(colour) === -1) err = "Please choose a colour.";
      else if (!H || H < cfg.minSize || H > cfg.maxSize) err = "Letter size must be between " + cfg.minSize + " and " + cfg.maxSize + " mm.";
      else if ((textIn.value || "").length > cfg.maxText) err = "Custom text must be at most " + cfg.maxText + " characters.";
      else if (len < 1) err = "Please enter the text for your lettering.";
      else if (!qty || qty < 1 || qty > cfg.maxQty) err = "Quantity must be between 1 and " + cfg.maxQty + ".";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your options";
        setText("[data-sp-lettering-peritem]", "—");
        setText("[data-sp-lettering-letters]", "—");
        setText("[data-sp-lettering-material]", "—");
        setText("[data-sp-lettering-cutting]", "—");
        setText("[data-sp-lettering-handling]", "—");
        setText("[data-sp-lettering-sell]", "—");
        setText("[data-sp-lettering-gst]", "—");
        setText("[data-sp-lettering-total]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var area = (H * (H * cfg.widthRatio)) / 1000000;
      var discount = H >= cfg.discountThreshold ? cfg.discountLarge : cfg.discountSmall;
      // Per-set drops with qty as the order minimum amortizes over more sets.
      function priceAt(q) {
        var acrylicPart = area * len * thick.rate * discount * q; // acrylic sheet (material + cutting)
        var adhPart = area * len * adh.add * q;
        var tmplPart = area * len * tmpl.add * q;
        var preFloor = acrylicPart + adhPart + tmplPart; // === perItem * q
        var subtotal = Math.max(cfg.minOrder, preFloor);
        var sellExcl = round2(subtotal);
        var gst = round2(sellExcl * cfg.gstRate);
        var total = round2(sellExcl * (1 + cfg.gstRate));
        // Split into Material / Cutting / Handling & Setup (mirrors server lettering.ts).
        // The three ALWAYS sum to sellExcl (Material is the remainder).
        var topUp = Math.max(0, sellExcl - preFloor); // min-order floor → setup
        var cutting = (thick.cutShare || 0) * acrylicPart;
        var handling = (cfg.handlingShare || 0) * acrylicPart + adhPart + tmplPart + topUp;
        // Integer-cent finalize: Material is the exact remainder; ensure each line
        // is >= 1c when the subtotal allows (>= 3c). Mirrors server finalizeSplit.
        var Sc = Math.round(sellExcl * 100);
        var cc = Math.max(0, Math.min(Math.round(cutting * 100), Sc));
        var hc = Math.max(0, Math.min(Math.round(handling * 100), Sc - cc));
        if (Sc >= 3) {
          if (cc < 1) cc = 1;
          if (hc < 1) hc = 1;
          var deficit = 1 - (Sc - cc - hc);
          while (deficit > 0 && (cc > 1 || hc > 1)) {
            if (hc >= cc && hc > 1) { hc -= 1; } else { cc -= 1; }
            deficit -= 1;
          }
        }
        cutting = cc / 100;
        handling = hc / 100;
        var material = (Sc - cc - hc) / 100;
        // Cart line carries quantity = sets, so the variant is priced per set.
        // Quantize so quantity × unit equals the charged total exactly.
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        return { subtotal: subtotal, sellExcl: sellExcl, gst: gst, material: material, cutting: cutting, handling: handling, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      // Per-letter price is the effective rate (min-order floor included) so
      // per-letter × letters × sets always equals the Subtotal shown.
      setText("[data-sp-lettering-peritem]", money(round2(pr.subtotal / qty / len)));
      setText("[data-sp-lettering-letters]", "x" + len);
      setText("[data-sp-lettering-material]", money(pr.material));
      setText("[data-sp-lettering-cutting]", money(pr.cutting));
      setText("[data-sp-lettering-handling]", money(pr.handling));
      setText("[data-sp-lettering-sell]", money(pr.sellExcl));
      setText("[data-sp-lettering-gst]", money(pr.gst));
      setText("[data-sp-lettering-total]", money(pr.chargedTotal));
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, cfg.maxQty);

      setProp("Thickness", thick.label);
      setProp("Colour", colour);
      setProp("Adhesive Backing", adh.label);
      setProp("Spacing Template", tmpl.label);
      setProp("Letter Size", H + " mm");
      setProp("Custom Text", textIn.value.trim());
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    thickSel.addEventListener("change", function () { rebuildColours(); recalc(); });
    colourSel.addEventListener("change", function () { updateSwatch(); recalc(); });
    adhSel.addEventListener("change", recalc);
    tmplSel.addEventListener("change", recalc);
    [sizeIn, textIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = Math.min(cfg.maxQty, (parseInt(qIn.value, 10) || 1) + 1); recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant.
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-lettering-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var thick = find(cfg.thicknesses, thickSel.value);
        var adh = find(cfg.adhesive, adhSel.value);
        var tmpl = find(cfg.template, tmplSel.value);
        var allowedColours = cfg.colours[thickSel.value] || [];
        var H = parseFloat(sizeIn.value);
        var len = textLen();
        var qty = parseInt(qIn.value, 10);
        if (!thick || !adh || !tmpl || allowedColours.indexOf(colourSel.value) === -1 || !H || H < cfg.minSize || H > cfg.maxSize || (textIn.value || "").length > cfg.maxText || len < 1 || !qty || qty < 1 || qty > cfg.maxQty) {
          recalc();
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-lettering-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { thickness: thickSel.value, colour: colourSel.value, adhesive: adhSel.value, template: tmplSel.value, letterSizeMm: H, text: textIn.value, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/lettering/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    rebuildColours();
    recalc();
  });

  /* ---------- Acrylic Signs (printed back-of-panel) calculator ---------- */
  document.querySelectorAll("[data-sp-acrylicprint-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-acrylicprint-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var presetSel = root.querySelector("[data-sp-acrylicprint-preset]");
    var thickSel = root.querySelector("[data-sp-acrylicprint-thickness]");
    var wIn = root.querySelector("[data-sp-acrylicprint-w]");
    var hIn = root.querySelector("[data-sp-acrylicprint-h]");
    var dimsWrap = root.querySelector("[data-sp-acrylicprint-dims]");
    var holesSel = root.querySelector("[data-sp-acrylicprint-holes]");
    var standoffSel = root.querySelector("[data-sp-acrylicprint-standoff]");
    var cuttingSel = root.querySelector("[data-sp-acrylicprint-cutting]");
    var designsIn = root.querySelector("[data-sp-acrylicprint-designs]");
    var qIn = root.querySelector("[data-sp-acrylicprint-qty]");
    var qMinus = root.querySelector("[data-sp-acrylicprint-qty-minus]");
    var qPlus = root.querySelector("[data-sp-acrylicprint-qty-plus]");
    var errEl = root.querySelector("[data-sp-acrylicprint-error]");

    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    var HOLE_RATE = cfg.holeRate, STANDOFF_AMOUNTS = cfg.standoffAmounts || {}, CUSTOM_MULT = cfg.customMult || 1.25,
        ARTWORK = cfg.artworkSurcharge, DELIVERY = cfg.delivery, GST_RATE = cfg.gstRate,
        MIN_DIM = cfg.minDim, MAX_DIM = cfg.maxDim, MAX_QTY = cfg.maxQty, MAX_DESIGNS = cfg.maxDesigns,
        QTY_TIERS = cfg.qtyTiers, THICK_MULT = cfg.thickMult, VALID_HOLES = cfg.validHoles;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setRow(sel, show) { var el = root.querySelector(sel); if (el) { if (show) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); } }
    function setProp(name, v) { var el = root.querySelector('[data-sp-acrylicprint-prop="' + name + '"]'); if (el) el.value = v; }

    // Base rate per m² for a given order quantity. Mirrors the server exactly
    // (quantity discounts stop deepening at cfg.discountCapQty units).
    function baseRateForQty(qty) {
      var q = cfg.discountCapQty ? Math.min(qty, cfg.discountCapQty) : qty;
      for (var i = 0; i < QTY_TIERS.length; i++) {
        var max = QTY_TIERS[i][0];
        if (max === null || q <= max) return QTY_TIERS[i][1];
      }
      return QTY_TIERS[QTY_TIERS.length - 1][1];
    }
    function multForThickness(t) {
      for (var i = 0; i < THICK_MULT.length; i++) { if (THICK_MULT[i][0] === t) return THICK_MULT[i][1]; }
      return null;
    }

    // Keep the size dropdown and the W/H inputs in sync.
    function applyPreset() {
      var v = presetSel ? presetSel.value : "custom";
      if (v && v.indexOf("x") > -1) {
        var parts = v.split("x");
        if (wIn) wIn.value = parts[0];
        if (hIn) hIn.value = parts[1];
      }
    }
    function syncPresetFromDims() {
      if (!presetSel) return;
      var key = (parseInt(wIn.value, 10) || 0) + "x" + (parseInt(hIn.value, 10) || 0);
      var match = "custom";
      for (var i = 0; i < presetSel.options.length; i++) { if (presetSel.options[i].value === key) { match = key; break; } }
      presetSel.value = match;
    }
    // Show the W×H inputs only while "Custom Size" is chosen (a preset already
    // fills them via applyPreset, so they stay hidden for preset sizes). Don't
    // yank a field the shopper is actively typing in — the blur handler reconciles.
    function syncPresetVisibility() {
      if (!dimsWrap) return;
      var custom = presetSel && presetSel.value === "custom";
      if (!custom && (document.activeElement === wIn || document.activeElement === hIn)) return;
      dimsWrap.hidden = !custom;
    }

    function recalc() {
      var W = parseInt(wIn.value, 10);
      var H = parseInt(hIn.value, 10);
      var t = parseFloat(thickSel.value);
      var holes = parseInt(holesSel.value, 10) || 0;
      var standoffCount = standoffSel ? String(parseInt(standoffSel.value, 10) || 0) : "0";
      var cutting = cuttingSel.value; // "standard" | "custom"
      var custom = cutting === "custom";
      var designs = parseInt(designsIn.value, 10);
      var qty = parseInt(qIn.value, 10);

      var err = "";
      if (multForThickness(t) === null) err = "That thickness isn't available.";
      else if (!W || W < MIN_DIM || W > MAX_DIM) err = "Width must be between " + MIN_DIM + " and " + MAX_DIM + " mm.";
      else if (!H || H < MIN_DIM || H > MAX_DIM) err = "Height must be between " + MIN_DIM + " and " + MAX_DIM + " mm.";
      else if (VALID_HOLES.indexOf(holes) === -1) err = "Number of holes must be 0, 2, 4, 6 or 8.";
      else if (!designs || designs < 1 || designs > MAX_DESIGNS) err = "Number of unique designs must be between 1 and " + MAX_DESIGNS + ".";
      else if (!qty || qty < 1 || qty > MAX_QTY) err = "Quantity must be between 1 and " + MAX_QTY + " signs.";
      else if (designs > qty) err = "Unique designs cannot exceed the quantity. Please increase the quantity.";

      if (err) {
        if (errEl) { errEl.textContent = err; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your options";
        setText("[data-sp-acrylicprint-total]", "—");
        setText("[data-sp-acrylicprint-sell]", "—");
        setText("[data-sp-acrylicprint-gst]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var mult = multForThickness(t);
      var area = (W / 1000) * (H / 1000);
      var drillPerSign = holes * HOLE_RATE;
      var standoffAdd = STANDOFF_AMOUNTS[standoffCount] || 0; // fixed $ per sign (0/39/55/69)
      var artworkTotal = designs > 1 ? (designs - 1) * ARTWORK : 0;
      // Per-sign drops with qty via the qty-tiered base rate + fixed artwork/delivery amortization.
      // panel = area × rate × thicknessMult × (custom?1.25); custom uplifts panel ONLY.
      function priceAt(q) {
        var panelPerSign = area * baseRateForQty(q) * mult * (custom ? CUSTOM_MULT : 1);
        var perSignParts = panelPerSign + drillPerSign + standoffAdd;
        var total = round2(q * perSignParts + artworkTotal + DELIVERY);
        var sellExcl = round2(total / (1 + GST_RATE));
        var gst = round2(sellExcl * GST_RATE);
        // Cart line carries quantity = signs, so the variant is priced per sign.
        // Quantize so quantity × unit equals the charged total exactly.
        var unitCents = Math.max(1, Math.round(Math.round(total * 100) / q));
        // Custom uplift shown on its own row = panel × 0.25 across the order.
        var customUplift = custom ? round2(q * (area * baseRateForQty(q) * mult) * (CUSTOM_MULT - 1)) : 0;
        return { panelPerSign: panelPerSign, customUplift: customUplift, total: total, sellExcl: sellExcl, gst: gst, chargedTotal: (unitCents * q) / 100, perPiece: unitCents / 100 };
      }
      var pr = priceAt(qty);

      // $70.00 ex-GST minimum order for acrylic signs. Applied AFTER the pricing
      // engine so the discount table (spLivePanel) is never altered — only the
      // displayed subtotal/GST/total and the headline per-sign price are adjusted.
      var AP_MIN_EXCL = 70;
      var AP_MIN_TOTAL = round2(AP_MIN_EXCL * (1 + GST_RATE)); // 77.00 incl. GST
      var minApplied = pr.sellExcl < AP_MIN_EXCL;
      var dispSellExcl = minApplied ? AP_MIN_EXCL : pr.sellExcl;
      var dispGst      = minApplied ? round2(AP_MIN_EXCL * GST_RATE) : pr.gst;
      var dispTotal    = minApplied ? AP_MIN_TOTAL : pr.chargedTotal;

      setRow("[data-sp-acrylicprint-drill-row]", drillPerSign > 0);
      setText("[data-sp-acrylicprint-drill]", money(round2(qty * drillPerSign)));
      setRow("[data-sp-acrylicprint-standoff-row]", standoffAdd > 0);
      setText("[data-sp-acrylicprint-standoff-cost]", money(round2(qty * standoffAdd)));
      setRow("[data-sp-acrylicprint-cutting-row]", pr.customUplift > 0);
      setText("[data-sp-acrylicprint-cutting-cost]", money(pr.customUplift));
      setRow("[data-sp-acrylicprint-artwork-row]", artworkTotal > 0);
      setText("[data-sp-acrylicprint-artwork]", money(artworkTotal));
      setText("[data-sp-acrylicprint-sell]", money(dispSellExcl));
      setText("[data-sp-acrylicprint-gst]", money(dispGst));
      setText("[data-sp-acrylicprint-total]", money(dispTotal));
      // Discount table always uses raw pricing (no change per brief).
      spLivePanel(root, function (q) { return priceAt(q).perPiece; }, qty, 1, MAX_QTY);
      // When minimum applies, override the headline per-sign price to reflect the
      // adjusted total. spRenderLead shows spExGst(perPiece) = perPiece/1.1 so
      // passing dispTotal/qty (incl-GST) yields dispSellExcl/qty (ex-GST) in the lead.
      if (minApplied) {
        var adjPerPieceIncl = round2(dispTotal / qty);
        spRenderLead(root, adjPerPieceIncl, adjPerPieceIncl, qty);
      }
      setRow("[data-sp-acrylicprint-min-notice]", minApplied);
      setRow("[data-sp-acrylicprint-min-note]", minApplied);

      var standoffLabel = standoffCount === "0" ? "None" : (standoffCount + " x Stand-Off Mounts (Silver)");
      setProp("Size", W + " × " + H + " mm");
      setProp("Thickness", t + " mm");
      setProp("Holes", holes === 0 ? "None" : String(holes));
      setProp("Stand-Off Mounts", standoffLabel);
      setProp("Shape", custom ? "Custom Shape" : "Standard (Square / Rectangle)");
      setProp("Unique Designs", String(designs));
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    // "Why?" tooltip toggle on the minimum order notice.
    var whyWrap = root.querySelector("[data-sp-acrylicprint-why]");
    var whyBtn  = root.querySelector("[data-sp-acrylicprint-why-btn]");
    var whyPanel = root.querySelector("[data-sp-acrylicprint-why-panel]");
    if (whyBtn && whyPanel) {
      whyBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        var hidden = whyPanel.hasAttribute("hidden");
        if (hidden) { whyPanel.removeAttribute("hidden"); } else { whyPanel.setAttribute("hidden", ""); }
      });
      document.addEventListener("click", function (e) {
        if (whyWrap && !whyWrap.contains(e.target)) { whyPanel.setAttribute("hidden", ""); }
      });
    }

    if (presetSel) presetSel.addEventListener("change", function () { applyPreset(); syncPresetVisibility(); recalc(); });
    [wIn, hIn].forEach(function (el) { if (el) { el.addEventListener("input", function () { syncPresetFromDims(); syncPresetVisibility(); recalc(); }); el.addEventListener("blur", syncPresetVisibility); } });
    [thickSel, holesSel, standoffSel, cuttingSel].forEach(function (el) { if (el) el.addEventListener("change", recalc); });
    spWireDesignsStepper(root, "sp-acrylicprint-designs", recalc);
    if (qIn) qIn.addEventListener("input", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = Math.min(MAX_QTY, (parseInt(qIn.value, 10) || 1) + 1); recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant.
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-acrylicprint-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var W = parseInt(wIn.value, 10);
        var H = parseInt(hIn.value, 10);
        var t = parseFloat(thickSel.value);
        var holes = parseInt(holesSel.value, 10) || 0;
        var standoffs = standoffSel ? (parseInt(standoffSel.value, 10) || 0) : 0;
        var shape = cuttingSel.value === "custom" ? "custom" : "standard";
        var designs = parseInt(designsIn.value, 10);
        var qty = parseInt(qIn.value, 10);
        if (multForThickness(t) === null || !W || W < MIN_DIM || W > MAX_DIM || !H || H < MIN_DIM || H > MAX_DIM ||
            VALID_HOLES.indexOf(holes) === -1 || !designs || designs < 1 || designs > MAX_DESIGNS || !qty || qty < 1 || qty > MAX_QTY || designs > qty) {
          recalc();
          return;
        }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-acrylicprint-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var payload = { widthMm: W, heightMm: H, thicknessMm: t, holes: holes, standoffs: standoffs, shape: shape, designs: designs, qty: qty };
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/acrylic-printing/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; });
          })
          .then(function (res) {
            if (!res.ok || !res.body || !res.body.variantId) {
              throw new Error((res.body && res.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res.body.variantId, quantity: res.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    syncPresetVisibility();
    recalc();
  });

  /* ---------- Aluminium Composite (ACM) Signs calculator ---------- */
  document.querySelectorAll("[data-sp-acm-calc]").forEach(function (root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector("[data-sp-acm-pricing]").textContent); } catch (e) { return; }
    if (!cfg) return;

    var sizeSel = root.querySelector("[data-sp-acm-size]");
    var wIn = root.querySelector("[data-sp-acm-w]");
    var hIn = root.querySelector("[data-sp-acm-h]");
    var lamSel = root.querySelector("[data-sp-acm-lamination]");
    var cutSel = root.querySelector("[data-sp-acm-cutting]");
    var designsIn = root.querySelector("[data-sp-acm-designs]");
    var qIn = root.querySelector("[data-sp-acm-qty]");
    var qMinus = root.querySelector("[data-sp-acm-qty-minus]");
    var qPlus = root.querySelector("[data-sp-acm-qty-plus]");
    var errEl = root.querySelector("[data-sp-acm-error]");
    var customRows = root.querySelectorAll("[data-sp-acm-custom-row]");
    var productRoot = root.closest("[data-sp-product]");
    var addBtn = productRoot ? productRoot.querySelector("[data-sp-add]") : null;
    var addLabel = productRoot ? productRoot.querySelector("[data-sp-add-label]") : null;

    // Aluminium Signage reuses this exact handler with a +25% price uplift and a
    // different backend endpoint. Both are read from data-attrs. The uplift is
    // applied INSIDE the same round2 unit chain as the backend so the preview
    // matches the charged price to the cent.
    //
    // Fail-closed: the endpoint MUST be "acm" or "alusign", and the uplift MUST
    // match the endpoint exactly ("acm"/absent → 1, "alusign" → 1.25). Any other
    // combination (stale/tampered/cached-mismatched markup) is treated as a
    // misconfiguration — we never price or submit, so we can never silently
    // charge ACM prices for an Aluminium (uplifted) page or vice versa.
    var rawUpliftAttr = root.getAttribute("data-sp-acm-uplift");
    var UPLIFT = parseFloat(rawUpliftAttr);
    // Absent uplift attr is the legacy ACM default (1); an invalid value is NOT.
    if (rawUpliftAttr === null || rawUpliftAttr === "") UPLIFT = 1;
    var ENDPOINT = (root.getAttribute("data-sp-acm-endpoint") || "acm").trim() || "acm";
    var MISCONFIGURED = false;
    if (ENDPOINT !== "acm" && ENDPOINT !== "alusign") MISCONFIGURED = true;
    else if (ENDPOINT === "alusign" && UPLIFT !== 1.25) MISCONFIGURED = true;
    else if (ENDPOINT === "acm" && UPLIFT !== 1) MISCONFIGURED = true;
    var MISCONFIG_MSG = "Pricing is temporarily unavailable. Please refresh the page.";

    var GST_RATE = cfg.gstRate, MIN_ORDER = cfg.minOrder, MAX_QTY = cfg.maxQty;
    var DISCOUNT_CAP_QTY = cfg.discountCapQty || 0;
    var MIN_DIM = cfg.minDim, MAX_LONG = cfg.maxLong, MAX_SHORT = cfg.maxShort, CUSTOM_KEY = cfg.customKey;
    var QTY_BREAKS = cfg.qtyBreaks, PRESETS = cfg.presets;
    var C_QTY = cfg.customQtyBreaks, C_AREAS = cfg.customAreas, C_TABLE = cfg.customTable;
    var LAMS = cfg.laminations;

    function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
    function money(n) { return "$" + n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function setText(sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; }
    function setProp(name, v) { var el = root.querySelector('[data-sp-acm-prop="' + name + '"]'); if (el) el.value = v; }

    // Locate x within an ascending axis; returns bracketing indices + fraction.
    // Clamps below the first and at/above the last breakpoint (matches server).
    function axisBracket(points, x) {
      var last = points.length - 1;
      if (x <= points[0]) return [0, 0, 0];
      if (x >= points[last]) return [last, last, 0];
      for (var i = 0; i < last; i++) {
        if (x >= points[i] && x <= points[i + 1]) {
          return [i, i + 1, (x - points[i]) / (points[i + 1] - points[i])];
        }
      }
      return [last, last, 0];
    }

    function presetUnit(row, qty) {
      var b = axisBracket(QTY_BREAKS, qty);
      return row[b[0]] + (row[b[1]] - row[b[0]]) * b[2];
    }

    function customUnit(area, qty) {
      var a = axisBracket(C_AREAS, area);
      var q = axisBracket(C_QTY, qty);
      var v00 = C_TABLE[a[0]][q[0]], v01 = C_TABLE[a[0]][q[1]];
      var v10 = C_TABLE[a[1]][q[0]], v11 = C_TABLE[a[1]][q[1]];
      var lo = v00 + (v01 - v00) * q[2];
      var hi = v10 + (v11 - v10) * q[2];
      return lo + (hi - lo) * a[2];
    }

    function isCustom() { return sizeSel.value === CUSTOM_KEY; }

    function syncCustomRows() {
      var show = isCustom();
      for (var i = 0; i < customRows.length; i++) customRows[i].style.display = show ? "" : "none";
    }

    // Returns { unit, error } — unit is inc-GST per sign (lamination + 10% board
    // uplift + Custom Shape ×1.25 applied). Designs are a flat per-order add and
    // are handled by the caller, NOT folded into the per-sign unit.
    // qOverride lets the tier ladder price arbitrary quantities without touching the input.
    function compute(qOverride) {
      var lamFactor = LAMS[lamSel.value];
      if (lamFactor === undefined) return { error: "Please choose a valid lamination option." };
      var custom = cutSel && cutSel.value === "custom";
      var shapeMult = custom ? 1.25 : 1;
      var qty = qOverride != null ? qOverride : parseInt(qIn.value, 10);
      if (!qty || qty < 1 || qty > MAX_QTY) return { error: "Quantity must be between 1 and " + MAX_QTY + " signs." };

      var baseUnit;
      if (isCustom()) {
        var W = parseInt(wIn.value, 10);
        var H = parseInt(hIn.value, 10);
        if (!W || !H) return { error: "Enter a custom width and height in millimetres." };
        if (W < MIN_DIM || H < MIN_DIM) return { error: "Each side must be at least " + MIN_DIM + " mm." };
        var long = Math.max(W, H), short = Math.min(W, H);
        if (long > MAX_LONG || short > MAX_SHORT) return { error: "Maximum custom panel size is " + MAX_LONG + " mm × " + MAX_SHORT + " mm." };
        var area = (W * H) / 1000000;
        // Discount cap: 16+ signs price at the 15-unit per-sign rate (server mirrors this).
        var qEff = DISCOUNT_CAP_QTY ? Math.min(qty, DISCOUNT_CAP_QTY) : qty;
        var interpolated = customUnit(area, qEff);
        // Min-order floor applies to baseUnit BEFORE the multipliers (as today).
        baseUnit = Math.max(MIN_ORDER / qty, interpolated);
      } else {
        var row = PRESETS[sizeSel.value];
        if (!row) return { error: "Please choose a valid sign size." };
        baseUnit = presetUnit(row, DISCOUNT_CAP_QTY ? Math.min(qty, DISCOUNT_CAP_QTY) : qty);
      }
      return { unit: round2(baseUnit * lamFactor * 1.10 * shapeMult * UPLIFT), qty: qty };
    }

    function recalc() {
      syncCustomRows();
      // Fail-closed: refuse to price/submit a misconfigured calculator.
      if (MISCONFIGURED) {
        if (errEl) { errEl.textContent = MISCONFIG_MSG; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Unavailable";
        setText("[data-sp-acm-total]", "—");
        setText("[data-sp-acm-sell]", "—");
        setText("[data-sp-acm-gst]", "—");
        spClearLead(root);
        return;
      }
      var res = compute();
      var designs = parseInt(designsIn && designsIn.value, 10) || 1;
      var qtyRaw = parseInt(qIn.value, 10);
      if (!res.error && (designs < 1 || designs > 100)) res = { error: "Number of unique designs must be between 1 and 100." };
      else if (!res.error && qtyRaw && designs > qtyRaw) res = { error: "Unique designs cannot exceed the quantity. Please increase the quantity." };
      if (res.error) {
        if (errEl) { errEl.textContent = res.error; errEl.classList.remove("hidden"); }
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Check your options";
        setText("[data-sp-acm-total]", "—");
        setText("[data-sp-acm-sell]", "—");
        setText("[data-sp-acm-gst]", "—");
        spClearLead(root);
        return;
      }
      if (errEl) errEl.classList.add("hidden");

      var qty = res.qty;
      // Cart line carries quantity = signs, so the variant is priced per sign.
      // unit is already 2dp inc-GST; add the flat (designs−1)×$10 once per order,
      // then quantize so quantity × unit-cents equals the charged total exactly.
      var designsAdd = designs > 1 ? (designs - 1) * 10 : 0;
      var total = round2(res.unit * qty + designsAdd);
      var unitCents = Math.max(1, Math.round(Math.round(total * 100) / qty));
      var chargedTotal = (unitCents * qty) / 100;
      var sellExcl = round2(chargedTotal / (1 + GST_RATE));
      var gst = round2(chargedTotal - sellExcl);

      setText("[data-sp-acm-sell]", money(sellExcl));
      setText("[data-sp-acm-gst]", money(gst));
      setText("[data-sp-acm-total]", money(chargedTotal));
      // Per-sign price steps down with qty (matrix tiers + min-order floor).
      spLivePanel(root, function (q) { var r = compute(q); return r.error ? null : Math.max(1, Math.round(r.unit * 100)) / 100; }, qty, 1, MAX_QTY);

      var sizeText = isCustom() ? (parseInt(wIn.value, 10) + " × " + parseInt(hIn.value, 10) + " mm (custom)") : (sizeSel.value + " mm");
      setProp("Size", sizeText);
      setProp("Lamination", lamSel.value);
      setProp("Shape", cutSel && cutSel.value === "custom" ? "Custom Shape" : "Standard (Square / Rectangle)");
      setProp("Unique Designs", String(designs));
      setProp("Quantity", String(qty));

      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = "Add to cart";
    }

    sizeSel.addEventListener("change", recalc);
    lamSel.addEventListener("change", recalc);
    if (cutSel) cutSel.addEventListener("change", recalc);
    [wIn, hIn, qIn].forEach(function (el) { if (el) el.addEventListener("input", recalc); });
    spWireDesignsStepper(root, "sp-acm-designs", recalc);
    if (qMinus && qIn) qMinus.addEventListener("click", function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); recalc(); });
    if (qPlus && qIn) qPlus.addEventListener("click", function () { qIn.value = Math.min(MAX_QTY, (parseInt(qIn.value, 10) || 1) + 1); recalc(); });

    // Submit → price server-side (creates a real, exactly-priced product) → add variant.
    var form = root.closest("form");
    var apiBase = (root.getAttribute("data-sp-acm-api") || "").trim().replace(/\/+$/, "");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        // Fail-closed: never submit a misconfigured calculator (wrong endpoint or
        // endpoint/uplift mismatch) — this would risk charging the wrong price.
        if (MISCONFIGURED) {
          if (errEl) { errEl.textContent = MISCONFIG_MSG; errEl.classList.remove("hidden"); }
          if (addBtn) addBtn.disabled = true;
          return;
        }
        var res = compute();
        var subDesigns = parseInt(designsIn && designsIn.value, 10) || 1;
        if (res.error || subDesigns < 1 || subDesigns > 100 || subDesigns > res.qty) { recalc(); return; }
        if (!apiBase) {
          if (errEl) { errEl.textContent = "Online pricing is temporarily unavailable. Please contact us to place this order."; errEl.classList.remove("hidden"); }
          return;
        }
        if (errEl) errEl.classList.add("hidden");
        spCartBtn(addBtn, "loading");
        var imageUrl = (root.getAttribute("data-sp-acm-image") || "").trim();
        if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
        var acmDesigns = parseInt(designsIn && designsIn.value, 10) || 1;
        var payload = { size: sizeSel.value, lamination: lamSel.value, shape: (cutSel && cutSel.value === "custom") ? "custom" : "standard", designs: acmDesigns, qty: res.qty };
        if (isCustom()) { payload.widthMm = parseInt(wIn.value, 10); payload.heightMm = parseInt(hIn.value, 10); }
        if (imageUrl) payload.imageUrl = imageUrl;
        fetch(apiBase + "/api/" + ENDPOINT + "/configure", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; });
          })
          .then(function (res2) {
            if (!res2.ok || !res2.body || !res2.body.variantId) {
              throw new Error((res2.body && res2.body.error) || "We couldn't price this configuration. Please try again.");
            }
            var props = {};
            form.querySelectorAll('[name^="properties["]').forEach(function (el) {
              var m = el.name.match(/^properties\[(.+)\]$/);
              if (m && el.value !== "") props[m[1]] = el.value;
            });
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: res2.body.variantId, quantity: res2.body.quantity || 1, properties: props })
            }).then(function (r) {
              if (!r.ok) throw new Error("We couldn't add this to your cart. Please try again.");
              return r.json();
            });
          })
          .then(function () {
            spCartBtn(addBtn, "done");
            document.dispatchEvent(new Event("cart:refresh"));
            setTimeout(function () { spCartBtn(addBtn, "idle"); }, 1600);
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = (err && err.message) || "Something went wrong. Please try again."; errEl.classList.remove("hidden"); }
            spCartBtn(addBtn, "idle");
          });
      });
    }

    recalc();
  });

  /* ---------- Product tabs: Description / Shipping / Returns ---------- */
  document.querySelectorAll("[data-sp-tabs]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-sp-tab]");
    var panels = root.querySelectorAll("[data-sp-panel]");
    function activate(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-sp-tab") === key;
        t.className = "px-4 py-3 text-sm font-bold border-b-2 " + (on ? "border-[var(--sp-blue)] text-[var(--sp-blue)]" : "border-transparent text-black");
      });
      panels.forEach(function (p) {
        p.classList.toggle("hidden", p.getAttribute("data-sp-panel") !== key);
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener("click", function () { activate(t.getAttribute("data-sp-tab")); });
    });
  });

  /* ---------- "Most popular" auto-rotating tile ---------- */
  document.querySelectorAll("[data-sp-popular]").forEach(function (root) {
    var track = root.querySelector("[data-sp-popular-track]");
    var prev = root.querySelector("[data-sp-popular-prev]");
    var next = root.querySelector("[data-sp-popular-next]");
    var dotsWrap = root.querySelector("[data-sp-popular-dots]");
    if (!track) return;
    var count = track.children.length;
    if (!count) return;
    var i = 0;
    var paused = false;

    function apply() {
      track.style.transform = "translateX(calc(-" + i + " * (100% + 5px)))";
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, n) {
          d.className = "h-1.5 rounded-full transition-all " + (n === i ? "w-4 bg-white" : "w-1.5 bg-white/45");
        });
      }
      Array.prototype.forEach.call(track.children, function (c, n) {
        if (n === i) { c.removeAttribute("aria-hidden"); c.tabIndex = 0; }
        else { c.setAttribute("aria-hidden", "true"); c.tabIndex = -1; }
      });
    }
    function go(n) { i = (n + count) % count; apply(); }

    if (dotsWrap) {
      for (var d = 0; d < count; d++) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", "Show popular sign " + (d + 1));
        (function (idx) { dot.addEventListener("click", function () { go(idx); }); })(d);
        dotsWrap.appendChild(dot);
      }
    }
    if (prev) prev.addEventListener("click", function () { go(i - 1); });
    if (next) next.addEventListener("click", function () { go(i + 1); });
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    apply();
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduce) {
      setInterval(function () { if (!paused) go(i + 1); }, 2600);
    }
  });

  /* ---------- Reviews carousel ---------- */
  document.querySelectorAll("[data-sp-reviews]").forEach(function (root) {
    var track = root.querySelector("[data-sp-reviews-track]");
    var prev = root.querySelector("[data-sp-reviews-prev]");
    var next = root.querySelector("[data-sp-reviews-next]");
    var dotsWrap = root.querySelector("[data-sp-reviews-dots]");
    if (!track) return;
    var cards = track.children;

    function perView() {
      if (window.matchMedia("(min-width: 1024px)").matches) return 3;
      if (window.matchMedia("(min-width: 640px)").matches) return 2;
      return 1;
    }
    function pages() {
      return Math.max(1, Math.ceil(cards.length / perView()));
    }
    function currentPage() {
      if (!cards.length) return 0;
      var cardW = cards[0].getBoundingClientRect().width + 24; // gap-6
      return Math.round(track.scrollLeft / (cardW * perView()));
    }
    function goTo(page) {
      var cardW = cards[0].getBoundingClientRect().width + 24;
      track.scrollTo({ left: page * cardW * perView(), behavior: "smooth" });
    }
    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      var p = pages();
      var cur = currentPage();
      for (var i = 0; i < p; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Go to testimonial page " + (i + 1));
        b.className = "h-2.5 rounded-full transition-all " +
          (i === cur ? "w-6 bg-[var(--sp-blue)]" : "w-2.5 bg-gray-300 hover:bg-gray-400");
        (function (idx) { b.addEventListener("click", function () { goTo(idx); }); })(i);
        dotsWrap.appendChild(b);
      }
    }
    function syncArrows() {
      var cur = currentPage();
      if (prev) prev.disabled = cur <= 0;
      if (next) next.disabled = cur >= pages() - 1;
    }
    function refresh() { renderDots(); syncArrows(); }

    if (prev) prev.addEventListener("click", function () { goTo(Math.max(0, currentPage() - 1)); });
    if (next) next.addEventListener("click", function () { goTo(Math.min(pages() - 1, currentPage() + 1)); });
    var raf;
    track.addEventListener("scroll", function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(refresh);
    });
    window.addEventListener("resize", refresh);
    refresh();
  });

  /* ---------- Product reviews "Load more" (4 first, then 8 at a time) ---------- */
  document.querySelectorAll("[data-sp-reviews-more]").forEach(function (btn) {
    var scope = btn.closest("section") || document;
    var list = scope.querySelector("[data-sp-reviews-list]");
    if (!list || list.querySelectorAll("[data-sp-review].hidden").length === 0) { btn.remove(); return; }
    var STEP = 8;
    btn.addEventListener("click", function () {
      var hidden = list.querySelectorAll("[data-sp-review].hidden");
      for (var i = 0; i < hidden.length && i < STEP; i++) hidden[i].classList.remove("hidden");
      if (list.querySelectorAll("[data-sp-review].hidden").length === 0) btn.remove();
    });
  });

  /* ---------- Live cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll(".sp-cart-count").forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });
  }
  function spRealCount(c) {
    var n = 0;
    (c.items || []).forEach(function (it) { n += it.quantity; });
    return n;
  }
  function refreshCart() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) updateCartCount(spRealCount(c)); })
      .catch(function () {});
  }
  refreshCart();
  document.addEventListener("cart:refresh", refreshCart);

  /* ---------- Live cart page: qty change + remove without a page reload ---------- */
  var cartRoot = document.querySelector("[data-sp-cart]");
  if (cartRoot) {
    var cartSection = cartRoot.getAttribute("data-sp-cart");
    var cartBusy = false;

    function applyCartChange(line, quantity) {
      if (cartBusy) return;
      cartBusy = true;
      cartRoot.classList.add("sp-cart-busy");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: cartSection, sections_url: window.location.pathname })
      })
        .then(function (r) { if (!r.ok) throw new Error("cart change failed"); return r.json(); })
        .then(function (cart) {
          var html = cart.sections && cart.sections[cartSection];
          if (!html) {
            // Shopify can return a successful cart mutation without the
            // requested section. Reload rather than leaving a stale line in
            // the cart, especially when the last configured item was removed.
            window.location.href = window.location.pathname;
            return;
          }
          var parsed = new DOMParser().parseFromString(html, "text/html");
          var fresh = parsed.querySelector("[data-sp-cart]");
          if (!fresh) {
            window.location.href = window.location.pathname;
            return;
          }
          cartRoot.innerHTML = fresh.innerHTML;
          // This mutation already contains the authoritative cart snapshot.
          // Avoid broadcasting cart:refresh here: third-party cart cleanup
          // listeners may assume an add event and dereference a missing item.
          updateCartCount(spRealCount(cart));
        })
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () {
          cartBusy = false;
          cartRoot.classList.remove("sp-cart-busy");
        });
    }

    // +/- steppers and the remove (trash) control are /cart/change links.
    cartRoot.addEventListener("click", function (e) {
      var link = e.target.closest("a[href*='/cart/change']");
      if (!link) return;
      e.preventDefault();
      var url = new URL(link.href, window.location.origin);
      var line = parseInt(url.searchParams.get("line"), 10);
      var quantity = parseInt(url.searchParams.get("quantity"), 10);
      if (!line || isNaN(quantity)) return;
      applyCartChange(line, quantity);
    });

    // Typing a quantity directly into the number input.
    cartRoot.addEventListener("change", function (e) {
      var input = e.target.closest("input[name='updates[]']");
      if (!input || input.type === "hidden") return;
      var li = input.closest("[data-sp-line]");
      if (!li) return;
      var line = parseInt(li.getAttribute("data-sp-line"), 10);
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      if (!line) return;
      applyCartChange(line, quantity);
    });

    // Enter inside a qty input must not full-reload; only checkout submits natively.
    cartRoot.addEventListener("submit", function (e) {
      if (!e.target || e.target.id !== "sp-cart-form") return;
      if (e.submitter && e.submitter.name === "checkout") return;
      e.preventDefault();
    });
  }

  /* ---------- Get-a-Quote calculator picker (tile grid → reveal one calc panel) ---------- */
  document.querySelectorAll("[data-sp-quote]").forEach(function (root) {
    var tiles = Array.prototype.slice.call(root.querySelectorAll("[data-sp-quote-tile]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-sp-quote-panel]"));
    if (!tiles.length) return;
    function setActive(tile, on) {
      tile.classList.remove("border-[var(--sp-blue)]", "ring-2", "ring-[var(--sp-blue)]/30", "border-gray-200");
      if (on) tile.classList.add("border-[var(--sp-blue)]", "ring-2", "ring-[var(--sp-blue)]/30");
      else tile.classList.add("border-gray-200");
      tile.setAttribute("aria-pressed", on ? "true" : "false");
    }
    function show(key, doScroll) {
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-sp-quote-panel") !== key; });
      tiles.forEach(function (t) { setActive(t, t.getAttribute("data-sp-quote-tile") === key); });
      if (doScroll) {
        var sel = (window.CSS && CSS.escape) ? CSS.escape(key) : key;
        var panel = root.querySelector('[data-sp-quote-panel="' + sel + '"]');
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    tiles.forEach(function (t) {
      t.addEventListener("click", function () { show(t.getAttribute("data-sp-quote-tile"), true); });
    });
    var def = root.querySelector("[data-sp-quote-tile][data-default]") || tiles[0];
    show(def.getAttribute("data-sp-quote-tile"), false);
  });
})();

/* ---------- Post-checkout customer artwork portal ---------- */
(function () {
  "use strict";
  var root = document.querySelector("[data-sp-artwork]");
  if (!root) return;

  var apiBase = (root.getAttribute("data-sp-artwork-api") || "").trim().replace(/\/+$/, "");
  var loadingEl = root.querySelector("[data-sp-artwork-loading]");
  var errorEl = root.querySelector("[data-sp-artwork-error]");
  var lookupForm = root.querySelector("[data-sp-artwork-lookup]");
  var orderHead = root.querySelector("[data-sp-artwork-orderhead]");
  var orderNameEl = root.querySelector("[data-sp-artwork-ordername]");
  var itemsEl = root.querySelector("[data-sp-artwork-items]");
  var doneEl = root.querySelector("[data-sp-artwork-done]");

  var ACCEPT = ".pdf,.png,.jpg,.jpeg,.svg,.ai,.eps,.tif,.tiff,application/pdf,image/png,image/jpeg,image/svg+xml,image/tiff,application/postscript";
  var MAX_BYTES = 50 * 1024 * 1024;

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function getToken() {
    try { return new URLSearchParams(window.location.search).get("token") || ""; }
    catch (e) { return ""; }
  }
  function show(el) { if (el) el.classList.remove("hidden"); }
  function hide(el) { if (el) el.classList.add("hidden"); }
  function showError(msg) { if (errorEl) { errorEl.textContent = msg; show(errorEl); } }

  function statusBadge(status) {
    if (status === "complete_uploaded") return '<span class="inline-flex items-center gap-1.5 rounded-full bg-green-50 px-3 py-1 text-xs font-bold text-green-700">Artwork uploaded</span>';
    if (status === "complete_free") return '<span class="inline-flex items-center gap-1.5 rounded-full bg-green-50 px-3 py-1 text-xs font-bold text-green-700">Free artwork selected</span>';
    return '<span class="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1 text-xs font-bold text-amber-700">Action needed</span>';
  }

  function itemHTML(it) {
    var done = it.status === "complete_uploaded" || it.status === "complete_free";
    var meta = [];
    if (it.recipientName) meta.push("For: " + esc(it.recipientName));
    meta.push("Qty " + (it.quantity || 1));
    var files = (it.files || []).map(function (f) {
      return '<a href="' + esc(apiBase) + "/api/artwork/files/" + f.id + "/download?token=" + encodeURIComponent(getToken()) + '" class="inline-flex items-center gap-1.5 text-xs font-bold text-[var(--sp-blue)] hover:underline">' + esc(f.fileName) + "</a>";
    }).join('<span class="text-gray-300">·</span>');

    var actions = done
      ? '<div class="mt-4 flex flex-wrap items-center gap-3 text-sm">' +
          '<span class="text-gray-600">' + (it.status === "complete_uploaded" ? "Your files:" : "Our team will set up free basic artwork for this item.") + '</span>' +
          (files ? '<span class="flex flex-wrap items-center gap-2">' + files + "</span>" : "") +
        "</div>"
      : '<div class="mt-4 grid gap-3 sm:grid-cols-2">' +
          '<button type="button" data-act="upload" class="inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-bold text-white shadow-lg shadow-[var(--sp-blue)]/20" style="background-image: var(--sp-grad-btn)">Upload my artwork</button>' +
          '<button type="button" data-act="free" class="inline-flex items-center justify-center gap-2 rounded-full border-2 border-gray-200 bg-white px-5 py-3 text-sm font-bold text-black transition-colors hover:border-[var(--sp-blue)] hover:text-[var(--sp-blue)]">Use free basic artwork</button>' +
        "</div>" +
        '<input type="file" data-art-file accept="' + ACCEPT + '" class="hidden">' +
        '<p class="mt-2 text-xs text-gray-500">Accepted: PDF, PNG, JPG, SVG, AI, EPS. Max 50&nbsp;MB.</p>' +
        '<p data-art-msg class="mt-2 hidden text-xs font-semibold text-red-600"></p>';

    return '<div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm" data-art-item="' + it.id + '">' +
        '<div class="flex items-start justify-between gap-4">' +
          '<div><p class="font-bold text-black">' + esc(it.productTitle) + "</p>" +
          '<p class="mt-0.5 text-sm text-gray-500">' + esc(meta.join(" · ")) + "</p></div>" +
          statusBadge(it.status) +
        "</div>" + actions +
      "</div>";
  }

  function render(order) {
    itemsEl.innerHTML = "";
    orderNameEl.textContent = order.orderName || "";
    show(orderHead);
    var pending = 0;
    order.items.forEach(function (it) {
      if (it.status === "pending") pending++;
      itemsEl.insertAdjacentHTML("beforeend", itemHTML(it));
    });
    if (order.items.length && pending === 0) show(doneEl); else hide(doneEl);
  }

  function api(path, opts) {
    return fetch(apiBase + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (!r.ok) throw new Error(body && body.error ? body.error : "Something went wrong.");
        return body;
      });
    });
  }

  function load(token) {
    return api("/api/artwork/order?token=" + encodeURIComponent(token)).then(render);
  }

  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.dataset.orig = btn.textContent; btn.textContent = label || "Working…"; btn.disabled = true; }
    else { if (btn.dataset.orig) btn.textContent = btn.dataset.orig; btn.disabled = false; }
  }

  function bindItemActions(token) {
    itemsEl.addEventListener("click", function (e) {
      var card = e.target.closest("[data-art-item]");
      if (!card) return;
      var itemId = card.getAttribute("data-art-item");
      var msg = card.querySelector("[data-art-msg]");
      var fileInput = card.querySelector("[data-art-file]");

      if (e.target.closest('[data-act="upload"]')) {
        if (fileInput) fileInput.click();
        return;
      }
      if (e.target.closest('[data-act="free"]')) {
        var freeBtn = e.target.closest('[data-act="free"]');
        if (msg) hide(msg);
        busy(freeBtn, true, "Saving…");
        api("/api/artwork/items/" + itemId + "/free", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: token })
        }).then(function () { return load(token); })
          .catch(function (err) { busy(freeBtn, false); if (msg) { msg.textContent = err.message; show(msg); } });
      }
    });

    itemsEl.addEventListener("change", function (e) {
      var fileInput = e.target.closest("[data-art-file]");
      if (!fileInput || !fileInput.files || !fileInput.files[0]) return;
      var card = e.target.closest("[data-art-item]");
      var itemId = card.getAttribute("data-art-item");
      var msg = card.querySelector("[data-art-msg]");
      var uploadBtn = card.querySelector('[data-act="upload"]');
      var file = fileInput.files[0];
      if (msg) hide(msg);
      if (file.size > MAX_BYTES) {
        if (msg) { msg.textContent = "That file is larger than 50 MB. Please send a smaller file or email it to us."; show(msg); }
        fileInput.value = "";
        return;
      }
      busy(uploadBtn, true, "Uploading…");
      api("/api/artwork/upload-url", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token })
      }).then(function (res) {
        return fetch(res.uploadURL, {
          method: "PUT",
          headers: { "Content-Type": file.type || "application/octet-stream" },
          body: file
        }).then(function (put) {
          if (!put.ok) throw new Error("Upload failed. Please try again.");
          return api("/api/artwork/items/" + itemId + "/files", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              token: token,
              uploadURL: res.uploadURL,
              fileName: file.name,
              contentType: file.type || "application/octet-stream",
              size: file.size
            })
          });
        });
      }).then(function () { return load(token); })
        .catch(function (err) {
          busy(uploadBtn, false);
          fileInput.value = "";
          if (msg) { msg.textContent = err.message; show(msg); }
        });
    });
  }

  function initLookup() {
    hide(loadingEl);
    show(lookupForm);
    var lookupMsg = lookupForm.querySelector("[data-sp-artwork-lookup-msg]");
    lookupForm.addEventListener("submit", function (e) {
      e.preventDefault();
      hide(lookupMsg);
      var orderNumber = (lookupForm.querySelector("[data-sp-artwork-order]").value || "").trim();
      var email = (lookupForm.querySelector("[data-sp-artwork-email]").value || "").trim();
      if (!orderNumber || !email) { if (lookupMsg) { lookupMsg.textContent = "Please enter both your order number and email."; show(lookupMsg); } return; }
      var btn = lookupForm.querySelector('button[type="submit"]');
      busy(btn, true, "Searching…");
      api("/api/artwork/lookup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderNumber: orderNumber, email: email })
      }).then(function (res) {
        if (res.found && res.url) { window.location.href = res.url; return; }
        busy(btn, false);
        if (lookupMsg) { lookupMsg.textContent = "We couldn't find an order with those details. Please check and try again, or email info@signportal.com.au."; show(lookupMsg); }
      }).catch(function (err) {
        busy(btn, false);
        if (lookupMsg) { lookupMsg.textContent = err.message; show(lookupMsg); }
      });
    });
  }

  if (!apiBase) { hide(loadingEl); showError("Online artwork upload is temporarily unavailable. Please email your artwork to info@signportal.com.au."); return; }

  var token = getToken();
  if (!token) { initLookup(); return; }

  bindItemActions(token);
  load(token)
    .then(function () { hide(loadingEl); })
    .catch(function (err) {
      hide(loadingEl);
      if (/find that artwork link|not found/i.test(err.message)) { initLookup(); showError("That artwork link is invalid or has expired. Look up your order below."); }
      else { showError(err.message); }
    });
})();

/* ---- Select-on-focus for numeric fields -------------------------------
   Clicking/tabbing into any number input (qty steppers, unique designs,
   width/height fields) highlights its value so typing instantly replaces
   it instead of appending. Delegated so it covers dynamically built UIs. */
(function () {
  document.addEventListener("focusin", function (e) {
    var t = e.target;
    if (t && t.tagName === "INPUT" && (t.type === "number" || t.inputMode === "numeric")) {
      // Defer so the browser's default caret placement doesn't undo the selection.
      setTimeout(function () {
        if (document.activeElement === t) { try { t.select(); } catch (err) {} }
      }, 0);
    }
  });
})();
